import React from "react";
import ScrollToBottom from "./ScrollToBottom";

const TermsOfUse = (props) => {
  const { t } = props;

  const translate = {
    sectionHeader: {
      topic1: {
        en: `Key points to note`,
        cn: `网站使用条款`,
        th: `สาระสำคัญ`,
      },
      topic2: {
        sub1: {
          en: `These Website Terms of Use apply to your use of our website www.tiffany-show.co.th, any other websites operated by us on which a link to these Website Terms of Use are found and our app (referred to collectively in these Website Terms of Use as our "websites").`,
          cn: `这些网站使用条款适用于您使用我方网站www.tiffany-show.co.th，我们运营的，可以找到这些网站使用条款链接的其他网站，和我们的应用程序（在“网站使用条款”中统称为我方“网站”）。`,
          th: `ข้อกำหนดการใช้งานเว็บไซต์นี้บังคับใช้กับท่านผู้เข้าใช้งานเว็บไซต์ www.tiffany-show.co.th ของเรา เว็บไซต์อื่นใดที่เราดำเนินการซึ่งมีการเชื่อมโยงมายังข้อกำหนดการใช้งานเว็บไซต์นี้ และแอพพลิเคชันของเรา (ในข้อกำหนดการใช้งานเว็บไซต์นี้จะเรียกรวมกันว่า “เว็บไซต์”)`,
        },
        sub2: {
          en: `If you are under the age of 18 it is important that you have your parent's or guardian's permission to use our websites or services and, as a parent or guardian, it is important that you have understood these Website Terms of Use.`,
          cn: `如果您未满 18 岁，请务必获得父母或监护人的许可才能使用本网站或服务，并且作为父母或监护人，了解这些网站使用条款也很重要。`,
          th: `หากท่านอายุต่ำกว่า 18 ปี จำเป็นที่ท่านต้องได้รับอนุญาตจากบิดามารดาหรือผู้ปกครองของท่านเพื่อเข้าใช้งานเว็บไซต์หรือบริการต่างๆ ของเรา และในฐานะบิดามารดาหรือผู้ปกครอง จำเป็นที่ท่านต้องเข้าใจข้อกำหนดการใช้งานเว็บไซต์นี้เป็นอย่างดี `,
        },
        sub3: {
          en: `By continuing to use any one of our websites, you confirm that you accept these Website Terms of Use and that you agree to comply with them.`,
          cn: `继续使用我方任意一个网站，即表示您确认接受该“网站使用条款”并同意遵守这些条款。`,
          th: `โดยการใช้งานเว็บไซต์ใดๆ ของเราอย่างต่อเนื่อง ท่านยืนยันว่า ท่านยอมรับข้อกำหนดการใช้งานเว็บไซต์นี้ และตกลงปฏิบัติตามข้อกำหนดดังกล่าว`,
        },
        sub4: {
          en: `If you do not agree to these Website Terms of Use, you must not use our websites.`,
          cn: `如果您不同意该“网站使用条款”，则不得使用我们的网站。`,
          th: `หากท่านไม่ยอมรับข้อกำหนดการใช้งานเว็บไซต์นี้ ท่านต้องไม่เข้าใช้งานเว็บไซต์ต่างๆ ของเรา`,
        },
        sub5: {
          en: `You agree that you will not misuse any of the content on any of our websites and agree to indemnify us for any loss that we suffer as a result of any and all unauthorised uses you make of any content on our websites (whether such content is owned by, or licensed to, us).`,
          cn: `您确认不会滥用本网站上的任何内容，如果因为您未经授权使用本网站内容而造成损失，您同意赔偿我方遭受的损失（无论此类内容是归我方所有，还是授权给我方）。`,
          th: `ท่านตกลงว่า ท่านจะไม่นำเนื้อหาในเว็บไซต์ใดๆ ของเราไปใช้งานในทางมิชอบ และตกลงชดใช้ค่าเสียหายใดๆ ที่เกิดขึ้นกับเราอันเป็นผลจากการที่ท่านใช้บรรดาเนื้อหาใดๆ ในเว็บไซต์ของเราโดยมิได้รับอนุญาต (ไม่ว่าเนื้อหานั้นจะเป็นกรรมสิทธิ์ของเราหรือที่เราได้รับสิทธิใช้งานก็ตาม)`,
        },
        sub6: {
          en: `We recommend that you print a copy of these Website Terms of Use for future reference.`,
          cn: `我们建议您打印“本网站使用条款”副本以供将来参考。`,
          th: `เราแนะนำให้ท่านสั่งพิมพ์สำเนาข้อกำหนดการใช้งานเว็บไซต์นี้ไว้เป็นเอกสารอ้างอิงในภายหลัง `,
        },
        sub7: {
          en: `Any changes we may make to our Website Terms of Use in the future will be posted on our websites and, where appropriate, notified to you when you next access any of our websites. It is your responsibility to ensure you are happy with any revised terms.`,
          cn: `我方将来可能对“网站使用条款”做出的更改都将发布在我方网站上，并在适当的情况下，在您下次访问我方网站时通知您。您有责任确保您对修订后的条款感到满意。`,
          th: `หากเรามีการเปลี่ยนแปลงข้อกำหนดการใช้งานเว็บไซต์นี้ในอนาคต เราจะประกาศให้ทราบบนเว็บไซต์ของเรา และแจ้งให้ท่านทราบเมื่อท่านเข้าใช้งานเว็บไซต์ใดๆ ของเราในครั้งถัดไปตามความเหมาะสม ท่านต้องรับผิดชอบตรวจสอบและอ่านรายละเอียดข้อกำหนดใดๆ ที่มีการเปลี่ยนแปลงแก้ไขดังกล่าว`,
        },
        sub8: {
          en: `In addition to these Website Terms of Use please take the time to read our Privacy Policy and Cookie Policy which will also govern your use of our websites.`,
          cn: `除了这些网站使用条款之外，请花时间阅读我们的隐私政策和 Cookie 政策，这些也是网站使用的约束政策。`,
          th: `นอกจากข้อกำหนดการใช้งานเว็บไซต์นี้แล้ว กรุณาสละเวลาอ่าน นโยบายคุ้มครองข้อมูลส่วนบุคคล และ นโยบายคุกกี้  ที่จะใช้บังคับกับการใช้งานเว็บไซต์ต่างๆ ของท่านด้วย `,
        },
      },
    },
    section1: {
      topic1: {
        en: `1. WHO ARE WE AND WHAT DO WE DO?`,
        cn: `1. 我们公司的角色和任务`,
        th: `1. เราคือใครและทำอะไร?`,
      },
      topic2: {
        sub1: {
          en: `1.1 “TIFFANY’S SHOW PATTAYA”, “MISS INTERNATIONAL QUEEN”, and “MISS TIFFANY’S UNIVERSE” (and “we”, “our”, “ours” and “us”) refers to TIFFANY’S SHOW PATTAYA CO., LTD., a venue owner, producer and ticketing operator in the arts and entertainment industry, registered with the Trade and Companies Register of Thailand under the number 0205535003687, having its registered office at 464 Moo 9, Pattaya 2nd Road, Nongprue, Banglamung, Chonburi (Thailand).`,
          cn: `1.1 “芭堤雅蒂芙尼秀”、“国际皇后小姐”和“蒂芙尼环球小姐”（以及“我们”、“我们的”和“我们的”）是指蒂芙尼秀芭堤雅有限公司，这家公司不仅是艺术和娱乐行业的场地所有人、制作人，还是票务运营商，本公司在泰国贸易和公司注册处造册登记，注册号为 0205535003687，其注册办事处位于 464 Moo 9, Pattaya 2nd Road, Nongprue, Banglamung, Chonburi (Thailand)。 `,
          th: `1.1 “ทิฟฟานี่โชว์ พัทยา”, “มิสอินเตอร์เนชั่นแนลควีน” และ “มิสทิฟฟานี่ยูนิเวิร์ส” (และ “เรา” และ “ของเรา”) หมายถึง บริษัท ทิฟฟานี่โชว์ พัทยา จำกัด เจ้าของสถานที่ ผู้อำนวยการสร้าง และผู้จัดจำหน่ายบัตรเข้าชมในธุรกิจศิลปะและให้ความบันเทิง จดทะเบียนบริษัทในประเทศไทย ทะเบียนบริษัท 0205535003687 มีสำนักงานจดทะเบียนตั้งอยู่เลขที่ 464 หมู่ 9 ถนนพัทยา 2 ตำบลหนองปรือ อำเภอบางละมุง จังหวัดชลบุรี (ประเทศไทย) `,
        },
        sub2: {
          en: `1.2 What we do. We sell theatre tickets via our websites as well as providing information and theatre related content in respect of shows performed in our theatres. We also sell theatre-related products such as coupons, vouchers, membership options and packaged theatre and dining experiences. All sales are final and non-refundable under any circumstances.`,
          cn: `1.2 我司的业务。我司通过本网站出售剧院门票，提供剧院演出节目的信息和剧院相关内容。我们还销售剧院周边产品，例如优惠券、代金券、会员资格以及剧院和餐饮套餐。所有销售均为最终销售，在任何情况下均不可退款。 `,
          th: `1.2 เราทำอะไร เราจำหน่ายบัตรเข้าชมการแสดงผ่านเว็บไซต์ของเรา และให้ข้อมูลและรายละเอียดเกี่ยวกับการแสดงที่จัดขึ้นภายในโรงละครต่างๆ ของเรา อีกทั้งยังจำหน่ายสินค้าที่เกี่ยวข้องกับโรงละคร เช่น คูปอง บัตรกำนัล สิทธิการสมัครสมาชิก และบัตรเข้าชมชุดการแสดงและรับประทานอาหาร การจำหน่ายบัตรและสินค้าทุกรายการนั้นเป็นแบบขายขาดและไม่มีการคืนเงินในทุกกรณี `,
        },
        sub3: {
          en: `1.3 How to contact us. You can contact us by emailing res@tiffany-show.co.th.`,
          cn: `1.3 如何联系我们。您可以通过发送电子邮件至 res@tiffany-show.co.th 与我们联系。`,
          th: `1.3 ช่องทางติดต่อเรา ท่านสามารถติดต่อเราได้ทางอีเมล res@tiffany-show.co.th`,
        },
        sub4: {
          en: `1.4 How we may contact you. If we have to contact you we will do so by telephone or in writing, using the telephone number, email address or postal address that you have provided to us. We will only contact you in accordance with our Privacy Policy.`,
          cn: `1.4 我们如何联系您？如果我们有必要与您联系，我们会使用您提供的电话号码、电子邮件地址或邮政地址，通过电话或书面形式与您进行联系。我们会按照 隐私政策与您联系`,
          th: `1.4 ช่องทางที่เราอาจติดต่อท่าน กรณีที่จำเป็น เราอาจติดต่อท่านทางโทรศัพท์หรือทำเป็นหนังสือโดยใช้หมายเลขโทรศัพท์ ที่อยู่อีเมล หรือที่อยู่ไปรษณีย์ที่ท่านได้ให้ไว้กับเรา เราจะติดต่อท่านโดยปฏิบัติตาม นโยบายคุ้มครองข้อมูลส่วนบุคคล ของเรา`,
        },
      },
    },
    section2: {
      topic1: {
        en: `2. WHAT IS THE PURPOSE OF THESE WEBSITE TERMS OF USE?`,
        cn: `2. “网站使用条款”的目的是什么？`,
        th: `2. จุดประสงค์ของข้อกำหนดการใช้งานเว็บไซต์นี้`,
      },
      topic2: {
        sub1: {
          en: `2.1 About these Website Terms of Use. These Website Terms of Use (together with the documents referred to below) explain the terms on which you may use our websites. Use of our websites includes (but is not limited to) accessing and browsing any of our websites. By using any of our websites, registering for an account with us or purchasing tickets and/or other theatre-related products online, you agree to comply with these Website Terms of Use.`,
          cn: `2.1 关于本网站使用简介“网站使用条款”（以及下面提到的文件）解释了您使用本网站的条款。本网站的使用包括（但不限于）访问和浏览我方任何网站。使用我方网站、注册我方帐户或在线购买门票和/或其他剧院相关产品，即表示您同意遵守“网站使用条款”。`,
          th: `2.1 เกี่ยวกับข้อกำหนดการใช้งานเว็บไซต์นี้ ข้อกำหนดการใช้งานเว็บไซต์นี้ (รวมทั้งเอกสารต่างๆ ที่ระบุไว้ด้านล่าง) ให้รายละเอียดข้อกำหนดต่างๆ ในการที่ท่านเข้าใช้งานเว็บไซต์ของเรา การใช้งานเว็บไซต์ของเรารวมถึง (แต่ไม่จำกัดเพียง) การเข้าถึงและการเรียกดูเว็บไซต์ใดๆ ของเรา โดยการใช้งานเว็บไซต์ใดๆ ของเรา การลงทะเบียนผู้ใช้งานกับเรา หรือการซื้อบัตรเข้าชม และ/หรือสินค้าอื่นที่เกี่ยวกับโรงละครผ่านช่องทางออนไลน์ ท่านตกลงปฏิบัติตามข้อกำหนดการใช้งานเว็บไซต์นี้`,
        },
        sub2: {
          en: `2.2 Revisions to these Website Terms of Use. We may revise these Website Terms of Use from time to time. Any changes we make will be posted on each of our websites and, where appropriate, notified to you when you next access our websites. It is your responsibility to ensure that you are aware of the latest version of these Website Terms of Use and your continued use of one of our websites will be deemed to be your acceptance of any revised terms.`,
          cn: `2.2 对“网站使用条款”的修订我司可能会不时修改“网站使用条款”。我司所做的任何更改都会发布在所有我司网站上，在您下次访问我司网站时，会酌情通知您。您有责任确认已经了解最新版本的“网站使用条款”，并且您使用我司网站将被视为您接受“修订后条款”。`,
          th: `2.2 การเปลี่ยนแปลงแก้ไขข้อกำหนดการใช้งานเว็บไซต์นี้ เราอาจเปลี่ยนแปลงแก้ไขข้อกำหนดการใช้งานเว็บไซต์นี้เป็นครั้งคราว หากเรามีการเปลี่ยนแปลงข้อกำหนดการใช้งานเว็บไซต์นี้ในอนาคต เราจะประกาศให้ทราบบนเว็บไซต์ของเรา และแจ้งให้ท่านทราบเมื่อท่านเข้าใช้งานเว็บไซต์ใดๆ ของเราในครั้งถัดไปตามความเหมาะสม ท่านต้องรับผิดชอบติดตามและอ่านรายละเอียดข้อกำหนดการใช้งานเว็บไซต์ฉบับล่าสุด และการที่ท่านยังใช้งานเว็บไซต์ใดๆ ต่อไปนั้นจะถือว่าท่านยอมรับข้อกำหนดการใช้งานที่มีการแก้ไขดังกล่าว `,
        },
        sub3: {
          en: `2.3 Updating our websites. We may update our websites from time to time. However, please note that any of the content on our websites may be out of date and/or inaccurate at any given time, and,`,
          cn: `2.3 更新我司网站。我们可能会不时更新我司网站。但是，请注意，网站内容可能是过时的，和/或不准确的，尽管我司会尝试纠正或更新此类内容，但这属于我司义务范围之外的事。`,
          th: `2.3 การปรับปรุงข้อมูลเว็บไซต์ของเราให้เป็นปัจจุบัน เราอาจปรับปรุงข้อมูลเว็บไซต์ของเราให้เป็นปัจจุบันเป็นครั้งคราว อย่างไรก็ดี โปรดทราบว่า บางครั้งเนื้อหาใดๆ ในเว็บไซต์ของเราอาจไม่เป็นปัจจุบันและ/หรือไม่ถูกต้อง และแม้ว่าเราจะได้พยายามแก้ไขหรือปรับปรุงเนื้อหาให้เป็นปัจจุบันแล้วก็ตาม แต่มิใช่ข้อผูกมัดใดๆ ให้เราต้องทำเช่นนั้นเสมอไป`,
        },
      },
    },
    section3: {
      topic1: {
        en: `3. WHAT OTHER TERMS APPLY TO YOUR USE OF OUR WEBSITES?`,
        cn: `3. 还有哪些其他条款适用于本网站的使用？`,
        th: `3. ข้อกำหนดอื่นๆ ที่บังคับใช้กับการใช้งานเว็บไซต์ของท่าน`,
      },
      topic2: {
        sub1: {
          en: `3.1 These Website Terms of Use refer to the following additional terms, which also apply to your use of our websites:`,
          cn: `3.1 本网站使用条款是指以下附加条款，这些条款也适用于您对我们网站的使用：`,
          th: `3.1 ข้อกำหนดการใช้งานเว็บไซต์นี้หมายถึงข้อกำหนดเพิ่มเติมต่อไปนี้ซึ่งจะบังคับใช้กับการใช้งานเว็บไซต์ของท่านด้วยเช่นกัน`,
        },
        sub2: {
          en: `(a) Our Privacy Policy which sets out the terms on which we process any personal data we collect from you, or that you provide to us.`,
          cn: `(a) 我司隐私政策，对我司处理从您那里收集的或您向我们提供个人数据的条款。`,
          th: `(ก) นโยบายคุ้มครองข้อมูลส่วนบุคคล ของเราซึ่งวางข้อกำหนดต่างๆ ในการที่เราประมวลผลข้อมูลส่วนบุคคลใดๆ ที่เราเก็บรวบรวมจากท่าน หรือที่ท่านได้ให้ไว้กับเรา`,
        },
        sub3: {
          en: `(b) Our Cookie Policy, which sets out information about the cookies on our websites.`,
          cn: `(b) 我们的 Cookie 政策，规定了我司网站上 的Cookie 信息。`,
          th: `(ข) นโยบายคุ้มครองข้อมูลส่วนบุคคล ของเราซึ่งระบุข้อมูลเกี่ยวกับคุกกี้ประเภทต่างๆ ในเว็บไซต์ของเรา`,
        },
      },
    },
    section4: {
      topic1: {
        en: `4. WHAT SHOULD YOU BE AWARE OF WHEN ACCESSING OUR WEBSITES?`,
        cn: `4. 访问我司网站时应注意什么？`,
        th: `4. สิ่งที่ท่านต้องทราบขณะที่เข้าถึงเว็บไซต์ของเรา`,
      },
      topic2: {
        sub1: {
          en: `4.1 Residency. Our websites are directed at people globally, especially for people residing in Thailand. We do not represent that content available on or through our websites is appropriate for use, or available in, other locations. We may limit the availability of our websites or any service or product described on our websites to any person or geographic area at any time.`,
          cn: `4.1 使用范围。我司网站面向全球用户，特别是泰国居民。我们不确保本网站上或通过本网站提供的内容适合在其他国家或地区使用或提供。我司可能会随时限制某人或某地使用我司网站或我司网站提供的服务或产品。 `,
          th: `4.1 ถิ่นที่อยู่ เว็บไซต์ของเราเชื่อมต่อกับผู้ใช้งานทั่วโลก โดยเฉพาะอย่างยิ่งผู้ใช้งานที่มีถิ่นที่อยู่ในประเทศไทย เราไม่รับรองว่า เนื้อหาที่มีอยู่หรือผ่านเว็บไซต์ของเรามีความเหมาะสมต่อการใช้งานหรือสามารถใช้งานได้ในพื้นที่อื่นเสมอไป เราอาจจำกัดความพร้อมใช้งานเว็บไซต์ของเราหรือบริการหรือสินค้าใดๆ ของเราที่ระบุไว้ในเว็บไซต์ของเราแก่บุคคลหรือพื้นที่ทางภูมิศาสตร์ใดก็ตามได้ทุกเมื่อ `,
        },
        sub2: {
          en: `4.2 Responsibility for internet connection. You are responsible for ensuring that all persons who access our websites through your internet connection are aware of these Website Terms of Use and other applicable terms and conditions and that they comply with them.`,
          cn: `4.2 互联网连接的责任。您有责任确保所有通过您的互联网访问我司网站的人士都了解并遵守“网站使用条款”以及其他适用的条款和条件。`,
          th: `4.2 ความรับผิดชอบในการเชื่อมต่ออินเทอร์เน็ต ท่านต้องรับผิดชอบตรวจสอบว่า ทุกคนที่เข้าถึงเว็บไซต์ของเราโดยผ่านการเชื่อมต่ออินเทอร์เน็ตของท่านทราบถึงข้อกำหนดการใช้งานเว็บไซต์นี้และข้อกำหนดและเงื่อนไขอื่นที่บังคับใช้ และปฏิบัติตามข้อกำหนดและเงื่อนไขดังกล่าวทุกประการ`,
        },
        sub3: {
          en: `4.3 Access. We do not guarantee that our websites, or any content on them, will always be available or be uninterrupted. Access to our websites is permitted on a temporary basis. We may suspend, withdraw, discontinue or change all or any part of any one of our websites without notice at any time, to allow for repairs, maintenance, the introduction of new services or otherwise. We will not be liable to you if for any reason one of our websites is unavailable at any time or for any period.`,
          cn: `4.3 访问。我们不保证本网站或相关内容始终是有效的，连续的。您可以临时访问我司网站。我们可以随时暂停、撤销、终止或更改全部或部分我司网站，且不另行通知，以便我司进行维修、维护、引入新服务或其他目的。如果我司某个网站因某些原因在某段时间或时期不可用，我们不对您承担责任。`,
          th: `4.3 การเข้าถึง เราไม่รับประกันว่า เว็บไซต์ของเราหรือเนื้อหาใดๆ ในเว็บไซต์จะพร้อมใช้งานหรือใช้งานได้ต่อเนื่องอยู่เสมอ การเข้าถึงเว็บไซต์ของเราเป็นการอนุญาตให้เข้าถึงได้เป็นการชั่วคราว เราอาจระงับ เพิกถอน ยุติ หรือเปลี่ยนแปลงเว็บไซต์หนึ่งเว็บไซต์ใดของเราทั้งหมดหรือบางส่วนได้ทุกเมื่อโดยไม่ต้องแจ้งล่วงหน้าเพื่อทำการซ่อมแซม ซ่อมบำรุง แนะนำบริการใหม่ หรือประการอื่น เราไม่ต้องรับผิดชอบต่อท่านหากเว็บไซต์หนึ่งเว็บไซต์ใดของเราไม่พร้อมใช้งานไม่ว่าเวลาใดหรือช่วงใดก็ตามไม่ว่าด้วยเหตุผลใดก็ตาม`,
        },
      },
    },
    section5: {
      topic1: {
        en: `5. REGISTERING AN ACCOUNT WITH US`,
        cn: `5. 注册我司帐户`,
        th: `5. การลงทะเบียนผู้ใช้งานกับเรา`,
      },
      topic2: {
        sub1: {
          en: `5.1 Registering with us. You may need to create an account with us to purchase tickets and/or other theatre-related products via our websites. You are responsible for the activity that occurs on your account so please keep your user name, passwords and any other pieces of information used by you as part of our security procedures, confidential. You must not disclose any of this information to any third party.`,
          cn: `5.1 注册我司账户。您可能需要在我司创建一个帐户才能通过本网站购买门票和/或其他剧院相关产品。您需要对您的帐户操作负责，因此请对您的用户名、密码以及您在我思安全程序中使用的其他信息保密。您不得向第三方透露此类信息。`,
          th: `5.1 การลงทะเบียนกับเรา ท่านอาจจำเป็นต้องสร้างบัญชีผู้ใช้งานกับเราเพื่อซื้อบัตรเข้าชม และ/หรือสินค้าอื่นที่เกี่ยวข้องกับโรงละครผ่านเว็บไซต์ของเรา ท่านต้องรับผิดชอบต่อกิจกรรมที่เกิดขึ้นจากบัญชีผู้ใช้งานของท่านเอง ดังนั้นกรุณาเก็บรักษาชื่อผู้ใช้งาน รหัสผ่าน และข้อมูลส่วนตัวอื่นใดของท่านที่ใช้ในขั้นตอนการรักษาความปลอดภัยของเราให้เป็นความลับ ท่านต้องไม่เปิดเผยข้อมูลอย่างหนึ่งอย่างใดให้บุคคลภายนอกทราบ`,
        },
        sub2: {
          en: `5.2 Restrictions on registration. To register for an account and purchase tickets and/or other theatre-related products from us:`,
          cn: `5.2 注册限制。如需注册帐户并向我司购买门票和/或其他剧院相关产品：`,
          th: `5.2 ข้อจำกัดในการลงทะเบียน ในการลงทะเบียนผู้ใช้งานและซื้อบัตรเข้าชม และ/หรือสินค้าอื่นที่เกี่ยวข้องกับโรงละครจากเรา`,
        },
        sub3: {
          en: `(a) you must be 18 or over;`,
          cn: `(a) 您必须年满 18 岁；`,
          th: `(ก) ท่านต้องมีอายุ 18 ปีบริบูรณ์ขึ้นไป`,
        },
        sub4: {
          en: `(b) you will need to provide us with certain registration information, including your date of birth.`,
          cn: `(b) 您需要向我司提供某些注册信息，包括您的出生日期。 `,
          th: `(ข) ท่านต้องให้ข้อมูลลงทะเบียนตามที่กำหนด รวมถึงวันเกิดของท่าน `,
        },
        sub5: {
          en: `You must tell us if any of your registration details change as soon as possible so that we may update our records.`,
          cn: `如果您的详细注册信息发生变化，您必须尽快告诉我们，以便我们更新记录。`,
          th: `ท่านต้องแจ้งให้เราทราบโดยเร็วที่สุดเท่าที่จะเป็นไปได้หากข้อมูลการลงทะเบียนของท่านเปลี่ยนแปลงไปเพื่อให้เราทำการปรับปรุงข้อมูลในบันทึกของเรา`,
        },
        sub6: {
          en: `5.3 Our right to restrict your access. We have the right to disable any user account at any time if, in our reasonable opinion, you have failed to comply with any of the provisions of these Website Terms of Use (or any other of our terms of which you have been made aware).`,
          cn: `5.3 我司有权利限制您的访问如果我司合理认为您未能遵守本网站使用条款（或您已了解的我司其他条款）的规定，我司有权随时禁用任何用户帐户 。`,
          th: `5.3 สิทธิของเราในการจำกัดการเข้าถึงของท่าน เรามีสิทธิปิดการใช้งานบัญชีผู้ใช้งานได้ทุกเมื่อหากเราเห็นว่า ท่านไม่ปฏิบัติตามข้อกำหนดใดๆ ในการใช้งานเว็บไซต์นี้ (หรือข้อกำหนดอื่นใดของเราที่ท่านได้ทราบอยู่ก่อนแล้ว)`,
        },
        sub7: {
          en: `5.4 One account only. Please note that you may not register more than once for an account. Multiple identities and accounts are not permitted.`,
          cn: `5.4 只能注册一个账户请注意，一个帐户不得注册多次。不允许使用多个身份和帐户。`,
          th: `5.4 หนึ่งบัญชีผู้ใช้งานเท่านั้น โปรดทราบว่า ท่านต้องไม่ลงทะเบียนผู้ใช้งานมากกว่าหนึ่งบัญชี ไม่อนุญาตให้ใช้ชื่อและบัญชีผู้ใช้งานหลายบัญชี`,
        },
        sub8: {
          en: `5.5 Your account is non-transferable. Only you may use your account. If we find that you are allowing other individuals to use your account, then we may suspend or terminate your account.`,
          cn: `5.5 您的帐户不可转让。只有您可以使用您的帐户。如果我们发现您让其他人使用您的帐户，那么我司可能会暂停或终止您的帐户。 `,
          th: `5.5 บัญชีผู้ใช้งานของท่านโอนเปลี่ยนมือไม่ได้ ท่านต้องใช้บัญชีผู้ใช้งานของท่านเองเท่านั้น หากเราพบว่า ท่านอนุญาตให้บุคคลอื่นใช้บัญชีผู้ใช้งานของท่าน เราจะทำการระงับหรือยกเลิกบัญชีผู้ใช้งานของท่าน`,
        },
        sub9: {
          en: `5.6 Keeping your account safe. You should change your password on a regular basis and never disclose it to any third party. You undertake to protect your username and password and any failure to do so shall be at your sole risk and expense. If another person accesses your account, you are solely responsible for all their actions whether or not their access was authorised by you and you hereby agree to take responsibility for and reimburse us in respect of all costs, claims, expenses and damages howsoever arising in connection with the use of, or access to, your account by any third party (save where such activity is the direct result of a failure by us or our systems).`,
          cn: `5.6 确保您帐户的安全性您应该定期更改您的密码，并且切勿将其透露给任何第三方。您承诺会保护好您的用户名和密码，如果您未能做到，那么相关风险和费用均由您自行承担。如果有其他人登录或使用您的帐户，无论他们的行为是否得到您的授权，您需要对他们的所有行为承担全部责任，您特此同意，如果因第三方登录或使用您的账户导致我司产生费用、招致索赔、发生开支、遭受损害，您需要承担相关责任并予以补偿（除非此类活动是我司或我司系统故障直接导致的结果）。 `,
          th: `5.6 การเก็บรักษาบัญชีผู้ใช้งานของท่านอย่างปลอดภัย ท่านควรเปลี่ยนรหัสผ่านของท่านเป็นประจำและไม่เปิดเผยรหัสผ่านดังกล่าวให้บุคคลอื่นทราบ ท่านรับรองว่าจะปกป้องชื่อผู้ใช้งานและรหัสผ่านของท่าน และท่านต้องรับผิดชอบความเสี่ยงและค่าใช้จ่ายต่างๆ เองหากท่านไม่ดำเนินการดังกล่าว หากบุคคลอื่นเข้าถึงบัญชีผู้ใช้งานของท่าน ท่านต้องรับผิดชอบต่อการกระทำ ทั้งปวงของบุคคลดังกล่าวแต่เพียงผู้เดียวไม่ว่าท่านจะอนุญาตให้บุคคลนั้นใช้งานบัญชีหรือไม่ก็ตาม และท่านตกลงรับผิดชอบและชดใช้ค่าธรรมเนียม ค่าสินไหม ค่าใช้จ่าย และค่าเสียหายทั้งปวงให้กับเราอันเนื่องมาจากการใช้งานหรือเข้าถึงบัญชีผู้ใช้งานของท่านโดยบุคคลภายนอก (ยกเว้นว่ากิจกรรมดังกล่าวเป็นผลที่เกิดขึ้นโดยตรงจากความบกพร่องของเราหรือระบบต่างๆ ของเราเอง) `,
        },
        sub10: {
          en: `5.7 Being polite. Any usernames chosen must not be offensive or infringe the right of a third party. Your chosen username must not be misleading, used to give opinions, or directly or indirectly used to solicit other users of our websites to use the services of any other company.`,
          cn: `5.7 有礼貌。您的用户名不得具有攻击性或侵犯第三方的权利。您的用户名不得具有误导性、用于发表意见或直接或间接用于招揽网站其他用户使用其他公司的服务。`,
          th: `5.7 การใช้งานอย่างสุภาพและมีมารยาท ชื่อผู้ใช้งานใดที่เลือกใช้ต้องไม่ล่วงล้ำหรือละเมิดสิทธิของบุคคลภายนอก ชื่อผู้ใช้งานที่ท่านเลือกใช้ต้องไม่ก่อให้เกิดความเข้าใจผิด ใช้เพื่อให้ความเห็น หรือใช้เพื่อชักชวนผู้ใช้เว็บไซต์รายอื่นของเราให้ไปใช้บริการของบริษัทอื่นใดไม่ว่าทางตรงหรือทางอ้อม`,
        },
        sub11: {
          en: `5.8 Security breach. If you know or suspect that anyone other than you knows your user name or password or you suspect that your account has been breached in any way, you must promptly notify us at res@tiffany-show.co.th.`,
          cn: `5.8 安全漏洞。如果您知道或怀疑除您之外的人知道您的用户名或密码，或者您怀疑您的帐户可能泄露，您必须立即通过 res@tiffany-show.co.th 通知我们。`,
          th: `5.8 การละเมิดความปลอดภัย หากท่านทราบหรือสงสัยว่า บุคคลใดก็ตามล่วงรู้ชื่อผู้ใช้งานหรือรหัสผ่านของท่าน หรือหากท่านสงสัยว่า มีการละเมิดบัญชีผู้ใช้งานของท่านไม่ว่าในทางใดก็ตาม ท่านต้องแจ้งให้เราทราบทันทีที่ res@tiffany-show.co.th`,
        },
      },
    },
    section6: {
      topic1: {
        en: `6. CHILDREN`,
        cn: `6. 儿童`,
        th: `6. ผู้เยาว์`,
      },
      topic2: {
        sub1: {
          en: `6.1 Website content. Some of the content on our websites may be aimed at children. There are however no age barriers to those accessing our websites. Users under 18 should only use our websites with the permission of a parent or guardian.`,
          cn: `6.1 网站内容。我司网站上的某些内容是面向儿童的。然而，对于访问我司网站的人士没有年龄限制。18 岁以下的用户只能在父母或监护人的许可下使用我司网站。 `,
          th: `6.1 เนื้อหาเว็บไซต์ เนื้อหาบางอย่างในเว็บไซต์ของเราอาจมุ่งเน้นไปที่ผู้เยาว์ แม้จะไม่มีการจำกัดอายุในการเข้าถึงเว็บไซต์ของเรา แต่ผู้ใช้งานอายุต่ำกว่า 18 ปีควรใช้งานเว็บไซต์ของเราโดยได้รับอนุญาตจากบิดามารดาหรือผู้ปกครองแล้วเท่านั้น `,
        },
        sub2: {
          en: `6.2 Parental consent. If you are under the age of 18 you may only use our websites if your parent or guardian has given you permission to do so and if you are supervised by a parent or guardian.`,
          cn: `6.2 家长同意。如果您未满 18 岁，那么您必须得到父母或监护人的允许，并在父母或监护人的监督下才可以使用我司网站。 `,
          th: `6.2 ความยินยอมของผู้ปกครอง หากท่านอายุต่ำกว่า 18 ปี ท่านต้องใช้งานเว็บไซต์ของเราหลังจากได้รับอนุญาตจากบิดามารดาหรือผู้ปกครองของท่านแล้วเท่านั้น และอยู่ภายใต้การควบคุมดูแลของบิดามารดาหรือผู้ปกครอง `,
        },
        sub3: {
          en: `6.3 Parents take note! If you have given your child permission to use our websites you are responsible for reading these Website Terms of Use and ensuring that you understand them. If you permit a child to access and view content on our websites, you are solely responsible for deciding whether or not that content is appropriate for that child. You will also be responsible for any purchases of tickets and/or other theatre-related products that may be made by the child via our websites.`,
          cn: `6.3 家长注意了！如果您允许您的孩子使用我们的网站，您有责任阅读“网站使用条款”并确保您理解这些条款。如果您允许儿童访问和查看我司网站上的内容，您将全权负责决定该内容是否适合该儿童。如果儿童通过我司网站购买门票和/或其他剧院相关产品，您需要对此负责。 `,
          th: `6.3 ผู้ปกครองโปรดทราบ! หากท่านอนุญาตให้ผู้เยาว์ใช้งานเว็บไซต์ของเรา ท่านต้องรับผิดชอบอ่านข้อกำหนดการใช้งานเว็บไซต์นี้โดยละเอียดและต้องมั่นใจว่า ท่านเข้าใจข้อกำหนดต่างๆ เป็นอย่างดี หากท่านอนุญาตให้ผู้เยาว์เข้าถึงและเรียกดูเนื้อหาในเว็บไซต์ของเรา ท่านต้องรับผิดชอบแต่เพียงผู้เดียวในการพิจารณาว่าเนื้อหานั้นเหมาะสมกับผู้เยาว์หรือไม่ อีกทั้งท่านต้องรับผิดชอบในการที่ผู้เยาว์ทำการสั่งซื้อบัตรเข้าชม และ/หรือสินค้าอื่นที่เกี่ยวข้องกับโรงละครผ่านเว็บไซต์ของเรา `,
        },
      },
    },
    section7: {
      topic1: {
        en: `7. WHAT ARE YOU PROHIBITED FROM DOING?`,
        cn: `7. 您不能做什么？`,
        th: `7. สิ่งที่ท่านห้ามทำ`,
      },
      topic2: {
        sub1: {
          en: `7.1 Your responsibilities. You may not use our websites:`,
          cn: `7.1 您的责任。您不得通过以下方式来使用我司网站：`,
          th: `7.1 ความรับผิดชอบของท่าน ท่านต้องไม่ใช้เว็บไซต์ของเรา`,
        },
        sub2: {
          en: `(a) in any way that breaches any applicable local, national or international law or regulation;`,
          cn: `(a) 可能会违反当地、国家或国际的法律或法规；`,
          th: `(ก) ในทางใดก็ตามอันเป็นการละเมิดกฎหมายหรือข้อบังคับท้องถิ่นหรือระหว่างประเทศใดๆ ที่บังคับใช้`,
        },
        sub3: {
          en: `(b) in any way that breaches these Website Terms of Use, or any other terms and conditions which apply to your use of our websites and of which you have been made aware;`,
          cn: `(b) 可能会违反本“网站使用条款”，或网站使用相关规定，或您已了解的其他条款和条件；`,
          th: `(ข) ในทางใดก็ตามอันเป็นการละเมิดข้อกำหนดการใช้งานเว็บไซต์นี้ หรือข้อกำหนดและเงื่อนไขอื่นใดที่บังคับใช้กับการใช้งานเว็บไซต์ของท่านและที่ท่านทราบอยู่แล้ว`,
        },
        sub4: {
          en: `(c) in any way that is fraudulent, or has a fraudulent purpose or effect;`,
          cn: `(c) 用欺诈方式使用网站，或带有欺诈目的或效果； `,
          th: `(ค) ในทางใดก็ตามอันเป็นการฉ้อโกงหรือมีจุดประสงค์หรือเป็นผลให้เกิดการฉ้อโกง `,
        },
        sub5: {
          en: `(d) to submit to any one of our websites anything that is unlawful, defamatory, abusive or obscene, or violates any right of any third party, including copyright or other intellectual property right;`,
          cn: `(d) 向我司网站提交非法、诽谤、辱骂或淫秽的内容，或侵犯第三方的权利，包括版权或其他知识产权；`,
          th: `(ง) เพื่อนำเข้าสู่เว็บไซต์ใดเว็บไซต์หนึ่งของเราซึ่งสิ่งใดก็ตามอันมิชอบด้วยกฎหมาย หมิ่นประมาท ดูถูกเหยียดหยาม หรือลามกอนาจาร หรือละเมิดสิทธิใดๆ ของบุคคลภายนอก รวมถึงลิขสิทธิ์หรือสิทธิในทรัพย์สินทางปัญญาอื่น`,
        },
        sub6: {
          en: `(e) to interfere or attempt to interfere with the proper working of our websites, or in a way that imposes an unreasonable or disproportionately large data load or content generation on our websites; or`,
          cn: `(e) 干扰或试图干扰我司网站的正常运行，或以在我司网站上施加不合理或不成比例的大量数据负载或内容生成的方式； 或者`,
          th: `(จ) เพื่อแทรกแซงหรือพยายามแทรกแซงการทำงานปกติของเว็บไซต์ของเรา หรือในลักษณะที่ทำให้เกิดการนำเข้าข้อมูลขนาดใหญ่หรือสร้างเนื้อหาอันไม่สมควรหรือไม่ได้สัดส่วนกับเว็บไซต์ของเรา หรือ`,
        },
        sub7: {
          en: `(f) for the purpose of harming or attempting to harm minors in any way.`,
          cn: `(f) 伤害或试图伤害未成年人。`,
          th: `(ฉ) เพื่อจุดประสงค์ในการทำอันตรายหรือพยายามทำอันตรายแก่ผู้เยาว์ไม่ว่าในลักษณะใดก็ตาม`,
        },
        sub8: {
          en: `7.2 Breaching these Website Terms of Use. If you breach these Website Terms of Use in any way, we may take such action as we consider appropriate including terminating our contract with you and/or disabling or deleting your user account. In the event of a breach by you, you acknowledge that damages may not provide a sufficient remedy to us and consequently we may seek injunctive or other equitable relief for any breach of these Website Terms of Use.`,
          cn: `7.2 违反“网站使用条款”如果您违反本网站使用条款，我司可能会采取我司认为适当的措施，包括终止与您的合同和/或禁用或删除您的用户帐户。如果您违反本“网站使用条款”，您特此确认，对于您违反本网站使用条款的行为，相关的损害赔偿可能没办法给本司提供充分的补救措施，所以我司可能会寻求禁令或其他衡平法救济。`,
          th: `7.2 การละเมิดข้อกำหนดการใช้งานเว็บไซต์นี้ หากท่านละเมิดข้อกำหนดการใช้งานเว็บไซต์นี้ไม่ว่าในทางใดก็ตาม เราอาจดำเนินการตามที่เห็นสมควรรวมถึงการบอกเลิกสัญญาที่เราทำไว้กับท่าน และ/หรือปิดการใช้งานหรือลบบัญชีผู้ใช้งานของท่าน กรณีที่ท่านละเมิดข้อกำหนด ท่านยอมรับว่า ค่าเสียหายอาจไม่เพียงพอเยียวยาความเสียหายที่เกิดขึ้นกับเรา และเราอาจขอคำสั่งคุ้มครองชั่วราวหรือการเยียวยาอื่นที่เป็นธรรมสำหรับการละเมิดข้อกำหนดการใช้งานเว็บไซต์นี้`,
        },
      },
    },
    section8: {
      topic1: {
        en: `8. CAN YOU LINK TO OUR WEBSITES?`,
        cn: `8. 您可以链接到我司网站吗？ `,
        th: `8. ช่องทางที่ท่านเชื่อมต่อมายังเว็บไซต์ของเรา `,
      },
      topic2: {
        sub1: {
          en: `8.1 How you link. You may link to our websites, provided that you do so in a way that is fair and legal and does not damage our reputation or take advantage of it.`,
          cn: `8.1 如何链接？您可以链接到我司网站，前提是您的链接方式公平合法，并且不会损害或利用我司声誉。`,
          th: `8.1 วิธีที่ท่านเชื่อมต่อ ท่านอาจเชื่อมโยงมายังเว็บไซต์ของเราภายใต้เงื่อนไขว่า ท่านดำเนินการดังกล่าวด้วยความชอบธรรมและชอบด้วยกฎหมาย และไม่ทำลายหรือแสวงประโยชน์จากชื่อเสียงของเรา`,
        },
        sub2: {
          en: `8.2 What you cannot do. You must not:`,
          cn: `8.2 您不可以做的事情. 您不得:`,
          th: `8.2 สิ่งที่ท่านทำไม่ได้ ท่านต้องไม่`,
        },
        sub3: {
          en: `(a) establish a link in such a way as to suggest any form of association, approval or endorsement on our part where none exists;`,
          cn: `(a) 建立的链接可能会暗示与我司存在关联、取得我司的批准或认可（如果不存在）；`,
          th: `(ก) สร้างลิงค์ในลักษณะที่เสนอให้มีการเข้าร่วม การอนุมัติ หรือการรับรองในนามของเราซึ่งไม่มีอยู่จริง`,
        },
        sub4: {
          en: `(b) establish a link to any of our websites on any website that is not owned by you;`,
          cn: `(b) 在不属于您的网站上建立指向我司网站的链接；`,
          th: `(ข) สร้างลิงค์ไปยังเว็บไซต์ใดๆ ของเราในเว็บไซต์ใดก็ตามที่ท่านมิได้เป็นเจ้าของ`,
        },
        sub5: {
          en: `(c) frame one of our websites on any other website or create a link to any part of one of our websites other than the home page.`,
          cn: `(c) 在任何其他网站上构建我司网站，或创建一个连接到我司主页之外的其他的页面的链接。`,
          th: `(ค) จัดวางเว็บไซต์ใดเว็บไซต์หนึ่งของเราบนเว็บไซต์อื่นใดหรือสร้างลิงค์มายังส่วนใดส่วนหนึ่งในเว็บไซต์ของเรานอกเหนือจากหน้าแรกของเว็บไซต์`,
        },
        sub6: {
          en: `8.3 Withdrawing permission. We reserve the right to withdraw linking permission without notice.`,
          cn: `8.3 撤销许可我们保留撤销链接许可的权利，恕不另行通知。`,
          th: `8.3 การเพิกถอนการอนุญาต เราสงวนสิทธิ์เพิกถอน การอนุญาตเชื่อมโยงมายังเว็บไซต์โดยไม่ต้องล่วงหน้า`,
        },
        sub7: {
          en: `8.4 Contacting us about our content. If you wish to make any use of content on our websites other than as set out above, please contact res@tiffany-show.co.th.`,
          cn: `8.4 就我司内容联系我们如果您想使用上述以外的网站内容，请联系 res@tiffany-show.co.th. `,
          th: `8.4 การติดต่อกับเราเกี่ยวกับเนื้อหาของเรา หากท่านประสงค์ใช้งานเนื้อหาใดๆ ในเว็บไซต์ของเรานอกเหนือจากที่กำหนดไว้ข้างต้น กรุณาติดต่อ res@tiffany-show.co.th`,
        },
      },
    },
    section9: {
      topic1: {
        en: `9. WHAT ABOUT THIRD-PARTY LINKS AND RESOURCES ON OUR WEBSITES?`,
        cn: `9. 关于我司网站上的第三方链接和资源`,
        th: `9. ลิงค์ภายนอกและทรัพยากรต่างๆ บนเว็บไซต์ของเรา`,
      },
      topic2: {
        sub1: {
          en: `9.1 Third party links. Our websites may provide links to and from the websites of our affiliates, business partners, advertisers or other third parties. If you follow a link to any of these websites, you understand, acknowledge and agree that all access to and use of any such third-party websites by you is at your own risk. A link to a third-party website does not imply our endorsement of that site.`,
          cn: `9.1 第三方链接。我司网站可能提供与我司附属公司、业务合作伙伴、广告商或其他第三方网站之间的链接。如果您点击此类网站的链接，即表示您理解、承认并同意您自行承担访问和使用任何此类第三方网站的风险。  第三方网站的链接并不意味着我们认可该网站。 `,
          th: `9.1 ลิงค์ภายนอก เว็บไซต์ของเราอาจมีลิงค์ไปยังและมาจากเว็บไซต์ต่างๆ ของบริษัทในเครือ พันธมิตรธุรกิจ บริษัทโฆษณาของเรา หรือบุคคลภายนอกรายอื่น หากท่านคลิกลิงค์ไปยังเว็บไซต์ใดเว็บไซต์หนึ่งเหล่านี้ ท่านเข้าใจ รับทราบ และตกลงว่า ท่านต้องยอมรับความเสี่ยงทั้งปวงจากการเข้าถึงและใช้งานเว็บไซต์ภายนอกดังกล่าวของท่านเอง ลิงค์ไปยังเว็บไซต์ภายนอกมิได้แปลว่าเราให้การรับรองเว็บไซต์นั้นแต่อย่างใด `,
        },
        sub2: {
          en: `9.2 Control over links. We have no control over the contents of third-party websites or resources and we do not accept any responsibility or liability for the content on those websites or in those resources.`,
          cn: `9.2 对链接的控制。我们无法控制第三方网站或资源的内容，并且我们对这些网站或资源中的内容不承担任何责任或义务。 `,
          th: `9.2 การควบคุมลิงค์ เราไม่มีอำนาจควบคุมเนื้อหาในเว็บไซต์หรือทรัพยากรภายนอก และเราไม่รับผิดชอบหรือรับผิดใดๆ ต่อเนื้อหาในเว็บไซต์เหล่านั้นหรือทรัพยากรในเว็บไซต์เหล่านั้น`,
        },
      },
    },
    section10: {
      topic1: {
        en: `10. WHAT ABOUT VIRUSES?`,
        cn: `10. 关于病毒`,
        th: `10. ไวรัส`,
      },
      topic2: {
        sub1: {
          en: `10.1 No guarantee. Whilst every effort is made to ensure the security of our websites and to ensure that they operate in a user friendly manner, we do not guarantee that our websites will be secure or free from bugs or viruses.`,
          cn: `10.1 不做出保证虽然我们会尽一切努力确保我司网站的安全并确保网站以用户友好的方式运行，但我们不保证我司网站一定安全，或没有错误或病毒。`,
          th: `10.1 การไม่รับประกัน แม้เราจะพยายามทุกวิถีทางเพื่อรักษาความปลอดภัยเว็บไซต์ของเราและเพื่อให้แน่ใจว่าเว็บไซต์ทำงานได้อย่างเป็นมิตรกับผู้ใช้งานก็ตาม แต่เราก็ไม่รับประกันว่า เว็บไซต์ของเราจะปลอดภัยหรือปราศจากบั๊กหรือไวรัสต่างๆ`,
        },
        sub2: {
          en: `10.2 Your responsibility. You are responsible for configuring your devices, computer programmes and platform in order to access our websites and we encourage all users of our websites to use virus protection software.`,
          cn: `10.2 您的责任。您有责任对您的设备、计算机程序和平台进行适当配置，以便访问我司网站，我们鼓励所以本网站用户使用病毒防护软件。`,
          th: `10.2 ความรับผิดชอบของท่าน ท่านต้องรับผิดชอบในการปรับตั้งอุปกรณ์ โปรแกรมคอมพิวเตอร์ และแพลตฟอร์มของท่านเพื่อเข้าถึงเว็บไซต์ของเรา และเราสนับสนุนให้ผู้ใช้งานเว็บไซต์ของเราทุกท่านใช้ซอฟต์แวร์ป้องกันไวรัส`,
        },
        sub3: {
          en: `10.3 What you cannot do. You must not:`,
          cn: `10.3 您不可以做的事情. 您不得:`,
          th: `10.3 สิ่งที่ท่านทำไม่ได้ ท่านต้องไม่`,
        },
        sub4: {
          en: `(a) knowingly transmit any data, send or upload any material that contains (or may contain) viruses, Trojan horses, worms, time-bombs, keystroke loggers, spyware, adware or any other harmful programs or similar computer code designed to adversely affect the operation of any device, software or other hardware;`,
          cn: `(a) 故意传输任何数据、发送或上传任何包含（或可能包含）病毒、特洛伊木马、蠕虫、定时炸弹、击键记录器、间谍软件、广告软件的材料，或旨在对设备、软件或其他硬件的操作产生不利影响的其他有害程序或类似计算机代码；`,
          th: `(ก) ส่งต่อข้อมูลใดๆ ส่งหรืออัปโหลดเนื้อหาใดๆ ทั้งที่รู้อยู่แล้วว่าประกอบด้วย (หรืออาจประกอบด้วย) ไวรัส ม้าโทรจัน หนอนคอมพิวเตอร์ ระเบิดเวลา เครื่องมือดักจับข้อมูล สปายแวร์ แอดแวร์ หรือโปรแกรมประสงค์ร้ายอื่นใด หรือรหัสคอมพิวเตอร์ในลักษณะเดียวกันซึ่งออกแบบมาให้ส่งผลกระทบอันไม่พึงประสงค์ต่ออุปกรณ์ ซอฟต์แวร์ หรือฮาร์ดแวร์ใดๆ `,
        },
        sub5: {
          en: `(b) attempt to gain unauthorised access to any of our websites, the server on which our websites are hosted or any server, computer, mobile device or database connected to our websites; or`,
          cn: `(b) 试图未经授权访问我司网站，我司网站使用的服务器，或我司网站所连接的服务器、计算机、移动设备或数据库； 或者`,
          th: `(ข) พยายามเข้าถึงเว็บไซต์ใดเว็บไซต์หนึ่งของเรา เซิร์ฟเวอร์อันเป็นแม่ข่ายของเว็บไซต์ของเรา หรือเซิร์ฟเวอร์ คอมพิวเตอร์ อุปกรณ์มือถือ หรือฐานข้อมูลที่เชื่อมต่อกับเว็บไซต์ของเราโดยมิได้รับอนุญาต หรือ`,
        },
        sub6: {
          en: `(c) attack any of our websites via a denial-of-service attack or a distributed denial-of service attack.`,
          cn: `(c) 通过拒绝服务攻击或分布式拒绝服务攻击来攻击我司网站。`,
          th: `(ค) โจมตีเว็บไซต์ใดเว็บไซต์หนึ่งของเราโดยใช้วิธีโจมตีเป้าหมายเดียวหรือโจมตีหลายเป้าหมายในเวลาเดียวกันเพื่อทำให้ระบบไม่สามารถให้บริการได้`,
        },
        sub7: {
          en: `10.4 Breach. By breaching the above restrictions, you may commit a criminal offence under the Computer Misuse Act. We may report any such breach to the relevant law enforcement authorities and co-operate with those authorities by disclosing your identity to them. In the event of such a breach, your right to use our websites will cease immediately.`,
          cn: `10.4 违反条款如果违反上述限制，您可能会涉嫌《计算机滥用法》规定的刑事犯罪。我们可能会向相关执法机构上报此类此类违规行为，并通过向这些机构透露您的身份来与他们合作。如果发生此类违规行为，我们会立即停止您使用我司网站的权利。`,
          th: `10.4 การละเมิด โดยการละเมิดข้อจำกัดข้างต้นนั้น ท่านอาจเข้าข่ายกระทำความผิดทางอาญาตามพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์ เราอาจรายงานเหตุละเมิดดังกล่าวให้หน่วยงานบังคับใช้กฎหมายทราบ และร่วมมือกับหน่วยงานดังกล่าวโดยเปิดเผยข้อมูลของท่าน กรณีที่เกิดเหตุละเมิด สิทธิของท่านในการใช้งานเว็บไซต์ของเราจะสิ้นสุดลงทันที`,
        },
      },
    },
    section11: {
      topic1: {
        en: `11. WHAT ABOUT OUR INTELLECTUAL PROPERTY RIGHTS?`,
        cn: `11. 有关我司的知识产权`,
        th: `11. สิทธิในทรัพย์สินทางปัญญาของเราคืออะไร?`,
      },
      topic2: {
        sub1: {
          en: `11.1 Our intellectual property rights. We are the owner or the licensee of all intellectual property rights in our websites (including the domain names www.tiffany-show.co.th, www.missinternationalqueen.com, and www.misstiffanyuniverse.org) and the material posted on these websites. This material is protected by copyright or trade mark or other intellectual property laws and treaties around the world, and these rights are owned by us or by other parties that have licensed these rights to us. All such rights are reserved.`,
          cn: `11.1 我司的知识产权。我司是我司网站（包括域名 www.tiffany-show.co.th、www.missinternationalqueen.com 和 www.misstiffanyuniverse.org）以及网站上发布的材料的所有知识产权的所有者或被许可人 。本材料受世界各地的版权或商标或其他知识产权法律和条约的保护，这些权利归我司或许可我司使用这些权利的其他方所有。所有此类权限一律保留。`,
          th: `11.1 สิทธิในทรัพย์สินทางปัญญาของเรา เราเป็นเจ้าของหรือผู้ได้รับสิทธิใช้งานทรัพย์สินทางปัญญาทั้งปวงในเว็บไซต์ของเรา (รวมถึงชื่อโดเมน www.tiffany-show.co.th,  www.missinternationalqueen.com  และ www.misstiffanyuniverse.org) และเนื้อหาที่เผยแพร่บนเว็บไซต์เหล่านี้ เนื้อหาดังกล่าวได้รับความคุ้มครองภายใต้กฎหมายและสนธิสัญญาลิขสิทธิ์หรือเครื่องหมายการค้าหรือทรัพย์สินทางปัญญาอื่นต่างๆ ทั่วโลก และสิทธิเหล่านี้เป็นกรรมสิทธิ์ของเราหรือบุคคลอื่นที่ได้ให้สิทธิใช้งานแก่เรา สิทธิดังกล่าวทั้งปวงนั้นได้รับการสงวนไว้ทุกประการ`,
        },
        sub2: {
          en: `11.2 What you can do. You may print off one copy, and may download extracts, of any material(s) from our websites for your personal information and shopping purposes and you may draw the attention of others within your organisation to content posted on our websites.`,
          cn: `11.2 您可以做什么？可以打印一份副本，也可以从我司网站下载任何材料摘录，用于您的个人信息和购物目的，并且您可以提请组织内其他人注意我司网站上发布的内容。`,
          th: `11.2 สิ่งที่ท่านทำได้ ท่านอาจสั่งพิมพ์สำเนา และดาวน์โหลดข้อความบางส่วนของเนื้อหาใดๆ จากเว็บไซต์ของเราเพื่อเป็นข้อมูลส่วนบุคคลของท่านและการซื้อสินค้า และท่านอาจทำให้บุคคลอื่นภายในองค์กรของท่านให้ความสนใจเนื้อหาที่เผยแพร่บนเว็บไซต์ของเราได้`,
        },
        sub3: {
          en: `11.3 What you may not do. You must not:`,
          cn: `11.3 您不可以做什么？ 你不能：`,
          th: `11.3 สิ่งที่ท่านทำไม่ได้ ท่านต้องไม่`,
        },
        sub4: {
          en: `(a) modify the paper or digital copies of any materials you have printed off or downloaded in any way;`,
          cn: `(a) 以任何方式修改您打印或下载的材料，包括纸质或数字副本；`,
          th: `(ก) แก้ไขสำเนาฉบับพิมพ์หรือดิจิทัลของเนื้อหาใดๆ ที่ท่านได้สั่งพิมพ์หรือดาวน์โหลดไม่ว่าในทางใดก็ตาม`,
        },
        sub5: {
          en: `(b) use any illustrations, photographs, video or audio sequences or any graphics separately from any accompanying text;`,
          cn: `(b) 脱离随附文本使用插图、照片、视频或音频序列或图形；`,
          th: `(ข) ใช้ภาพประกอบ รูปถ่าย วิดีโอ หรือเสียงใดๆ หรือกราฟิกใดๆ ที่แยกจากข้อความประกอบใดๆ`,
        },
        sub6: {
          en: `(c) distribute, publish, transmit or create derivative works from or exploit the content or materials (including illustrations, photographs, video or audio sequences or any graphics) on our websites; or`,
          cn: `(c) 分发、出版、传输或利用我司网站上的内容或材料（包括插图、照片、视频或音频序列或任何图形）创建衍生作品； 或者`,
          th: `(ค) แจกจ่าย เผยแพร่ ส่งต่อ หรือสร้างงานสร้างสรรค์ต่อเนื่องจากหรือใช้ประโยชน์จากเนื้อหาหรือข้อมูลต่างๆ (รวมถึงภาพประกอบ รูปถ่าย วิดีโอ หรือเสียง หรือกราฟิกใดๆ) ในเว็บไซต์ของเรา `,
        },
        sub7: {
          en: `(d) use any part of the content on our websites for commercial purposes without obtaining a license to do so from us or our licensors.`,
          cn: `(d) 在未获得我司或我司许可方许可的情况下将我司网站上的内容用于商业目的。`,
          th: `(ง) ใช้เนื้อหาส่วนใดก็ตามในเว็บไซต์ของเราเพื่อจุดประสงค์ในเชิงพาณิชย์โดยมิได้รับสิทธิใช้งานจากเราหรือจากผู้ให้สิทธิใช้งานของเรา`,
        },
        sub8: {
          en: `11.4 Our status. Our status (and that of any identified contributors) as the authors of content on our websites must always be acknowledged.`,
          cn: `11.4 我司情况我司（以及其他确认内容贡献者）是我司网站内容的作者，这一点是始终确定事实。`,
          th: `11.4 สถานะของเรา ต้องยอมรับสถานะของเรา (และของผู้สนับสนุนที่ระบุไว้) ในฐานะผู้จัดทำเนื้อหาในเว็บไซต์ของเราตลอดเวลา`,
        },
        sub9: {
          en: `11.5 Breach. If you use any of the content on our websites in breach of these Website Terms of Use, your right to use our websites will cease immediately and you must, at our option, return or destroy any copies of the materials you have made.`,
          cn: `11.5 违反条款如果您在违反本网站使用条款的情况下使用我司网站上的内容，我们会立即终止您使用我司网站的权利，并且您必须根据我们的要求返还或销毁您制作的材料副本。`,
          th: `11.5 การละเมิด หากท่านใช้เนื้อหาใดๆ ในเว็บไซต์ของเราในลักษณะที่เป็นการละเมิดข้อกำหนดการใช้งานเว็บไซต์นี้ สิทธิของท่านในการใช้งานเว็บไซต์ของเราจะสิ้นสุดลงทันที และท่านต้องส่งคืนหรือทำลายสำเนาเนื้อหาใดๆ ที่ท่านได้ทำขึ้นตามที่เราเห็นสมควร`,
        },
        sub10: {
          en: `11.6 Indemnity. You agree to indemnify us for any loss that we suffer as a result of any and all unauthorised uses you make of any content or materials on any of our websites.`,
          cn: `11.6 赔偿.对于因您未经授权使用我司网站内容或材料而导致我司遭受的损失，您必须进行赔偿。`,
          th: `11.6 การชดใช้ค่าเสียหาย ท่านตกลงชดใช้ค่าเสียหายให้กับเรากรณีที่เราประสบกับความเสียหายใดๆ อันเป็นผลจากการที่ท่านใช้เนื้อหาหรือข้อมูลใดๆ ในเว็บไซต์หนึ่งเว็บไซต์ใดของเราโดยมิได้รับอนุญาต`,
        },
      },
    },
    section12: {
      topic1: {
        en: `12. CAN YOU RELY ON INFORMATION ON OUR WEBSITES?`,
        cn: `12. 您可以信赖我司网站上的信息吗？`,
        th: `12. ท่านสามารถเชื่อถือข้อมูลในเว็บไซต์ของเราได้หรือไม่?`,
      },
      topic2: {
        sub1: {
          en: `12.1 General information. The content on our websites is provided for general information only. It is not intended to amount to advice on which you should rely and we disclaim any liability and responsibility for such reliance. Please think carefully before you decide to register for an account with us or purchase tickets and/or other theatre-related products via our websites. Any decisions you make based on information contained on our websites are your sole responsibility.`,
          cn: `12.1 一般信息。我司网站上的内容仅供一般信息参考。这些内容并非是您一定要采纳的建议，对于相关建议的可靠性，我司不承担任何责任和义务。在您决定注册我司帐户或通过我司网站购买门票和/或其他剧院相关产品之前，请仔细考虑。您根据我司网站上的信息做出的任何决定均由您自行承担责任。`,
          th: `12.1 ข้อมูลทั่วไป เนื้อหาในเว็บไซต์ของเราเป็นเพียงข้อมูลทั่วไปเท่านั้น มิได้มีจุดประสงค์เพื่อชี้แนะให้ท่านต้องเชื่อถือข้อมูลดังกล่าวแต่อย่างใด และเราปฏิเสธความรับผิดและความรับผิดชอบใดๆ ในการเชื่อถือข้อมูลดังกล่าว กรุณาพิจารณาให้รอบคอบก่อนลงทะเบียนผู้ใช้งานกับเราหรือซื้อบัตรเข้าชมและ/หรือสินค้าอื่นที่เกี่ยวกับโรงละครผ่านเว็บไซต์ของเรา การตัดสินใจใดๆ ของท่านโดยอาศัยเนื้อหาในเว็บไซต์ของเราถือเป็นความรับผิดชอบของท่านแต่เพียงผู้เดียว`,
        },
        sub2: {
          en: `12.2 No warranty. Although we make reasonable efforts to update the information on our websites, we make no representations, warranties or guarantees, whether express or implied, that the content on our websites is accurate, complete, up-to-date or free from errors or omissions.`,
          cn: `12.2 不提供担保尽管我们尽合理努力更新网站上的信息，但我们不以明示或暗示的方式作出任何声明、保证或担保，我司网站上的内容一定是准确的、完整的、最新的或不存在错误或遗漏的。`,
          th: `12.2 การไม่รับประกัน แม้ว่าเราจะพยายามตามสมควรเพื่อปรับปรุงข้อมูลในเว็บไซต์ของเราให้เป็นปัจจุบันแล้วก็ตาม แต่เรามิได้รับรอง รับประกัน หรือยืนยันไม่ว่าโดยชัดแจ้งหรือโดยปริยายว่า เนื้อหาในเว็บไซต์ของเรานั้นถูกต้อง ครบถ้วน เป็นปัจจุบัน หรือปราศจากข้อผิดพลาดหรือการตกหล่นใดๆ`,
        },
      },
    },
    section13: {
      topic1: {
        en: `13. HOW DO WE LIMIT OUR LIABILITY?`,
        cn: `13. 我们如何限制我司责任？`,
        th: `13. เราจำกัดความรับผิดอย่างไรบ้าง?`,
      },
      topic2: {
        sub1: {
          en: `13.1 What we cannot do. Nothing in these Website Terms of Use excludes or limits our liability for death or personal injury arising from our negligence, or our fraud or fraudulent misrepresentation, or any other liability that cannot be excluded or limited by applicable law.`,
          cn: `13.1 我司不能做什么？ 本网站使用条款中的任何内容均不排除或限制我司承担因我司疏忽、欺诈或欺诈性失实陈述而导致的死亡或人身伤害所引起的责任，或适用法律不能排除或限制的其他责任。`,
          th: `13.1 สิ่งที่เราทำไม่ได้ ไม่มีข้อความใดในข้อกำหนดการใช้งานเว็บไซต์นี้ที่ยกเว้นหรือจำกัดความรับผิดของเราต่อการเสียชีวิตหรือบาดเจ็บของบุคคลอันเนื่องมาจากความประมาทเลินเล่อของเรา หรือการฉ้อโกงหรือการให้ข้อมูลอันเป็นเท็จโดยมีเจตนาทุจริตของเรา หรือความรับผิดอื่นใดที่ไม่อาจยกเว้นหรือจำกัดได้ตามกฎหมายที่บังคับใช้`,
        },
        sub2: {
          en: `13.2 What we can do. To the extent permitted by applicable law, we exclude all conditions, warranties, representations or other terms which may apply to your use of our websites or any content on our websites, whether express or implied.`,
          cn: `13.2 我们能做什么。 在适用法律允许的范围内，我们排除所有可能适用您对我司网站或网站内容使用的条件、保证、陈述或其他条款，无论是明示还是暗示。 `,
          th: `13.2 สิ่งที่เราทำได้ ตราบเท่าที่กฎหมายอนุญาตให้กระทำได้ เราอาจยกเว้นเงื่อนไข การรับประกัน การรับรอง หรือข้อกำหนดอื่นทั้งปวงที่บังคับใช้กับการใช้งานเว็บไซต์ของท่าน หรือเนื้อหาใดๆ ในเว็บไซต์ของเราไม่ว่าโดยชัดแจ้งหรือโดยปริยาย `,
        },
        sub3: {
          en: `13.3 What we are not liable for. To the extent permitted by applicable law, we, together with our employees, officers, directors, shareholders and agents, will not be liable to you for any loss or damage, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, whether direct, indirect or consequential even if foreseeable, arising under or in connection with:`,
          cn: `13.3 哪些不属于我司责任范围？在适用法律允许的范围内，我司以及我司员工、管理人员、董事、股东和代理人不对您因以下原因或与之相关的损失或损害承担责任，无论是合同、侵权（包括疏忽）、违反法定义务、 或以其他方式，无论是直接的、间接的还是后果性的，即使是可预见的： `,
          th: `13.3 สิ่งที่เราไม่รับผิด ตราบเท่าที่กฎหมายอนุญาตให้กระทำได้ เราพร้อมทั้งพนักงาน เจ้าหน้าที่ กรรมการ ผู้ถือหุ้น และตัวแทนของเราไม่ต้องรับผิดต่อท่านสำหรับความสูญเสียหรือความเสียหายใดๆ ไม่ว่าตามสัญญา การละเมิด (รวมถึงความประมาทเลินเล่อ) การละเมิดหน้าที่ตามกฎหมาย หรือประการอื่น ไม่ว่าทางตรง ทางอ้อม หรือสืบเนื่องแม้จะสามารถคาดการณ์ได้ล่วงหน้าก็ตามซึ่งอยู่ภายใต้หรือเกี่ยวข้องกับ `,
        },
        sub4: {
          en: `(a) the use, or inability to use, our websites;`,
          cn: `(a) 使用或无法使用我司网站；`,
          th: `(ก) การใช้งานหรือไม่สามารถใช้งานเว็บไซต์ของเรา`,
        },
        sub5: {
          en: `(b) the performance, functioning or display of our websites;`,
          cn: `(b) 我司网站的性能、功能或显示；`,
          th: `(ข) ประสิทธิภาพ การทำงาน หรือการแสดงผลของเว็บไซต์ของเรา`,
        },
        sub6: {
          en: `(c) use of or reliance on any content or materials displayed on our websites, any websites linked to our websites or any materials posted on them;`,
          cn: `(c) 使用或参考我司网站上的内容或材料、有我司网站链接的网站或其上发布的材料；`,
          th: `(ค) การใช้หรือการเชื่อถือเนื้อหาหรือข้อมูลใดๆ ที่แสดงบนเว็บไซต์ของเรา เว็บไซต์ใดๆ ที่เชื่อมโยงมายังเว็บไซต์ของเรา หรือเนื้อหาใดๆ ที่เผยแพร่บนเว็บไซต์ของเรา`,
        },
        sub7: {
          en: `(d) any acts, omissions and/or conduct of any third-party users, advertisers and/or sponsors that display content or links on our websites;`,
          cn: `(d) 在我司网站上发布内容或链接的第三方用户、广告商和/或赞助商的任何作为、不作为和/或行为；`,
          th: `(ง) การกระทำ ละเว้นการกระทำ และ/หรือการปฏิบัติของผู้ใช้ภายนอก ผู้โฆษณา และ/หรือผู้สนับสนุนใดๆ ที่แสดงเนื้อหาหรือลิงค์ต่างๆ บนเว็บไซต์ของเรา`,
        },
        sub8: {
          en: `including, without limitation, any liability for any loss of income or revenue, loss of business or business opportunity, loss of profits or contracts, loss of anticipated savings, loss of data, loss of goodwill or reputation and/or any other loss or damage of any kind.`,
          cn: `包括但不限于收入或所得损失、业务或商业机会损失、利润或合同损失、预期储蓄损失、数据丢失、商誉或声誉损失和/或任何其他损失或损坏责任。`,
          th: `รวมถึงแต่ไม่จำกัดเพียงความรับผิดใดๆ ต่อการสูญเสียรายได้หรือรายรับ การสูญเสียธุรกิจหรือโอกาสทางธุรกิจ การสูญเสียกำไรหรือสัญญา การสูญเสียเงินสะสมที่คาดไว้ ข้อมูลสูญหาย การสูญเสียค่าความนิยม หรือชื่อเสียง และ/หรือความสูญเสียหรือความเสียหายอื่นใดทุกรูปแบบ`,
        },
        sub9: {
          en: `13.4 Home use. Please note that we only provide our websites for personal, non-commercial use. We will not be liable for any loss or damage caused by a virus, distributed denial-of-service attack, or other technologically harmful material that may infect your computer equipment, computer programs, mobile device, data or other proprietary material due to your use of our websites or to you downloading any content on our websites, or on any website linked to them.`,
          cn: `13.4 家庭使用。请注意，我司网站仅供个人做非商业目的使用。对于病毒、分布式拒绝服务攻击造成的，或因其他可能感染您的计算机设备、计算机程序、移动设备、数据的有害技术材料，或因您使用我司网站而产生的其他专有材料，或因您在我司网站或与其链接网站上下载内容而产生的专有材料而任何损失或损害，我司不承担责任。`,
          th: `13.4 การใช้งานในเคหสถาน โปรดทราบว่า เราจัดทำเว็บไซต์ของเราเพื่อการใช้งานเป็นการส่วนตัวและมิใช่เชิงพาณิชย์เท่านั้น เราไม่ต้องรับผิดต่อความสูญเสียหรือความเสียหายใดๆ ที่เกิดจากไวรัส โจมตีหลายเป้าหมายในเวลาเดียวกันเพื่อทำให้ระบบไม่สามารถให้บริการได้ หรือข้อมูลอื่นที่เป็นอันตรายทางเทคโนโลยีที่อาจเกิดขึ้นกับอุปกรณ์คอมพิวเตอร์ โปรแกรมคอมพิวเตอร์ อุปกรณ์มือถือ ข้อมูลหรือเนื้อหาอื่นที่มีกรรมสิทธิ์อันเนื่องมาจากการใช้งานเว็บไซต์ของท่านหรือการที่ท่านดาวน์โหลดเนื้อหาใดๆ ในเว็บไซต์ของเรา หรือเว็บไซต์ใดๆ ที่เชื่อมโยงมายังเว็บไซต์ของเรา`,
        },
        sub10: {
          en: `13.5 Other limitations of liability. Different limitations and exclusions of liability will apply to liability arising as a result of the purchase by you of tickets and/or other theatre-related products. Please note that all sales are final and non-refundable under any circumstances.`,
          cn: `13.5 其他责任限制。不同的责任限制和排除适用于因您购买门票和/或其他剧院相关产品而产生的责任。请注意，所有销售均为最终销售，在任何情况下均不可退款。 `,
          th: `13.5 การจำกัดความรับผิดอื่น การจำกัดและการยกเว้นความรับผิดอื่นจะใช้กับความรับผิดอันเป็นผลจากการที่ท่านซื้อบัตรเข้าชมและ/หรือสินค้าอื่นที่เกี่ยวกับโรงละคร โปรดทราบว่า การจำหน่ายบัตรและสินค้าทุกรายการนั้นเป็นแบบขายขาดและไม่มีการคืนเงินในทุกกรณี `,
        },
      },
    },
    section14: {
      topic1: {
        en: `14. WHICH LAW APPLIES TO THESE WEBSITE TERMS OF USE?`,
        cn: `14. “网站使用条款”适用哪些法律？`,
        th: `14. กฎหมายใดที่ใช้บังคับข้อกำหนดการใช้งานเว็บไซต์นี้?`,
      },
      topic2: {
        sub1: {
          en: `These Website Terms of Use, their subject matter and their formation, are governed by Thai law. You and we both agree that the courts of Thailand will have exclusive jurisdiction over any disputes arising under these Website Terms of Use.`,
          cn: `“网站使用条款”、其主题及其编纂均受泰国法律管辖。您和我司均同意泰国法院对本网站使用条款引起的争议拥有专属管辖权。`,
          th: `ข้อกำหนดการใช้งานเว็บไซต์นี้ สาระสำคัญ และการจัดทำข้อกำหนดบังคับใช้ตามกฎหมายไทย ทั้งท่านและเราตกลงว่า ศาลยุติธรรมของไทยต้องมีเขตอำนาจเด็ดขาดในการตัดสินข้อพิพาทใดๆ ที่เกิดขึ้นภายใต้ข้อกำหนดการใช้งานเว็บไซต์นี้ `,
        },
      },
    },
    section15: {
      topic1: {
        en: `15. THIRD PARTIES`,
        cn: `15. 第三方`,
        th: `15. บุคคลภายนอก`,
      },
      topic2: {
        sub1: {
          en: `Nothing in these terms gives any third party any benefits under the Contracts (Rights of Third Parties) Act. This does not affect any of your rights.`,
          cn: `任何条款内容均不会根据《合同（第三方权利）法》给第三方带来利益。这不会影响您的权利。`,
          th: `ไม่มีข้อความในที่นี้ที่ให้สิทธิประโยชน์ใดๆ ตามสัญญาแก่บุคคลภายนอก (สิทธิของบุคคลภายนอก) และไม่มีสิ่งใดกระทบสิทธิใดๆ ของท่าน`,
        },
      },
    },
    section16: {
      topic1: {
        en: `16. WAIVERS`,
        cn: `16. 权利放弃`,
        th: `16. การสละสิทธิ์`,
      },
      topic2: {
        sub1: {
          en: `No failure or delay by us in exercising any right or remedy under or in relation to these terms will operate as a waiver of the same.`,
          cn: `我们未能或延迟行使条款项下或与条款相关权利或补救措施，并不构成我司对该权利或补救措施的放弃。`,
          th: `การที่เราไม่ใช้หรือเกิดความล่าช้าในการใช้สิทธิหรือการเยียวยาความเสียหายใดๆ ภายใต้หรือเกี่ยวข้องกับข้อกำหนดนี้ต้องไม่ถือเป็นการสละสิทธิ์หรือการเยียวยาความเสียหายนั้นแต่อย่างใด`,
        },
      },
    },
    section17: {
      topic1: {
        en: `17. SEVERANCE`,
        cn: `17. 分割性`,
        th: `17. การแยกออกจากกันได้`,
      },
      topic2: {
        sub1: {
          en: `If anyone (or more) of the terms in these Website Terms of Use is held by a court to be invalid, void, unlawful or unenforceable, it shall not affect the enforceability of the remaining terms.`,
          cn: `如果本网站使用条款中的任何一条（或多条）条款被法院判定为无效、作废、非法或不可执行，则不会影响其余条款的可执行性。`,
          th: `หากศาลยุติธรรมตัดสินให้ข้อกำหนดข้อหนึ่งข้อใด (หรือหลายข้อ) ในข้อกำหนดการใช้งานเว็บไซต์นี้ตกเป็นโมฆะ สิ้นผล มิชอบด้วยกฎหมาย หรือบังคับใช้ไม่ได้ ข้อกำหนดนั้นต้องไม่กระทบกับความสามารถบังคับใช้ได้ของข้อกำหนดที่เหลือ`,
        },
      },
    },
  };

  const handlePressScrollToBottom = () => {
    const element = document.getElementById("end-page-terms-of-use");
    element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="terms-of-use">
      <div className="containter">
        <div className="title">
          <h1>Terms of Use</h1>
        </div>
        <div className="section">
          <h3>{t(translate.sectionHeader.topic1)}</h3>
          <ul>
            <li>{t(translate.sectionHeader.topic2.sub1)}</li>
            <li>{t(translate.sectionHeader.topic2.sub2)}</li>
            <li>{t(translate.sectionHeader.topic2.sub3)}</li>
            <li>{t(translate.sectionHeader.topic2.sub4)}</li>
            <li>{t(translate.sectionHeader.topic2.sub5)}</li>
            <li>{t(translate.sectionHeader.topic2.sub6)}</li>
            <li>{t(translate.sectionHeader.topic2.sub7)}</li>
            <li>{t(translate.sectionHeader.topic2.sub8)}</li>
          </ul>
        </div>
        <div className="section">
          <h3>{t(translate.section1.topic1)}</h3>
          <p>{t(translate.section1.topic2.sub1)}</p>
          <p>{t(translate.section1.topic2.sub2)}</p>
          <p>{t(translate.section1.topic2.sub3)}</p>
          <p>{t(translate.section1.topic2.sub4)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section2.topic1)}</h3>
          <p>{t(translate.section2.topic2.sub1)}</p>
          <p>{t(translate.section2.topic2.sub2)}</p>
          <p>{t(translate.section2.topic2.sub3)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section3.topic1)}</h3>
          <p>{t(translate.section3.topic2.sub1)}</p>
          <p>{t(translate.section3.topic2.sub2)}</p>
          <p>{t(translate.section3.topic2.sub3)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section4.topic1)}</h3>
          <p>{t(translate.section4.topic2.sub1)}</p>
          <p>{t(translate.section4.topic2.sub2)}</p>
          <p>{t(translate.section4.topic2.sub3)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section5.topic1)}</h3>
          <p>{t(translate.section5.topic2.sub1)}</p>
          <p>{t(translate.section5.topic2.sub2)}</p>
          <p>{t(translate.section5.topic2.sub3)}</p>
          <p>{t(translate.section5.topic2.sub4)}</p>
          <p>{t(translate.section5.topic2.sub5)}</p>
          <p>{t(translate.section5.topic2.sub6)}</p>
          <p>{t(translate.section5.topic2.sub7)}</p>
          <p>{t(translate.section5.topic2.sub8)}</p>
          <p>{t(translate.section5.topic2.sub9)}</p>
          <p>{t(translate.section5.topic2.sub10)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section6.topic1)}</h3>
          <p>{t(translate.section6.topic2.sub1)}</p>
          <p>{t(translate.section6.topic2.sub2)}</p>
          <p>{t(translate.section6.topic2.sub3)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section7.topic1)}</h3>
          <p>{t(translate.section7.topic2.sub1)}</p>
          <p>{t(translate.section7.topic2.sub2)}</p>
          <p>{t(translate.section7.topic2.sub3)}</p>
          <p>{t(translate.section7.topic2.sub4)}</p>
          <p>{t(translate.section7.topic2.sub5)}</p>
          <p>{t(translate.section7.topic2.sub6)}</p>
          <p>{t(translate.section7.topic2.sub7)}</p>
          <p>{t(translate.section7.topic2.sub8)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section8.topic1)}</h3>
          <p>{t(translate.section8.topic2.sub1)}</p>
          <p>{t(translate.section8.topic2.sub2)}</p>
          <p>{t(translate.section8.topic2.sub3)}</p>
          <p>{t(translate.section8.topic2.sub4)}</p>
          <p>{t(translate.section8.topic2.sub5)}</p>
          <p>{t(translate.section8.topic2.sub6)}</p>
          <p>{t(translate.section8.topic2.sub7)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section9.topic1)}</h3>
          <p>{t(translate.section9.topic2.sub1)}</p>
          <p>{t(translate.section9.topic2.sub2)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section10.topic1)}</h3>
          <p>{t(translate.section10.topic2.sub1)}</p>
          <p>{t(translate.section10.topic2.sub2)}</p>
          <p>{t(translate.section10.topic2.sub3)}</p>
          <p>{t(translate.section10.topic2.sub4)}</p>
          <p>{t(translate.section10.topic2.sub5)}</p>
          <p>{t(translate.section10.topic2.sub6)}</p>
          <p>{t(translate.section10.topic2.sub7)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section11.topic1)}</h3>
          <p>{t(translate.section11.topic2.sub1)}</p>
          <p>{t(translate.section11.topic2.sub2)}</p>
          <p>{t(translate.section11.topic2.sub3)}</p>
          <p>{t(translate.section11.topic2.sub4)}</p>
          <p>{t(translate.section11.topic2.sub5)}</p>
          <p>{t(translate.section11.topic2.sub6)}</p>
          <p>{t(translate.section11.topic2.sub7)}</p>
          <p>{t(translate.section11.topic2.sub8)}</p>
          <p>{t(translate.section11.topic2.sub9)}</p>
          <p>{t(translate.section11.topic2.sub10)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section12.topic1)}</h3>
          <p>{t(translate.section12.topic2.sub1)}</p>
          <p>{t(translate.section12.topic2.sub2)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section13.topic1)}</h3>
          <p>{t(translate.section13.topic2.sub1)}</p>
          <p>{t(translate.section13.topic2.sub2)}</p>
          <p>{t(translate.section13.topic2.sub3)}</p>
          <p>{t(translate.section13.topic2.sub4)}</p>
          <p>{t(translate.section13.topic2.sub5)}</p>
          <p>{t(translate.section13.topic2.sub6)}</p>
          <p>{t(translate.section13.topic2.sub7)}</p>
          <p>{t(translate.section13.topic2.sub8)}</p>
          <p>{t(translate.section13.topic2.sub9)}</p>
          <p>{t(translate.section13.topic2.sub10)}</p>
        </div>
        <div id="end-page-terms-of-use" className="section">
          <h3>{t(translate.section14.topic1)}</h3>
          <p>{t(translate.section14.topic2.sub1)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section15.topic1)}</h3>
          <p>{t(translate.section15.topic2.sub1)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section16.topic1)}</h3>
          <p>{t(translate.section16.topic2.sub1)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section17.topic1)}</h3>
          <p>{t(translate.section17.topic2.sub1)}</p>
        </div>
      </div>
      <ScrollToBottom onClick={handlePressScrollToBottom} />
    </div>
  );
};

const PrivacyPolicy = (props) => {
  const { t, currentLanguage } = props;

  const translate = {
    title: {
      en: `Privacy Policy`,
      cn: `个人信息保护政策`,
      th: `นโยบายคุ้มครองข้อมูลส่วนบุคคล`,
    },
    sectionHeader: {
      topic1: {
        en: `Privacy Policy`,
        cn: `个人信息保护政策`,
        th: `Privacy Policy`,
      },
      topic2: {
        sub1: {
          en: `Tiffany's Show Pattaya Co., Ltd. and Tiffany's Show Group of Companies have realized the importance of personal data protection as it is part of our social responsibility and foundation of reliable business relationship among our customers, employees and other personnel. Hence, the Company is committed to comply with personal data protection laws and other relevant statutory rules and regulations. `,
          cn: `蒂芙尼秀芭堤雅有限公司和蒂芙尼秀集团公司意识到个人信息保护的重要性；由于个人信息保护是社会责任的一部分，也是与客户以及员工和其他人员建立值得信赖业务关系的基础。公司才致力于遵守个人信息保护法以及其他相关官方规则。`,
          th: `บริษัท ทิฟฟานี่โชว์ พัทยา จำกัดและกลุ่มบริษัททิฟฟานี่โชว์ตระหนักถึงความสำคัญของการคุ้มครองข้อมูลส่วนบุคคล เนื่องจากการคุ้มครองข้อมูลส่วนบุคคลเป็นส่วนหนึ่งของการรับผิดชอบต่อสังคมและเป็นรากฐานในการสร้างความสัมพันธ์ทางธุรกิจที่น่าเชื่อถือกับลูกค้ารวมถึงพนักงานและบุคคลากร บริษัทจึงยึดมั่นในการปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล และกฎเกณฑ์ทางการอื่น ๆ  ที่เกี่ยวข้อง`,
        },
        sub2: {
          en: `This Privacy Policy has been established to describe the purposes and details concerning collection, use and disclosure of personal data as well as legal rights concerning personal data that is collected, used and disclosed by the Company to achieve the purposes of sale of products, provision of services, offering of services or sale of products or promotional campaigns or any other relevant operations. The Company always realizes and prioritizes the rights and privacy of the data subject whether you are our customer, client, guest, visitor or any other related party. Furthermore, the Company will implement stringent security and confidentiality measures to prevent any unauthorized use of personal data without the data subject’s consent. The Company will proceed based on the purposes and the data subject’s consent given to us as to collection, use or disclosure of personal data or as required by the applicable law and in conformity with the international standards.`,
          cn: `该份个人信息保护政策是为了告知您有关收集、使用和披露个人信息的目的和详细信息以及与个人信息相关的合法权利而制定。公司是以实现销售产品、提供服务、提议服务或销售产品或公司促销活动或任何其他相关行动为目的而收集、使用和披露您的个人信息。因此，不管您是客户、服务对象、访客、来访人员或任何其他相关人员，公司意识到并高度重视个人信息所有者的权利和隐私；公司将采取严格措施维护安全保密工作并防止未经个人信息所有者许可使用个人信息。公司将根据目标和就个人信息所有者向公司提供有关收集、使用或披露的个人信息的同意书或根据法律要求并按照国际标准推进业务。`,
          th: `นโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ถูกจัดทำขึ้นเพื่อแจ้งให้ทราบถึงวัตถุประสงค์และรายละเอียดเกี่ยวกับการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล ตลอดจนสิทธิตามกฎหมายที่เกี่ยวข้องกับข้อมูลส่วนบุคคล ซึ่งบริษัทได้ทำการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อให้บรรลุวัตถุประสงค์ในการขายสินค้า การให้บริการการเสนอบริการหรือขายสินค้า หรือโปรโมชั่นของบริษัท หรือการดำเนินการอื่นใดที่เกี่ยวข้อง ทั้งนี้ ไม่ว่าท่านจะเป็นลูกค้า ผู้รับบริการ ผู้เยี่ยมชม ผู้มาติดต่อหรือบุคคลอื่นใดที่เกี่ยวข้องก็ตามบริษัทตระหนักและให้ความสำคัญอย่างยิ่งกับสิทธิและความเป็นส่วนตัวของเจ้าของข้อมูลส่วนบุคคลและบริษัทจะดำเนินมาตรการที่เข้มงวดในการรักษาความมั่นคงปลอดภัยการรักษาความลับตลอดจนการป้องกันมิให้มีการนำข้อมูลส่วนบุคคลไปใช้โดยมิได้รับอนุญาตจากเจ้าของข้อมูลส่วนบุคคลก่อนโดยบริษัทจะดำเนินการตามวัตถุประสงค์และความยินยอมจากเจ้าของข้อมูลส่วนบุคคลที่ให้ไว้กับบริษัทในเรื่องเกี่ยวกับ การเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลนั้น หรือ ตามที่กฎหมายกำหนดและสอดคล้องกับมาตรฐานสากล`,
        },
      },
    },
    section1: {
      topic1: {
        en: `1. Definition`,
        cn: `1. 定义`,
        th: `1. นิยาม`,
      },
      topic2: {
        sub1: { en: `Term`, cn: `定义`, th: `นิยาม` },
        sub2: { en: `Definition`, cn: `含义`, th: `ความหมาย` },
        sub3: { en: `Data processing`, cn: `数据处理`, th: `ข้อมูลชีวภาพ` },
        sub3_1: {
          en: `means any act performed with personal data or set of personal data, whether by automated means or not, including collection, recording, organization, structuring, storage, adaptation or alteration, retrieval, consultation, use, disclosure by transmission, dissemination or otherwise making available, alignment or combination, restriction, erasure or destruction of personal data.`,
          cn: `是指对个人信息或个人数据集采取的任何措施，无论是否通过自动化方式均是。例如，收集、记录、系统组织、整理存储结构、变更或修改、接收、审批使用、通过传输披露、宣传或进行任何其他导致可用性、使用、放置或组合、限制、删除或损坏的行为。`,
          th: `หมายถึง ข้อมูลส่วนบุคคลที่เกิดจากการใช้เทคนิคหรือเทคโนโลยีที่เกี่ยวข้องกับการนำลักษณะเด่นทางกายภาพหรือทางพฤติกรรมของบุคคลมาใช้ทำให้สามารถยืนยันตัวตนของบุคคลนั้นที่ไม่เหมือนกับบุคคลอื่นได้ เช่น ข้อมูลจำลองภาพใบหน้า ข้อมูลจำลองม่านตา หรือข้อมูลจำลองลายนิ้วมือ`,
        },
        sub4: {
          en: `Company`,
          cn: `公司`,
          th: `ข้อมูลที่ไม่สามารถระบุตัวบุคคลได้`,
        },
        sub4_1: {
          en: `means Tiffany's Show Pattaya Co., Ltd.`,
          cn: `是指蒂芙尼秀芭堤雅有限公司`,
          th: `หมายถึง ข้อมูลที่ผ่านกระบวนการจัดทำข้อมูลนิรนามแล้ว`,
        },
        sub5: {
          en: `Group of Companies`,
          cn: `蒂芙尼秀集团`,
          th: `ข้อมูลส่วนบุคคล`,
        },
        sub5_1: {
          en: `means subsidiaries that are under control of the Company and its affiliates.`,
          cn: `是指受公司或附属公司管辖之下子公司`,
          th: `หมายถึง ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ`,
        },
        sub6: { en: `Biometric data`, cn: `生物学数据`, th: `ข้อมูลสาธารณะ` },
        sub6_1: {
          en: `means personal data arising from the use of technics or technology related to the physical or behavioral dominance of person, which can be used to identify such person apart from other persons, such as the facial recognition data, iris recognition data or fingerprint recognition data.`,
          cn: `是指使用技术或涉及利用个人的身体或行为特征验证该人身份与其他人不同的技术产生的个人信息。例如，人脸模拟数据、虹膜模拟数据或指纹模拟数据。`,
          th: `หมายถึง ข้อมูลส่วนบุคคลที่เจ้าของข้อมูลส่วนบุคคลได้เปิดเผยต่อสาธารณชน เช่น ข้อมูลโปรไฟล์สื่อสังคมออนไลน์ เมื่อมีการใช้ข้อมูลและรหัสการเข้าระบบของสื่อสังคมออนไลน์ (social media credential) เช่น Facebook Instagram Youtube TikTok Twitter และ Line เพื่อเชื่อมต่อหรือเข้าสู่บริการใด ๆ ของบริษัท เช่น บัญชีสื่อสังคมออนไลน์ (social media account ID) สิ่งที่สนใจ (interests) รายการที่ชอบ (likes) และรายชื่อเพื่อนของเจ้าของข้อมูลส่วนบุคคล ซึ่งเจ้าของข้อมูลส่วนบุคคลสามารถควบคุมการจัดเก็บความเป็นส่วนตัวนี้ผ่านการตั้งค่าบัญชีสื่อสังคมออนไลน์ที่จัดทำไว้ให้โดยผู้ให้บริการสื่อสังคมออนไลน์ดังกล่าว`,
        },
        sub7: {
          en: `Anonymous data`,
          cn: `非个人身份识别信息`,
          th: `ข้อมูลส่วนบุคคลที่มีความอ่อนไหว`,
        },
        sub7_1: {
          en: `means data which has been anonymized.`,
          cn: `是指通过创建匿名数据过程的数据`,
          th: `หมายถึง ข้อมูลส่วนบุคคลเกี่ยวกับเชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ หรือข้อมูลสุขภาพจิต ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพหรือข้อมูลอื่นใดซึ่งกระทบต่อเจ้าของข้อมูลส่วนบุคคลในทำนองเดียวกันตามที่คณะกรรมการประกาศกำหนด`,
        },
        sub8: { en: `Personal data`, cn: `个人信息`, th: `คณะกรรมการ` },
        sub8_1: {
          en: `means any information relating to a person, which enables the identification of such person, whether directly or indirectly, but not including the information of the deceased persons in particular.`,
          cn: `是指能够直接或间接识别个人身份的有关个人信息，但不包括死者的具体信息`,
          th: `หมายถึง คณะกรรมการคุ้มครองข้อมูลส่วนบุคคล`,
        },
        sub9: { en: `Public data`, cn: `公开信息`, th: `คุกกี้ (Cookie)` },
        sub9_1: {
          en: `means personal data which is made available to the public by the data subject such as social media profile and credential such as Facebook, Instagram, Youtube, TikTok, Twitter and Line in order to connect to or access any service of the Company such as social media account ID, interests, likes and list of friends of the data subject. The data subject may control the privacy of personal data by setting the social media account ID provided by the social media service provider.`,
          cn: `是指个人信息所有者向公众公开的个人信息。例如，社交媒体个人资料信息；当使用社交媒体登录信息和代码（social media credential）时。例如，Facebook、Instagram、Youtube、TikTok、Twitter 和 Line 。连接或进入任何公司服务。例如，个人信息所有者的社交媒体帐户（social media account ID）、兴趣(interests)、喜欢(likes)和好友列表。个人信息所有者可以通过上述社交媒体服务提供商提供的社交媒体账户设置控制该隐私的存储方式。`,
          th: `หมายถึง ข้อมูลขนาดเล็กที่เว็บไซต์ของบริษัท ส่งไปยังคอมพิวเตอร์หรืออุปกรณ์อิเล็กทรอนิกส์ที่เชื่อมต่ออินเทอร์เน็ต เพื่อเก็บข้อมูลส่วนบุคคล โดยคุกกี้จะถูกส่งกลับไปที่เว็บไซต์ต้นทางในแต่ละครั้งที่กลับเข้ามาดูที่เว็บไซต์ดังกล่าว`,
        },
        sub10: {
          en: `Sensitive data`,
          cn: `个人敏感信息`,
          th: `เจ้าของข้อมูลส่วนบุคคล`,
        },
        sub10_1: {
          en: `means personal data pertaining to racial, ethnic origin, political opinions, cult, religious or philosophical beliefs, sexual behavior, criminal records, health data, disability or mental health data, trade union information, genetic data, biometric data, or of any data which may affect the data subject in the same manner, as prescribed by the Committee.`,
          cn: `是指有关种族、民族、政治观点、信仰、宗教或哲学、性行为、犯罪史、残疾健康信息或心理健康信息、工会信息、遗传信息、生物数据或与委员会公布方式相同作风对个人信息所有者有影响的任何其他信息。`,
          th: `หมายถึง บุคคลซึ่งเป็นเจ้าของข้อมูลส่วนบุคคลซึ่งบริษัทหรือกลุ่มบริษัททิฟฟานี่โชว์มีการเก็บรวบรวมใช้ หรือเปิดเผยข้อมูลส่วนบุคคล`,
        },
        sub11: { en: `Committee`, cn: `委员会`, th: `นโยบาย` },
        sub11_1: {
          en: `means the Personal Data Protection Committee.`,
          cn: `是指 个人信息保护委员会`,
          th: `หมายถึง นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับลูกค้า ผู้รับบริการ ผู้มาติดต่อ หรือบุคคลอื่นใดที่เกี่ยวข้องกับในการเป็นผู้ซื้อสินค้าหรือรับบริการของบริษัทและกลุ่มบริษัททิฟฟานี่โชว์ฉบับนี้และที่อาจจะมีการแก้ไขเพิ่มเติม`,
        },
        sub12: { en: `Cookie`, cn: `Cookie`, th: `ผู้ควบคุมข้อมูลส่วนบุคคล` },
        sub12_1: {
          en: `means a small text file which is sent by the Company's websites to any computer or electronic device connected to internet in order to collect personal data. Cookie will be resent to the original websites upon revisit to the websites. `,
          cn: `是指 为了收集个人信息公司网站发送到连接互联网的计算机或电子设备的小型信息，每次您返回到上述网站时，该Cookie都会被发送回该原始网站。`,
          th: `หมายถึง ผู้ที่มีอำนาจหน้าที่ตัดสินใจเกี่ยวกับการรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล`,
        },
        sub13: {
          en: `Data subject`,
          cn: `个人信息所有者`,
          th: `ผู้ประมวลผลข้อมูล`,
        },
        sub13_1: {
          en: `means an individual person whom personal data is collected, used or disclosed by the Company or Tiffany's Show Group of Companies.`,
          cn: `是指个人信息所有者个人；公司或蒂芙尼秀集团有收集使用或披露个人信息。`,
          th: `หมายถึง ผู้ซึ่งดำเนินการเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของผู้ควบคุมข้อมูลส่วนบุคคล`,
        },
        sub14: {
          en: `Policy`,
          cn: `政策`,
          th: `พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล`,
        },
        sub14_1: {
          en: `means the Privacy Policy applied to customers, clients, visitors or any other related parties who purchase products or receive services from the Company and Tiffany's Show Group of Companies and the amendments thereof.`,
          cn: `是指该份有可能会变更并适用于客户、服务对象、访客或参与从公司和蒂芙尼秀集团购买产品或接受服务的任何其他人的个人信息保护政策`,
          th: `หมายถึง พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 และที่จะมีการแก้ไขเพิ่มเติม`,
        },
        sub15: { en: `Data Controller`, cn: `个人信息控制者`, th: `สำนักงาน` },
        sub15_1: {
          en: `means a person having the power and duties to make decisions regarding collection, use, or disclosure of the personal data.`,
          cn: `是指有权对个人信息收集、使用或披露作决定之人`,
          th: `หมายถึง สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล`,
        },
        sub16: { en: `Data Processor`, cn: `数据处理员`, th: `แอพพลิเคชัน` },
        sub16_1: {
          en: `means a person or a juristic person who operates in relation to collection, use, or disclosure of personal data pursuant to the orders given by or on behalf of a data controller.`,
          cn: `是指 根据个人信息控制者的指令或名义执行收集、使用或披露个人信息的人员。`,
          th: `หมายถึง โปรแกรม หรือชุดคำสั่งที่ใช้ควบคุมการทำงานของคอมพิวเตอร์เคลื่อนที่และอุปกรณ์ต่อพ่วงต่าง ๆ เพื่อให้ทำงานตามคำสั่ง และตอบสนองความต้องการของผู้ใช้ โดยแอพพลิเคชั่น (Application) ต้องมีสิ่งที่เรียกว่า ส่วนติดต่อกับผู้ใช้ (User Interface หรือ UI) เพื่อเป็นตัวกลางการใช้งานต่างๆ`,
        },
        sub17: { en: `PDPA`, cn: `个人信息保护法`, th: `IP Address` },
        sub17_1: {
          en: `means the Personal Data Protection Act, B.E. 2562 (2019) and the amendments thereof.`,
          cn: `是指 2019年个人信息保护法及修订案`,
          th: `หมายถึง สัญลักษณ์เชิงหมายเลขที่กำหนดให้แก่อุปกรณ์แต่ละชนิด เช่น คอมพิวเตอร์ หรือ เครื่องพิมพ์ ที่มีส่วนร่วมอยู่ในเครือข่ายคอมพิวเตอร์หนึ่งๆ ที่ใช้อินเทอร์เน็ตโพรโทคอล ในการสื่อสาร`,
        },
        sub18: { en: `PDPC`, cn: `办公室`, th: `Log` },
        sub18_1: {
          en: `means the Office of Personal Data Protection Commission.`,
          cn: `是指个人信息保护委员会办公室`,
          th: `หมายถึง ข้อมูลที่เกิดจากการใช้งานแอพพลิเคชั่น ซึ่งรวมถึงแหล่งกำเนิดต้นทางปลายทาง เส้นทาง เวลา วันที่ ปริมาณ ระยะเวลา ชนิดของบริการ หรืออื่นๆ ที่เกี่ยวข้องกับการใช้งานของแอพพลิเคชั่น`,
        },
        sub19: { en: `Application`, cn: `应用`, th: `` },
        sub19_1: {
          en: `means any program or set of command used to control mobile computer and peripherals to function and respond to users’ commands. Application shall comprise User Interface (UI) to facilitate interaction.`,
          cn: `是指 用于控制移动计算机和各种外围设备运行，以便按指令进行工作和响应用户需求的程序或指令集。应用程序（Application）必须有一个叫做用户界面（User Interface或UI）作为各种应用程序运用的界面。`,
          th: ``,
        },
        sub20: { en: `IP Address`, cn: `IP Address`, th: `` },
        sub20_1: {
          en: `means a numerical label assigned to each kind of device such as computer or printer involved in any computer network using internet protocol for communication.`,
          cn: `是指 分配给每种设备类型的数字符号。例如，参与计算机网络并使用互联网协议进行通信的计算机或打印机`,
          th: ``,
        },
        sub21: { en: `Log`, cn: `Log`, th: `` },
        sub21_1: {
          en: `means a record containing information on use of applications, upstream and downstream information, route, time, volume, duration, type of service or other information related to use of application.`,
          cn: `是指 使用应用程序产生的数据，包括出发地、目的地、路线、时间、日期、数量、持续时间、服务类型或与应用程序使用相关的其他内容。`,
          th: ``,
        },
        sub22: {
          en: `Unless otherwise provided herein, the Company referred in this Policy shall include Tiffany's Show Group of Companies and you shall be referred to the data subject.`,
          cn: `除非该政策另有说明，以下该政策提及到公司应包括蒂芙尼秀集团公司；当提及到您时是指个人信息所有者。`,
          th: `นอกจากจะกำหนดไว้เป็นอย่างอื่นในนโยบายฉบับนี้ ต่อไปในนโยบายนี้เวลาอ้างถึงบริษัทให้หมายความรวมถึงกลุ่มบริษัททิฟฟานี่โชว์ และเวลาอ้างถึงท่านให้หมายความถึงเจ้าของข้อมูลส่วนบุคคล`,
        },
        sub23: {
          en: `2. Personal Data Collected, Used and Disclosed by the Company`,
          cn: `2. 公司收集、使用和披露的个人信息`,
          th: `2. ข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวม ใช้ และเปิดเผย`,
        },
        sub24: {
          en: `1. General Personal Data`,
          cn: `1. 个人基本信息`,
          th: `1. ข้อมูลส่วนบุคคลทั่วไป`,
        },
        sub25: {
          en: `1. The Company will collect personal data (including sensitive data as prescribed in the PDPA and by the Committee) that is directly provided by the data subject or personal data that the Company obtains from its provision of service or operations through all channels as follows :`,
          cn: `1. 公司通过以下各个渠道收集个人信息所有者直接向公司提供的个人信息或公司通过提供公司服务或运营得到的个人信息（包括个人信息保护法和委员会规定的个人敏感信息）:`,
          th: `1. บริษัทจะทำการเก็บรวบรวมข้อมูลส่วนบุคคล (ซึ่งรวมไปถึงข้อมูลส่วนบุคคลที่มีความอ่อนไหว ตามที่กำหนดไว้ใน พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล และที่คณะกรรมการกำหนด) ที่เจ้าของข้อมูลส่วนบุคคลได้ให้ไว้กับบริษัทโดยตรงหรือข้อมูลส่วนบุคคลที่บริษัทได้รับจากการให้บริการหรือการดำเนินงานของบริษัทผ่านทุกช่องทาง ดังนี้`,
        },
        sub26: {
          en: `Personal data generally relating to the data subject such as name, surname, identification number, date of birth, age, occupation, sex, marital status, photograph, home telephone number, mobile phone number, registered address, mailing address, passport number, email, credit card number, IP Address, financial information concerning receipt of service or ordering of products from the Company, preferences, information on product and/or service ordering and other relevant information. `,
          cn: `与个人信息所有者有关的个人基本信息。例如，姓名、姓氏、公民身份证号码、出生日期、年龄、职业、性别、婚姻状况、照片、家庭电话号码、移动电话号码、户籍登记地址、邮寄地址、护照号码、电子邮件、信用卡卡号、计算机序列号（IP地址）、使用公司服务或订购产品的财务信息、您感兴趣的内容、订购信息和/或服务以及其他相关的信息`,
          th: `ข้อมูลส่วนบุคคลที่เกี่ยวกับเจ้าของข้อมูลส่วนบุคคลเป็นการทั่วไป เช่น ชื่อ นามสกุล เลขบัตรประจำตัวประชาชน วันเกิด อายุ อาชีพ เพศ สถานภาพทางการสมรส รูปถ่าย หมายเลขโทรศัพท์บ้าน หมายเลขโทรศัพท์เคลื่อนที่ ที่อยู่ตามทะเบียนบ้าน ที่อยู่เพื่อจัดส่งไปรษณีย์ เลขที่หนังสือเดินทาง อีเมล หมายเลขบัตรเครดิต หมายเลขประจำเครื่องคอมพิวเตอร์ (IP address) ข้อมูลทางการเงินในการใช้บริการหรือสั่งซื้อสินค้ากับบริษัท เนื้อหาที่ท่านสนใจ ข้อมูลการสั่งซื้อสินค้า และ/หรือบริการ และข้อมูลอื่นๆที่เกี่ยวข้อง`,
        },
        sub27: {
          en: `Searching behavior data means any data which is not related an identifiable natural person such as type of browser, domain, visited websites, website visiting duration, URL, customer support information. Your log information will be kept from your use of the Company’s application. `,
          cn: `搜索行为信息是指与可识别自然人无关的信息。例如，浏览器类型、域名、访问过的网站、网站登录时间、客户支持参考网站地址。公司的应用程序将会记录您的Log使用情况。`,
          th: `ข้อมูลพฤติกรรมการสืบค้น หมายถึง ข้อมูลที่ไม่เกี่ยวข้องต่อบุคคลธรรมดาที่ระบุตัวตนได้ เช่น ประเภทเบราเซอร์ โดเมน เว็บไซต์ที่เยี่ยมชม เวลาเข้าเว็บไซต์ ที่อยู่เว็บไซต์อ้างอิงข้อมูลเพื่อการสนับสนุนลูกค้า โดยจะมีการเก็บ Log การใช้งานของท่านจากบนแอพพลิเคชั่นของทางบริษัท`,
        },
        sub28: {
          en: `System data means any data which is automatically kept by the Company when you are logging into the Company’s websites, either via Cookie, Log File, Script (for more information, refer to the Company’s Cookie Policy), including technical data such as IP Address, type of browser, domain, history of visited websites, duration of use, URL, your searching or viewing information during use of the Company’s websites as well as application usage behavior. `,
          cn: `系统信息是指当您登陆公司网站时，公司自动收集的信息，不管是通过cookie、网络信标、登录文件、脚本（请参阅公司cookie政策中的更多详细信息）以及技术信息。例如，IP地址、浏览器类型、域名、访问网址的历史记录、访问时间、参考网站地址、有关您使用公司网站时搜索或查看的内容信息，包括应用程序使用行为。`,
          th: `ข้อมูลระบบ หมายถึง ข้อมูลที่บริษัทจัดเก็บโดยอัติโนมัติเมื่อท่านล๊อคอินเข้าสู่เว็บไซต์ของบริษัท ไม่ว่าจะผ่านทางคุกกี้ เว็บบีคอน ไฟล์ล๊อคอิน สคริปท์ (โปรดดูรายละเอียดเพิ่มเติมในโยบายคุกกี้ของบริษัท) รวมถึง ข้อมูลทางเทคนิค เช่น ที่อยู่ไอพี ประเภทของบราวซเซอร์ โดเมน ประวัติเว็บไซต์ที่เยี่ยมชม เวลาการเข้าใช้งาน ที่อยู่เว็บไซต์ที่อ้างอิง ข้อมูลเกี่ยวกับสิ่งที่ท่านค้นหาหรือที่ท่านดูในขณะที่ใช้เว็บไซต์ของบริษัท รวมถึง พฤติกรรมการใช้งานแอพพลิเคชั่น`,
        },
        sub29: {
          en: `Location data means any data obtained from GPS, Wi-Fi, compass, acceleration sensor, IP Address or public posts specifying the location data. `,
          cn: `位置信息是指从GPS、WI-FI、指南针、加速器、IP地址或含位置信息公开的帖子`,
          th: `ข้อมูลที่ตั้ง หมายถึง ข้อมูลที่ได้รับจากจีพีเอส ไวไฟ เข็มทิศ เครื่องวัดความเร่ง IP Address หรือโพสต์สาธารณะซึ่งระบุข้อมูลที่ตั้ง`,
        },
        sub30: {
          en: `2. Sensitive Data`,
          cn: `2. 个人敏感信息 (Sensitive Data)`,
          th: `2. ข้อมูลส่วนบุคคลที่มีความอ่อนไหว (Sensitive Data)`,
        },
        sub31: {
          en: `In order to sell products or render services of the Company or perform any act according to the purposes of personal data collection, in some cases, the Company has to collect special sensitive data such as personal data pertaining to racial, religious or philosophical beliefs, sexual behavior, disability, trade union information, genetic data, biometric data and health data. In this case, the Company will notify and ask for the data subject's consent to use such special sensitive data to achieve the purposes of personal data use of the Company (in this Policy, unless otherwise individually specified, personal data and sensitive data related to you will be referred to as “Personal Data”).`,
          cn: `提供销售公司产品或服务时或在某些情况下按公司的个人信息收集目标执行，公司有必要收集特别敏感的个人信息。例如，与种族、宗教或哲学、性行为、残疾、公会信息、遗传信息、生物学信息和健康信息等有关的个人信息。在这种情况下，公司将通知并征得个人信息所有者的同意，以便使用特别敏感的个人信息进一步实现公司个人信息使用目的。（该份政策后续若无特别说明，与您有关的个人信息和个人敏感信息将统称为“个人信息”）`,
          th: `ในการเสนอขายผลิตภัณฑ์หรือให้บริการของบริษัท หรือการดำเนินการตามวัตถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคลของบริษัทในบางกรณี บริษัทมีความจำเป็นต้องเก็บรวบรวมข้อมูลส่วนบุคคลที่มีความอ่อนไหวเป็นพิเศษ เช่น ข้อมูลส่วนบุคคลที่เกี่ยวกับ เชื้อชาติ ศาสนา หรือ ปรัชญา พฤติกรรมทางเพศ ความพิการ ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพและข้อมูลสุขภาพ เป็นต้น ซึ่งในกรณีนี้บริษัทจะแจ้งและขอความยินยอมจากเจ้าของข้อมูลส่วนบุคคล เพื่อใช้ข้อมูลส่วนบุคคลที่มีความอ่อนไหวเป็นพิเศษเพื่อดำเนินการตามวัตถุประสงค์ในการใช้ข้อมูลส่วนบุคคลของบริษัทต่อไป (ต่อไปในนโยบายฉบับนี้ หากไม่กล่าวโดยเฉพาะเจาะจง จะเรียกข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลที่มีความอ่อนไหวที่เกี่ยวกับท่านข้างต้น รวมกันว่า “ข้อมูลส่วนบุคคล”)`,
        },
        sub32: {
          en: `3. How to Obtain Personal Data`,
          cn: `3. 个人信息的获取方式`,
          th: `3. วิธีที่ได้มาซึ่งข้อมูลส่วนบุคคล`,
        },
        sub33: {
          en: `The Company collects personal data by the following processes:`,
          cn: `公司通过如下流程收集个人信息：`,
          th: `บริษัทมีการจัดเก็บรวบรวมข้อมูลส่วนบุคคลด้วยกระบวนการต่อไปนี้`,
        },
        sub34: {
          en: `1. Personal Data Directly Obtained from the Data Subject`,
          cn: `1. 直接从个人信息所有者获取个人信息`,
          th: `1. ข้อมูลส่วนบุคคลที่ได้รับจากเจ้าของข้อมูลส่วนบุคคลโดยตรง`,
        },
        sub35: {
          en: `Personal data that is directly provided by you to the Company, including data collection from product ordering or receipt of service, visit, contact or any other operation relating to the Company as well as any personal data obtained:`,
          cn: `您直接向公司提供的个人信息，通过购买产品或使用服务（包括访问、联系或与公司相关的任何其他行为）收集的信息以及如下获取的个人信息`,
          th: `ข้อมูลส่วนบุคคลที่ท่านให้ไว้แก่บริษัทโดยตรง ทั้งการเก็บข้อมูลจากการซื้อสินค้า หรือใช้บริการ รวมถึงการเยี่ยมชม การติดต่อ หรือการดำเนินการอื่นใดที่เกี่ยวข้องกับบริษัท ซึ่งรวมถึง ข้อมูลส่วนบุคคลที่ได้รับ`,
        },
        sub36: {
          en: `Upon expression of your intent to purchase products or use services of the Company (the “Products or Services”), member subscription and registration as well as data obtained from documentation and application forms for purchase of products, use of services, member subscription or registration or when the data subject has provided personal data at the time of determining purchase of products or use of services of the Company and when the data subject contacts the Company, either in writing or verbal, regardless of who contacts first.`,
          cn: `当表达购买产品或使用公司服务（“产品”或“服务”）意向时，申请加入会员、各种注册，包括购买产品、使用服务、申请会员或注册时提交各种文件和申请所获得的信息；或当个人信息所有者在考虑购买产品或使用公司的各种服务时提供的个人信息，包括个人信息所有者与公司沟通时，不管是哪一方先联系书面或是口头沟通的个人信息。`,
          th: `เมื่อแสดงเจตนาจะซื้อสินค้าหรือใช้บริการของบริษัท (“ผลิตภัณฑ์” หรือ “บริการ”) การสมัครสมาชิก รวมถึงการลงทะเบียนต่าง ๆ ซึ่งรวมถึงข้อมูลข้อที่ได้จากการส่งเอกสารและใบสมัครต่าง ๆ เพื่อซื้อผลิตภัณฑ์ ใช้บริการ สมัครสมาชิก หรือลงทะเบียน หรือเมื่อเจ้าของข้อมูลส่วนบุคคลให้ข้อมูลส่วนบุคคลขณะที่พิจารณาจะซื้อผลิตภัณฑ์หรือใช้บริการต่าง ๆ ของบริษัท รวมถึงเมื่อเจ้าของข้อมูลส่วนบุคคลติดต่อสื่อสารกับบริษัท ไม่ว่าจะเป็นการสื่อสารเป็นหนังสือหรือวาจา ไม่คำนึงว่าฝ่ายใดจะเป็นผู้ติดต่อก่อนก็ตาม`,
        },
        sub37: {
          en: `When the data subject contacts any personnel, customer service officer, salesperson, representative, agent, contractor, supplier, service provider, attorney-in-fact, authorized person or other persons or organizations related to the Company via websites application, social media, telephone, email, face-to-face meeting, interview, short message (SMS), facsimile, mail or any other means.`,
          cn: `当个人信息所有者与工作人员、客户服务人员、销售人员、代理商、经纪人、承包商、合作伙伴、服务供应商、授权人、代理人或其他人员或公司其他相关部门联系通过网站、应用程序、社交媒体、电话、电子邮件、面对面会议、采访、短信（SMS）、传真、邮寄或任何其他方式联系。`,
          th: `เมื่อเจ้าของข้อมูลส่วนบุคคลติดต่อกับบุคลากร เจ้าหน้าที่บริการลูกค้า พนักงานขาย ตัวแทน นายหน้า ผู้รับจ้าง คู่ค้า ผู้ให้บริการ ผู้รับมอบอำนาจ ผู้กระทำการแทน หรือบุคคลอื่นหรือหน่วยงานอื่นที่เกี่ยวข้องของบริษัท ผ่านทางเว็บไซต์ แอพพลิเคชัน สื่อสังคมออนไลน์ โทรศัพท์ อีเมล การพบปะกันโดยตรง การสัมภาษณ์ ข้อความสั้น (SMS) โทรสาร ไปรษณีย์ หรือโดยวิธีการอื่นใด`,
        },
        sub38: {
          en: `When the data subject furnishes to the Company personal data to participate in any marketing activity, contest, lucky draw, event or competition organized by or on behalf of the Company or personnel and supplier of the Company.`,
          cn: `当个人信息所有者参加公司或以公司名义或公司人员和业务合作伙伴组织的营销、竞赛、抽奖、事件或各种比赛活动时向公司发送的个人信息。`,
          th: `เมื่อเจ้าของข้อมูลส่วนบุคคลส่งข้อมูลส่วนบุคคลให้แก่บริษัท เพื่อเข้าร่วมในกิจกรรมทางการตลาด การประกวด การจับฉลากชิงโชค งานอีเว้นท์ หรือการแข่งขันต่าง ๆ ที่จัดขึ้นโดยหรือในนามของบริษัท หรือบุคลากรและคู่ค้าของบริษัท`,
        },
        sub39: {
          en: `When the data subject purchases any product, receives any service or makes any contact in the Company’s premises.`,
          cn: `当个人信息所有者在公司区域范围内购买产品、使用服务或联系。`,
          th: `เมื่อเจ้าของข้อมูลส่วนบุคคลเข้ามาซื้อผลิตภัณฑ์ ใช้บริการ หรือทำการติดต่อภายในพื้นที่ขอบริษัท`,
        },
        sub40: {
          en: `2. Personal Data Collected by the Company from Other Sources Than the Data Subject`,
          cn: `2. 公司从个人信息所有者以外其他源地收集的个人信息`,
          th: `2. ข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวมจากแหล่งอื่นที่ไม่ใช่เจ้าของข้อมูลส่วนบุคคล`,
        },
        sub41: {
          en: `Personal data that is obtained or accessed by the Company from other sources than directly from the data subject such as government organizations, financial group of companies, financial institutions, financial service providers, business partners, credit agencies, data service providers and etc. The Company will collect data from other sources only after obtaining your consent as required by the applicable law, except that it is necessary for the Company as permitted by the applicable law or such personal data may be collected, used or disclosed as required by the applicable law, including:`,
          cn: `公司从其他源地获取或有权访问的个人信息（不是直接从个人信息所有者获取）。例如，政府机构、金融业务集团公司、金融机构、金融服务提供商、商业合作伙伴、信用信息公司和信息服务供应商等等。公司只有在法律规定之下征得您的同意才会从其他源地收集信息，除非在法律允许公司有必要或可以按照法律规定收集、使用或披露个人信息，包括`,
          th: `ข้อมูลส่วนบุคคลที่บริษัทได้รับหรือเข้าถึงได้จากแหล่งอื่นซึ่งไม่ใช่จากเจ้าของข้อมูลส่วนบุคคลโดยตรง เช่น เช่น หน่วยงานของรัฐ บริษัทในกลุ่มธุรกิจทางการเงิน สถาบันการเงิน ผู้ให้บริการทางการเงิน พันธมิตรทางธุรกิจ บริษัทข้อมูลเครดิต และผู้ให้บริการข้อมูล เป็นต้น ซึ่งบริษัทจะเก็บรวบรวมข้อมูลจากแหล่งอื่นต่อเมื่อได้รับความยินยอมจากท่านตามที่กฎหมายกำหนด เว้นแต่บริษัทมีความจำเป็นตามกรณีที่กฎหมายอนุญาต หรือสามารถเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลได้ตามที่กฎหมายกำหนด ซึ่งรวมถึง`,
        },
        sub42: {
          en: `personal data obtained from Tiffany's Show Group of Companies`,
          cn: `蒂芙尼秀集团公司获取的个人信息`,
          th: `ข้อมูลส่วนบุคคลที่ได้รับจากกลุ่มบริษัททิฟฟานี่โชว์`,
        },
        sub43: {
          en: `personal data obtained from any third party such as representative, store or data collection provider, supplier, business partner and etc.`,
          cn: `来自第三方的个人信息。例如，代理商、商店或提供数据收集服务的公司、合作伙伴、联盟等。`,
          th: `ข้อมูลส่วนบุคคลจากบุคคลที่สาม เช่น ตัวแทน ร้านค้า หรือบริษัทที่ให้การบริการจัดเก็บรวบรวมข้อมูล คู่ค้า พันธมิตร เป็นต้น`,
        },
        sub44: {
          en: `personal data obtained from public records and non-public records that the Company is entitled to collect under the applicable law;`,
          cn: `公司依法有权收集公开（Public Records）和非公开（Non-Public Records）信息中获取的个人信息`,
          th: `ข้อมูลส่วนบุคคลที่ได้รับจากข้อมูลสาธารณะ (Public Records) และที่ไม่ใช่สาธารณะ (Non-Public Records) ที่บริษัท มีสิทธิเก็บรวบรวมได้ตามกฎหมาย`,
        },
        sub45: {
          en: `personal data obtained from website visits such as name of internet service provider and IP Address via use of internet, date and time of website visits, visited web pages and URLs directly linked to the Company’s websites, information on equipment or tools such as IP Address, MAC Address, Cookie, ID, IMEI as well as processing of personal data by using Cookie; `,
          cn: `通过访问网站获取的个人信息。例如，互联网服务供应商名称和访问互联网的IP地址（IP Address）、访问网站日期和时间、访问网站时访问的页面和网站地址；直接链接到该公司的网站、设备或工具信息。例如，IP address、MAC address、Cookie ID、IMEI，包括使用 cookie 处理个人数据。`,
          th: `ข้อมูลส่วนบุคคลที่ได้รับจากการเข้าเยี่ยมชมเว็ปไซต์ เช่น ชื่อของผู้ให้บริการอินเทอร์เน็ต และที่อยู่ไอพี (IP Address) ผ่านการเข้าใช้อินเทอร์เน็ต วันที่และเวลาของการเข้าเยี่ยมชมเว็บไซต์ หน้าเพจที่เข้าเยี่ยมชมขณะเข้าเว็บไซต์ และที่อยู่ของเว็บไซต์ ซึ่งเชื่อมโยงโดยตรงกับเว็บไซต์ของบริษัท ข้อมูลอุปกรณ์หรือเครื่องมือ เช่น IP address MAC address Cookie ID IMEI รวมถึงการประมวลผลข้อมูลส่วนบุคคลโดยการใช้คุกกี้`,
        },
        sub46: {
          en: `Application usage behavior in which your log files will be kept while using the Company’s application and`,
          cn: `应用程序使用行为，公司的应用程序将会记录您的Log使用情况`,
          th: `พฤติกรรมการใช้งานแอพพลิเคชั่น โดยจะมีการเก็บ Log การใช้งานของท่านจากบนแอพพลิเคชั่นของทางบริษัท`,
        },
        sub47: {
          en: `personal data obtained from government organizations or law enforcement agencies.`,
          cn: `从政府机构或行使法定权利的监管机构获取的个人信息`,
          th: `ข้อมูลส่วนบุคคลที่ได้รับจากหน่วยงานภาครัฐ หรือหน่วยงานกำกับดูแลที่ใช้อำนาจตามกฎหมาย`,
        },
        sub48: {
          en: `Generally, the Company will collect personal data directly from the data subject, except in some cases, the Company may collect personal data from other sources than the data subject. The Company will collect personal data from other sources only after obtaining your consent as required by the applicable law, except that it is necessary for the Company as permitted by the applicable law or such personal data may be collected, used or disclosed as required by the applicable law.`,
          cn: `一般情况下，公司将直接从个人信息所有者处收集个人信息。除非某些情况下公司可能会从个人信息所有者以外的源地收集个人信息；公司只有在法律规定之下征得您的同意才会从其他源地收集信息，除非在法律允许公司有必要或可以按照法律规定收集、使用或披露个人信息。`,
          th: `โดยทั่วไปบริษัทจะเก็บรวบรวมข้อมูลส่วนบุคคลของเจ้าของข้อมูลส่วนบุคคลโดยตรง เว้นแต่บางกรณีที่บริษัทอาจเก็บรวบรวมข้อมูลส่วนบุคคลจากแหล่งอื่นนอกจากเจ้าของข้อมูลส่วนบุคคล บริษัทจะเก็บรวบรวมข้อมูลจากแหล่งอื่นต่อเมื่อได้รับความยินยอมจากท่านตามที่กฎหมายกำหนด เว้นแต่บริษัทมีความจำเป็นตามกรณีที่กฎหมายอนุญาต หรือสามารถเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลได้ตามที่กฎหมายกำหนด`,
        },
        sub49: {
          en: `If the data subject is a minor, the Company will perform as required by the applicable law prior to processing of the minor’s personal data. The Company will collect, use or disclose personal data under the purposes of collection and in compliance with the applicable law.`,
          cn: `若个人信息所有者是未成年人，公司在处理未成年人的个人信息之前将按照法律要求采取措施。因此，公司将根据目的并依法收集、使用或披露个人信息。`,
          th: `หากเจ้าของข้อมูลส่วนบุคคลเป็นผู้เยาว์ บริษัทจะดำเนินการตามที่กฎหมายกำหนดก่อนมีการประมวลผลข้อมูลส่วนบุคคลของผู้เยาว์ ทั้งนี้ บริษัทจะเก็บ รวบรวม ใช้ หรือเผยแพร่ข้อมูลส่วนบุคคลภายใต้วัตถุประสงค์และเป็นไปตามที่กฎหมายกำหนด`,
        },
        sub50: {
          en: `4. Purposes of Collection, Use and Disclosure of Personal Data`,
          cn: `4. 收集、使用和披露个人信息目的`,
          th: `4. วัตถุประสงค์ในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล`,
        },
        sub51: {
          en: `The Company has the purposes of collection, use or disclosure of personal data as follows:`,
          cn: `公司收集、使用或披露个人信息的目的如下：`,
          th: `บริษัทมีวัตถุประสงค์ในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล ดังนี้`,
        },
        sub52: {
          en: `To sell products or render services, improve products and services and other services or products to be offered in the future, maintain and perform any operation in connection with such provision of services; `,
          cn: `销售产品或提供服务、改善公司的产品和服务，包括未来将提供的其他服务或产品以及管理、维护和执行与提供上述服务有关的业务。`,
          th: `เพื่อการขายสินค้าหรือให้บริการ การปรับปรุงผลิตภัณฑ์และบริการของบริษัท รวมถึงบริการหรือผลิตภัณฑ์อื่น ๆ ที่จะมีในอนาคต ตลอดจนการดูแล การบำรุงรักษา และการดำเนินการ ที่เกี่ยวข้องกับการให้บริการดังกล่าว`,
        },
        sub53: {
          en: `To carry out any operations on your demand, including visiting websites and/or mobile application of the Company;`,
          cn: `不管是访问公司网站和或移动应用程序，根据您的期望目标完成交易。`,
          th: `เพื่อการทำรายการตามวัตถุประสงค์ที่ท่านต้องการ ไม่ว่าจะเป็นการเข้าชมเว็บไซต์และหรือโมบายแอพลิเคชั่น ของบริษัท`,
        },
        sub54: {
          en: `To carry out transactions related to products or services of the Company such as member subscription or participation in any related activities;`,
          cn: `进行与公司产品或服务有关的各种交易。例如，申请会员、付款或参加各类相关活动。`,
          th: `เพื่อการดำเนินธุรกรรมต่าง ๆ ที่เกี่ยวข้องกับผลิตภัณฑ์หรือบริการของบริษัท เช่น การสมัครสมาชิก การชำระเงิน หรือการเข้าร่วมกิจกรรมต่างๆที่เกี่ยวข้อง`,
        },
        sub55: {
          en: `To manage relationship between the Company and the data subject;`,
          cn: `管理公司与个人信息所有者之间的关系`,
          th: `เพื่อการบริหารความสัมพันธ์ระหว่างบริษัทกับเจ้าของข้อมูลส่วนบุคคล`,
        },
        sub56: {
          en: `To verify and/or identify the data subject prior to using any service through available channels or contacting the Company; `,
          cn: `通过各种渠道访问服务或联系公司验证和/或识别个人信息所有者的身份`,
          th: `เพื่อยืนยัน และ/หรือ ระบุตัวตนของเจ้าของข้อมูลส่วนบุคคลในการเข้าใช้บริการผ่านช่องทางต่าง ๆ หรือการติดต่อกับบริษัท`,
        },
        sub57: {
          en: `To communicate, notify and/or receive any news and information from the Company or any change of the Company;`,
          cn: `传达、告知和/或接收公司各类新闻信息或公司发生的各种变更`,
          th: `เพื่อการติดต่อสื่อสาร แจ้ง และ/หรือ รับข้อมูลข่าวสารต่าง ๆ จากบริษัท หรือการเปลี่ยนแปลงต่าง ๆ ที่เกิดขึ้นของบริษัท`,
        },
        sub58: {
          en: `To respond to the data subject’s requests notified to the Company;`,
          cn: `根据个人信息所有者已向公司报告的意愿进行处理`,
          th: `เพื่อการดำเนินการตามความประสงค์ของเจ้าของข้อมูลส่วนบุคคลที่ได้แจ้งไว้กับบริษัท`,
        },
        sub59: {
          en: `To offer benefits and/or other services of the Company such as giving advice and/or offers concerning products and services, marketing promotions and any transactions related to the Company’s services; `,
          cn: `介绍公司的各种福利和/或其他服务。例如，提供有关产品和服务的建议和/或优惠，包括促进营销活动的各种促销活动以及与使用公司服务相关的交易。`,
          th: `เพื่อการนำเสนอสิทธิประโยชน์ต่าง ๆ และ/หรือ บริการอื่น ๆ ของบริษัท อาทิ การให้คำแนะนำและ/หรือ ข้อเสนอเกี่ยวกับผลิตภัณฑ์และการบริการ รวมถึงโปรโมชั่นต่าง ๆ ในการส่งเสริมกิจกรรมทางการตลาด รวมถึง การทำธุรกรรมที่เกี่ยวข้องกับการใช้บริการของบริษัท`,
        },
        sub60: {
          en: `To operate the Company’s business such as data analysis, examination, development of new products, improvement or change of services, analysis of service performance, survey, sales promotional activities, operational development and business expansion of the Company; `,
          cn: `为了公司的业务运营采取数据分析、检验、新产品开发、改善或改变服务、服务使用分析、促销活动调查、公司经营及业务拓展审议等措施。`,
          th: `เพื่อการดำเนินธุรกิจของบริษัท เช่น การวิเคราะห์ข้อมูล การตรวจสอบ การพัฒนาผลิตภัณฑ์ใหม่ การปรับปรุงหรือเปลี่ยนแปลงการบริการ การวิเคราะห์การใช้งานด้านบริการ การสำรวจการจัดกิจกรรมส่งเสริมการขาย การพิจารณาการดำเนินงานและขยายธุรกิจของบริษัท`,
        },
        sub61: {
          en: `To operate any necessary and appropriate act to examine and prevent any breach or possible breach of the applicable laws, respond to any request of the government or government authorities and foreign government or foreign government authorities where the data subject resides, enforce the Company’s terms of services and policies related to personal data, protect the Company’s business operations, protect privacy, safety or property of the Company, personnel, the data subject or other persons, remedy, prevent or limit any possible damage and`,
          cn: `采取任何必要和适当的措施来调查和防止违反或潜在违反法律的行为，响应政府或政府机构的请求，包括个人信息所有者所在地国外政府机构或政府部门的请求，强制执行与个人信息相关的公司服务条款和政策，保护公司业务运营、保护隐私权、公司、人员和个人信息所有者或他人的安全或财产；补救、预防或限制可能发生的损害。`,
          th: `เพื่อการดำเนินการใดๆ ที่จำเป็นและเหมาะสมในการตรวจสอบและป้องกันการกระทำที่ละเมิดหรืออาจจะละเมิดต่อกฎหมาย ตอบสนองต่อคำขอจากหน่วยงานรัฐหรือรัฐบาล รวมถึงหน่วยงานของรัฐหรือรัฐบาลต่างประเทศที่เจ้าของข้อมูลส่วนบุคคลอาศัยอยู่ บังคับใช้ข้อกำหนดในการให้บริการและนโยบายที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของบริษัท ปกป้องการดำเนินธุรกิจของบริษัท ปกป้องสิทธิความเป็นส่วนตัว ความปลอดภัยหรือทรัพย์สินของบริษัท บุคคลากร และเจ้าของข้อมูลส่วนบุคคล หรือบุคคลอื่น เยียวยา ป้องกัน หรือจำกัดความเสียหายที่อาจเกิดขึ้น`,
        },
        sub62: {
          en: `To comply with the applicable laws and investigation of competent officials or regulatory authorities or to conform with the rules, regulations or obligations required by the laws or the government. Where such personal data is sensitive data, the Company will collect, use or disclose your sensitive data under the following purposes:`,
          cn: `依法调查工作人员或监管机构；或遵守法律或政府部门规定的规章制度、法规或义务。若其个人信息是个人敏感信息，公司收集、使用或披露您的个人敏感信息的目的如下：`,
          th: `เพื่อปฏิบัติตามกฎหมาย การสืบสวนของเจ้าพนักงาน หรือหน่วยงานกำกับดูแลหรือเพื่อให้เป็นไปตามกฎ ข้อบังคับ หรือข้อผูกพันที่กฎหมายหรือภาครัฐกำหนด ในกรณีที่ข้อมูลส่วนบุคคลนั้นเป็นข้อมูลส่วนบุคคลที่มีความอ่อนไหว บริษัทจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวของท่านภายใต้วัตถุประสงค์ดังต่อไปนี้:`,
        },
        sub63: {
          en: `It is to prevent or suppress danger to life, body or health where consent cannot be given by the data subject for any reason whatsoever;`,
          cn: `防止或阻止对个人信息所有者生命、身体或个人健康的危害，不管是任何原因均不能同意`,
          th: `เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของบุคคลซึ่งเจ้าของข้อมูล ส่วนบุคคลไม่สามารถให้ความยินยอมได้ ไม่ว่าด้วยเหตุใดก็ตาม`,
        },
        sub64: {
          en: `It is information that is disclosed to the public with explicit consent of the data subject; `,
          cn: `是经个人信息所有者明确同意向公众公开的信息`,
          th: `เป็นข้อมูลที่เปิดเผยต่อสาธารณะด้วยความยินยอมโดยชัดแจ้งของเจ้าของข้อมูลส่วนบุคคล`,
        },
        sub65: {
          en: `It is necessary for the purpose of establishment, compliance or exercise of legal claims or defense of legal claims;`,
          cn: `为了确立合法权利、遵守或行使合法权利或依法提起诉讼索赔权利所需`,
          th: `เป็นการจำเป็นเพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย การปฏิบัติตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย`,
        },
        sub66: {
          en: `It is necessary for compliance with the applicable laws to achieve the purposes with respect to matters stipulated by the applicable laws.`,
          cn: `为了实现法律规定的目标，必须遵守法律`,
          th: `เป็นการจำเป็นในการปฏิบัติตามกฎหมายเพื่อให้บรรลุวัตถุประสงค์ที่กฎหมายกำหนด`,
        },
        sub67: {
          en: `For other purposes not mentioned above, the data subject will be notified when the Company asks to collect the data subject’s personal data.`,
          cn: `因此，上述未注明的其他目的，当公司要求收集个人信息时，个人信息所有者将收到通知。`,
          th: `ทั้งนี้ วัตถุประสงค์อื่น ๆ ที่ไม่ได้ระบุไว้ข้างต้น เจ้าของข้อมูลส่วนบุคคลจะได้รับการแจ้งเมื่อบริษัทมีการขอเก็บรวบรวมข้อมูลส่วนบุคคล`,
        },
        sub68: {
          en: `In order to obtain your personal data, the Company will collect, use or disclose your personal data under the purposes in Clause 4 only when it is subject to any of the following conditions:`,
          cn: `此外，当获取您的个人信息后，仅限满足以下条件，公司才能在第4条目的范围之下收集、使用或披露您的个人信息：`,
          th: `อนึ่ง ในการได้ข้อมูลส่วนบุคคลของท่านมานั้น บริษัทจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านภายใต้วัตถุประสงค์ตาม ข้อ 4. เฉพาะเมื่อเข้าเงื่อนไขดังต่อไปนี้:`,
        },
        sub69: {
          en: `You have given the Company your consent under the law; `,
          cn: `您已依法向公司表示同意。`,
          th: `ท่านได้ให้ความยินยอมไว้กับบริษัทตามกฎหมาย`,
        },
        sub70: {
          en: `It is necessary for the performance of a contract to which you are a party or for proceeding your request prior to execution of such contract; `,
          cn: `为了履行您所签订的合同或在签订该合同之前根据您的要求采取措施所需`,
          th: `เป็นการจำเป็นเพื่อการปฏิบัติตามสัญญาซึ่งท่านเป็นคู่สัญญา หรือเพื่อใช้ในการดำเนินการตามคำขอของท่านก่อนเข้าทำสัญญานั้น`,
        },
        sub71: {
          en: `It is to prevent or suppress danger to a person’s life, body or health;`,
          cn: `是为了防止或阻止对生命、身体或个人健康造成危害`,
          th: `เป็นการป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือ สุขภาพของบุคคล`,
        },
        sub72: {
          en: `It is necessary for the performance of a task carried out in the public interest of the Company or exercise of any government authority assigned to the Company; `,
          cn: `为公司公共利益或履行政府赋予公司权利的职责履行使命中的职责所需`,
          th: `เป็นการจำเป็นเพื่อการปฏิบัติหน้าที่ในการดำเนินภารกิจเพื่อประโยชน์สาธารณะของบริษัท หรือปฏิบัติหน้าที่ในการใช้อำนาจที่รัฐได้มอบหมายให้แก่บริษัท`,
        },
        sub73: {
          en: `It is necessary for the legitimate interest of the Company or any other person or juristic person, except that such interest is overridden by your fundamental rights concerning your personal data;`,
          cn: `为了公司或其他个人、法人的合法权利所需，除非上述权益重要性不如您个人信息的基本权利`,
          th: `เป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัทหรือของบุคคลหรือนิติบุคคลอื่น เว้นแต่ประโยชน์ดังกล่าวมีความสำคัญน้อยกว่าสิทธิขั้นพื้นฐานในข้อมูลส่วนบุคคลของท่าน`,
        },
        sub74: {
          en: `It is necessary for legal compliance;`,
          cn: `必须遵守法律`,
          th: `เป็นความจำเป็นเพื่อปฏิบัติตามกฎหมาย`,
        },
        sub75: {
          en: `It is for preparation of historical documents or the archives for public interest or for the purpose relating to research or statistics, in which the suitable protection measures to safeguard your rights and freedoms are put in place by the Company.`,
          cn: `为了公共利益或与研究或统计相关编制历史文件或档案，公司为了保障您的权利和自由，将提供适当的保护措施。`,
          th: `มีการจัดทำเอกสารประวัติศาสตร์หรือจดหมายเหตุเพื่อประโยชน์สาธารณะ หรือที่เกี่ยวกับการศึกษาวิจัยหรือสถิติ โดยบริษัทจะจัดให้มีมาตรการปกป้องที่เหมาะสมเพื่อคุ้มครองสิทธิและเสรีภาพของท่าน`,
        },
        sub76: {
          en: `5. Disclosure and Transfer of Personal Data`,
          cn: `5. 个人信息披露及转让`,
          th: `5. การเปิดเผยและถ่ายโอนข้อมูลส่วนบุคคล`,
        },
        sub77: {
          en: `1. Disclosure of Personal Data`,
          cn: `1. 个人信息披露`,
          th: `1. การเปิดเผยข้อมูลส่วนบุคคล`,
        },
        sub78: {
          en: `The Company will keep your personal data confidential. However, to the extent permitted by the law or when the disclosure is reasonably required to achieve the purpose of processing of personal data or relevant purposes mentioned above, the Company may provide such personal data to any of the following persons:`,
          cn: `公司将对数据所有者的个人信息保密，但若法律允许或如有必要披露，为了能够实现处理个人信息或上述指定的相关目的，公司可能会向以下人员提供其人员个人信息：`,
          th: `บริษัทจะรักษาข้อมูลส่วนบุคคลของเจ้าของข้อมูลไว้เป็นความลับ แต่ทั้งนี้ ในกรณีที่กฎหมายที่ใช้บังคับอนุญาตให้กระทำได้ หรือกรณีที่การเปิดเผยดังกล่าวมีความจำเป็น เพื่อให้สามารถบรรลุตามวัตถุประสงค์ของการประมวลผลข้อมูลส่วนบุคคล หรือวัตถุประสงค์ที่เกี่ยวข้องตามที่ระบุข้างต้น บริษัทอาจให้ข้อมูลส่วนบุคคลนั้นแก่บุคคล ต่าง ๆ ดังต่อไปนี้`,
        },
        sub79: {
          en: `Relevant group of companies and affiliates of the Company: the Company will share your personal data within Tiffany's Show Group of Companies.`,
          cn: `相关公司和附属公司:公司将在蒂芙尼秀集团公司分享或共享您的个人信息。`,
          th: `กลุ่มบริษัทที่มีความเกี่ยวข้อง และบริษัทในเครือของบริษัท: บริษัทจะแชร์หรือแบ่งปันข้อมูลส่วนบุคคลของท่านภายในกลุ่มบริษัททิฟฟานี่โชว์`,
        },
        sub80: {
          en: `Contractor/contractual party: In case that the Company engages any contractor to perform any task which requires your personal data such as postal code, statistical analysis or online or website activity, the Company will require such contractor to protect your personal data and prohibit such contractor from using your personal data for any other purpose than supporting the Company’s activity or task.`,
          cn: `承包商/合同方:若公司雇佣承包商执行工作须使用您的个人信息。例如，邮政编码、统计分析或线上活动，网站将要求承包商这样操作以便保护您个人信息的隐私，除了支持公司活动或工作之外，禁止承包商将您的个人信息用于任何其他用途。`,
          th: `ผู้รับเหมา/คู่สัญญา: ในกรณีที่บริษัททำการจ้างผู้รับเหมาเพื่อดำเนินการใดอันจำเป็นใช้ข้อมูลส่วนบุคคลของท่าน เช่น รหัสไปรษณีย์ การวิเคราะห์ทางสถิติ หรือกิจกรรมออนไลน์ เว็บไซต์จะกำหนดให้ผู้รับเหมาในการดำเนินการนั้นเพื่อป้องกันความเป็นส่วนตัวของข้อมูลส่วนบุคคลของท่าน และต้องห้ามมิให้ผู้รับเหมาใช้ข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์อื่นใดนอกจากเพื่อสนับสนุนกิจกรรมหรืองานของบริษัท`,
        },
        sub81: {
          en: `Vendor/agent: In certain circumstances, the Company may share your personal data with any permitted vendor or agent such as Payment Gateway for any specific purpose such as processing of credit card information.`,
          cn: `卖方/中介：在某些情况下公司可能会向授权卖方/中介分享您的信息。例如，用于特定用途的Payment Gateway公司，如信用卡处理`,
          th: `ผู้ขาย/นายหน้า ในบางกรณี บริษัทอาจทำการแชร์ข้อมูลของท่านต่อผู้ขายหรือนายหน้าซึ่งได้รับอนุญาต เช่น บริษัท Payment Gateway เพื่อวัตถุประสงค์เฉพาะเจาะจง เช่น การประมวลผลบัตรเครดิต`,
        },
        sub82: {
          en: `Government organizations, government or other statutory organizations for compliance with the laws, orders, demands and coordination with other organizations in any matters concerning legal compliance.`,
          cn: `政府部门、政府或其他机构依法遵守法律、命令、要求，就遵守法律规定相关事宜与各机构进行协调工作。`,
          th: `หน่วยงานรัฐบาล รัฐบาล หรือองค์กรอื่นตามกฎหมาย เพื่อเป็นการปฏิบัติตามกฎหมาย คำสั่ง คำร้องขอ เพื่อการประสานงานกับหน่วยงานต่าง ๆ ในเรื่องที่เกี่ยวข้องกับการปฏิบัติตามกฎหมาย`,
        },
        sub83: {
          en: `Any other person or entity permitted by the applicable law.`,
          cn: `适用法律授权的任何其他部门或个人`,
          th: `บุคคลหรือหน่วยงานอื่นใดที่ได้รับอนุญาตตามกฎหมายที่ใช้บังคับ`,
        },
        sub84: {
          en: `Any other person whom the data subject can give an explicit consent to achieve the purposes mentioned above.`,
          cn: `为了实现上述目标，个人信息所有者明确同意的任何其他人`,
          th: `บุคคลอื่นใดที่เจ้าของข้อมูลส่วนบุคคลได้ให้ความยินยอมโดยชัดแจ้ง เพื่อให้บรรลุเป้าหมาย ตามวัตถุประสงค์ที่กล่าวมาแล้วข้างต้น`,
        },
        sub85: {
          en: `2. Transfer and/or Transmission of Personal Data Overseas`,
          cn: `2. 向境外转移、传输和/或发送个人信息`,
          th: `2. การโอน ถ่าย และ/หรือ ส่งข้อมูลส่วนบุคคลไปยังต่างประเทศ`,
        },
        sub86: {
          en: `The Company may have to transmit or transfer your personal data to any company or any of Tiffany's Show Group of Companies located overseas where you are working or to other recipients as part of the Company’s ordinary course of business such as transmission or transfer of personal data to the server/cloud in other countries. When the destination country may not have sufficient personal data protection measures, `,
          cn: `公司可能有必要将您的个人信息发送或转移至国外的公司或蒂芙尼秀集团公司，有可能是您工作的国家或其他信息接收人，这是公司业务正常运营的一部分。例如，发送或传输个人信息存储在国外的Server/Cloud上；若目的地国家的个人信息保护标准可能不足，公司将依法处理发送或转移个人信息，并按照其国家法律要求保密标准提供必要和适当的个人信息保护措施和补救措施。例如，要求信息接收者有与公司措施等效的个人信息安全保护措施、有与上述国家/地区信息接收者签订保密协议；或若信息接收者是蒂芙尼秀集团公司，`,
          th: `บริษัทจึงอาจมีความจำเป็นต้องส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบริษัทหรือกลุ่มบริษัททิฟฟานี่โชว์ที่อยู่ต่างประเทศ ซึ่งอาจเป็นประเทศที่ท่านทำงาน หรือไปยังผู้รับข้อมูลอื่น ซึ่งเป็นส่วนหนึ่งของการดำเนินธุรกิจตามปกติของบริษัท เช่น การส่งหรือโอนข้อมูลส่วนบุคคลไปเก็บไว้บน Server/Cloud ในประเทศต่าง ๆ กรณีที่ประเทศปลายทางที่อาจมีมาตรฐานในการคุ้มครองข้อมูลส่วนบุคคลที่ไม่เพียงพอ บริษัทจะดูแลการส่งหรือโอนข้อมูลส่วนบุคคลให้เป็นไปตามที่กฎหมายกำหนด และจะดำเนินการให้มีมาตรการคุ้มครองข้อมูลส่วนบุคคลและมาตรการเยียวยาตามที่เห็นว่าจำเป็นและเหมาะสมสอดคล้องกับมาตรฐานการรักษาความลับตามที่กฎหมายประเทศนั้นกำหนด เช่น กำหนดให้ผู้รับข้อมูลมีมาตรการในการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลเทียบเท่ากับมาตรการของบริษัท มีข้อตกลงรักษาความลับกับผู้รับข้อมูลในประเทศดังกล่าว หรือในกรณีที่ผู้รับข้อมูลเป็นกลุ่มบริษัททิฟฟานี่โชว์ `,
        },
        sub87: {
          en: `the Company will ensure that transmission or transfer of personal data conforms with the applicable law and provide any personal data protection and remedy measures that are necessary, appropriate and conforming to the confidentiality standard stipulated by the law of such country, for example, requiring the recipient to put in place personal data security measures at the same level implemented by the Company, executing a non-disclosure agreement with the recipient in such country or if the recipient is any of Tiffany's Show Group of Companies, the Company may, at its option, establish the personal data protection policy which has been verified and endorsed by relevant regulatory authorities and transmit or transfer personal data to Tiffany's Show Group of Companies in accordance with the personal data protection policy in lieu of compliance with the applicable law.`,
          cn: `公司可选择实施经相关法律机构检查和认证的个人信息保护政策，并按照上述个人信息保护政策而不是按照法律规定的方式向国外的蒂芙尼秀集团公司发送或传输个人信息。`,
          th: `บริษัทอาจเลือกใช้วิธีการดำเนินการให้มีนโยบายการคุ้มครองข้อมูลส่วนบุคคลที่ได้รับการตรวจสอบและรับรองจากผู้มีอำนาจตามกฎหมายที่เกี่ยวข้องและจะดำเนินการให้การส่งหรือโอนข้อมูลส่วนบุคคลไปยังกลุ่มบริษัททิฟฟานี่โชว์ที่อยู่ต่างประเทศเป็นไปตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลดังกล่าวแทนการดำเนินการตามที่กฎหมายกำหนดไว้ก็ได้`,
        },
        sub88: {
          en: `6. Retention Period and Storage Location of Personal Data`,
          cn: `6. 存储期限及个人信息存储位置`,
          th: `6. ระยะเวลาจัดเก็บ และสถานที่จัดเก็บข้อมูลส่วนบุคคล`,
        },
        sub89: {
          en: `The Company will retain personal data as long as it is necessary by taking into consideration the purposes and necessity of the Company’s collection and processing as well as compliance with the legal requirements governing such matters.`,
          cn: `公司将根据需求保存个人信息，并须考虑到公司存储、收集和处理个人信息的目的和需求，包括遵守上述事项中适用法律的要求。公司将在您与公司签订的合同到期后一段时间内保存您的个人信息，其期限符合相关法律规定的期限和时效。`,
          th: `บริษัทจะจัดเก็บข้อมูลส่วนบุคคลตราบเท่าที่จำเป็น โดยคำนึงถึงวัตถุประสงค์และความจำเป็นที่บริษัทจะต้องดำเนินการจัดเก็บรวบรวมและประมวลผล ซึ่งรวมไปถึงการปฏิบัติตามข้อกำหนดของกฎหมายที่ใช้บังคับในเรื่องดังกล่าว บริษัทจะจัดเก็บข้อมูลส่วนบุคคลไว้หลังระยะเวลาที่สัญญาที่ท่านได้ทำไว้กับบริษัทสิ้นผลบังคับระยะเวลาหนึ่ง และสอดคล้องตามระยะเวลาและอายุความของกฎหมายที่เกี่ยวข้อง โดยบริษัทจะจัดเก็บไว้ในสถานที่จัดเก็บที่เหมาะสมตามประเภทของข้อมูลส่วนบุคคล ทั้งนี้บริษัทจำเป็นต้องเก็บข้อมูลส่วนบุคคลต่อไปแม้จะพ้นกำหนดอายุความตามกฎหมายแล้วก็ตาม เช่น กรณีอยู่ระหว่างการดำเนินคดีหรือพิจารณาคดีตามกฎหมาย เป็นต้น ทั้งนี้ตามนโยบายการเก็บรักษาข้อมูลส่วนบุคคลของบริษัท (Data Retention Policy)`,
        },
        sub90: {
          en: `The Company will retain personal data for a certain period after expiration of the contract made between you and the Company in conformity with relevant duration and statute of limitations. Such personal data will be retained in appropriate locations according types of data. The Company may have to further retain personal data after the statute of limitations such as during legal proceedings or litigation subject to the Company’s Data Retention Policy. The Company will take appropriate steps to delete or destroy or anonymize your personal data according to the retention period specified above under the Data Disposal Policy.`,
          cn: `公司将根据个人信息的类型将其存储在适当的存储位置。因此，即使法定时效到期后，公司也必须保留个人信息。例如，若在案件审理或依法受理审判期间等。因此，根据公司个人信息保留政策（Data Retention Policy）。公司将根据个人信息删除政策（Data Disposal Policy）在上述个人信息保留期限内采取适当措施以便删除或销毁您的个人信息或使得您的个人信息无法识别。`,
          th: `บริษัทจะมีการดำเนินการในขั้นตอนอันเหมาะสม เพื่อทำการลบหรือทำลาย หรือทำให้ ข้อมูลส่วนบุคคลของท่านเป็นข้อมูลที่ไม่สามารถระบุตัวเจ้าของข้อมูล ตามระยะเวลาเก็บรักษาข้อมูลส่วนบุคคลข้างต้น ตามนโยบายการลบข้อมูลส่วนบุคคล (Data Disposal Policy)`,
        },
        sub91: {
          en: `7. Use of Personal Data for Marketing Purposes `,
          cn: `7. 更正信息的权利`,
          th: `7. การใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ทางการตลาด`,
        },
        sub92: {
          en: `In addition to the purposes mentioned above and subject to the legal requirements, the Company may use your personal data for marketing purposes such as delivery of promotional documents by post, email and any other means and deploying direct marketing to enhance benefits of the data subject as the Company’s customer through introduction of relevant products and services. You may opt out any communication for marketing purposes from the Company, except for any relevant and necessary communications and/or services provided for you by the Company.`,
          cn: `除了上述目的之外须遵守法律要求，公司将出于营销目的使用个人信息。例如，通过邮寄、电子邮件和任何其他方式发送有关各种促销文件，包括直接营销业务。通过推荐相关产品和服务增加个人信息所有者从公司客户中获取权益 您可以选择不接收公司出于营销目的的通讯，除了公司向您提供相关且必要的通信和/或服务之外。`,
          th: `นอกจากวัตถุประสงค์ดังกล่าวข้างต้นและภายใต้ข้อกำหนดของกฎหมาย บริษัทจะใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ทางการตลาด เช่น การจัดส่งเอกสารเกี่ยวกับโปรโมชั่นต่าง ๆ ทางไปรษณีย์ อีเมล และด้วยวิธีการอื่นใด รวมถึงการดำเนินการด้านการตลาดแบบตรง เพื่อเพิ่มสิทธิประโยชน์ที่เจ้าของข้อมูลส่วนบุคคลจะได้รับจากการเป็นลูกค้าของบริษัทผ่านการแนะนำผลิตภัณฑ์และบริการที่เกี่ยวข้อง ท่านสามารถเลือกที่จะไม่รับการสื่อสารเพื่อวัตถุประสงค์ทางการตลาดจากบริษัท ยกเว้นการติดต่อสื่อสารที่เกี่ยวข้องและจำเป็น และ/หรือบริการที่บริษัทได้ให้แก่ท่าน`,
        },
        sub93: {
          en: `8. Safeguarding Personal Data`,
          cn: `8. 个人信息保护`,
          th: `8. การคุ้มครองข้อมูลส่วนบุคคล`,
        },
        sub94: {
          en: `The Company will properly keep and maintain your personal data according to the administrative safeguard measures, technical safeguard measures and physical safeguard measures in order to provide appropriate security of personal data processing based on confidentiality, integrity and availability as well as prevention of personal data breach. The Company has established personal data protection policies, rules and criteria such as information technology security standards and preventive measures against misuse or malicious disclosure or unauthorized or unlawful use or disclosure. The Company may update such policies, rules and criteria from time to time as deemed reasonable and necessary.`,
          cn: `为了在个人信息处理过程中保持适当的安全性，公司将会根据管理预防措施（administrative safeguard）、技术保障措施（technical safeguard）和物理保护措施（physical safeguard）妥善保存您的个人信息。这意味着严格保密（confidentiality）、准确完整（integrity）和随时提供可用的信息（availability）并防止侵犯个人信息。公司制定了保护个人信息的政策、法规和标准。例如，信息技术安全标准和防止公司信息接收者在预期目的之外未经授权或非法使用或披露信息的措施。公司已根据需求合理定期调整上述政策、法规和标准。`,
          th: `บริษัทจะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้เป็นอย่างดีตามมาตรการป้องกันด้านการบริหารจัดการ (administrative safeguard) มาตรการป้องกันด้านเทคนิค (technical safeguard) และมาตรการป้องกันทางกายภาพ (physical safeguard) เพื่อรักษาความมั่นคงปลอดภัยในการประมวลผลข้อมูลส่วนบุคคลที่เหมาะสม หมายความว่า มีการธำรงไว้ซึ่งความลับ (confidentiality) ความถูกต้องครบถ้วน (integrity) และให้ข้อมูลอยู่ในลักษณะที่พร้อมใช้งาน (availability) และเพื่อป้องกันการละเมิดข้อมูลส่วนบุคคล โดยบริษัท ได้กำหนดนโยบาย ระเบียบ และหลักเกณฑ์ในการคุ้มครองข้อมูลส่วนบุคคล เช่น มาตรฐานความปลอดภัยของระบบเทคโนโลยีสารสนเทศ และมาตรการเพื่อป้องกันไม่ให้ผู้รับข้อมูลไปจากบริษัท ใช้หรือเปิดเผยข้อมูลนอกวัตถุประสงค์ หรือโดยไม่มีอำนาจหรือโดยไม่ชอบ และบริษัท ได้มีการปรับปรุงนโยบาย ระเบียบ และหลักเกณฑ์ดังกล่าวเป็นระยะ ๆ ตามความจำเป็นและเหมาะสม`,
        },
        sub95: {
          en: `The Company has put in place the data subject’s privacy protection by restricting the right to access personal data of the data subject to only personnel who uses such data on a need-to-know basis to introduce products and render services of the Company such as employees and representatives. Any person permitted by the Company to access personal data shall strictly adhere and comply with the Company’s personal data protection measures. As for personal data confidentiality, the Company has implemented both physical and electronic protection measures in accordance with the regulatory standards governing personal data protection.`,
          cn: `公司有措施保护个人信息所有者的隐私，通过限制访问个人信息所有者的个人信息权限，仅限向有必要使用上述个人信息来展示公司产品和提供服务的个人。例如，公司允许访问该个人信息的员工、代理人都须秉承并严格遵守公司个人信息保护措施以及维护上述个人信息的机密性。公司应根据适用的监管标准来制定物理和电子防护措施来保护个人信息。`,
          th: `บริษัท มีมาตรการปกป้องความเป็นส่วนตัวของเจ้าของข้อมูลส่วนบุคคล โดยการจำกัดสิทธิ์การเข้าถึงข้อมูลส่วนบุคคลของเจ้าของข้อมูลส่วนบุคคล จะกำหนดให้เฉพาะบุคคลที่จำเป็นต้องใช้ข้อมูลส่วนบุคคลดังกล่าวในการนำเสนอสินค้า และเพื่อการให้บริการของบริษัท เช่น พนักงาน ตัวแทน ซึ่งบุคคลที่บริษัทอนุญาตให้เข้าถึงข้อมูลส่วนบุคคลนั้น จะต้องยึดมั่นและปฏิบัติตามมาตรการการปกป้องข้อมูลส่วนบุคคลของบริษัทอย่างเคร่งครัด ตลอดจนการรักษาความลับของข้อมูลส่วนบุคคลดังกล่าว โดยบริษัทมีมาตรการป้องกันทั้งทางกายภาพและทางอิเล็กทรอนิกส์เป็นไปตามมาตรฐานการกำกับดูแลที่บังคับใช้เพื่อปกป้องข้อมูลส่วนบุคคล`,
        },
        sub96: {
          en: `Upon executing any contract or agreement with any third party, the Company will establish personal data security and confidentiality measures to ensure that personal data possessed by the Company is secure.`,
          cn: `当公司于第三方签订合同或协议，公司为了确保公司所掌握的个人信息安全将制定适当个人信息的安全和保密措施。`,
          th: `เมื่อบริษัททำสัญญา หรือ ข้อตกลงกับบุคคลที่สาม บริษัทจะกำหนดมาตรการรักษาความปลอดภัยของข้อมูลส่วนบุคคล การรักษาข้อมูลที่เป็นความลับที่เหมาะสม เพื่อให้มั่นใจว่าข้อมูลส่วนบุคคลที่บริษัทครอบครองจะมีความปลอดภัย`,
        },
        sub97: {
          en: `9. Rights of the Data Subject`,
          cn: `9. 个人信息所有者的权利`,
          th: `9. สิทธิของเจ้าของข้อมูลส่วนบุคคล`,
        },
        sub98: {
          en: `Your rights as the data subject are the legal rights provided to you. You may request for exercise of any right subject to the legal requirements and this Policy applied at the time being or any subsequent amendment or any criteria specified by the Company.`,
          cn: `您的权利是您应该了解的合法权利，您可以申请行使法律规定下的各种权利和目前或未来额外制定的政策以及公司规定的标准。`,
          th: `สิทธิของท่าน เป็นสิทธิตามกฎหมายที่ท่านควรทราบ โดยท่านสามารถขอใช้สิทธิต่าง ๆ ได้ภายใต้ข้อกำหนดของกฎหมาย และนโยบายที่กำหนดไว้ในขณะนี้ หรือที่จะมีการแก้ไขเพิ่มเติมในอนาคต ตลอดจนหลักเกณฑ์ตามที่บริษัท กำหนดขึ้น`,
        },
        sub99: {
          en: `1. Right to Withdraw Consent`,
          cn: `1. 撤回同意的权利`,
          th: `1. สิทธิขอถอนความยินยอม`,
        },
        sub100: {
          en: `If you have given your consent to the Company to collect, use and disclose your personal data (whether such consent has been given prior to the effective date of the PDPA or thereafter), you have the right to withdraw such consent at any time while your personal data is retained by the Company, except that there is any restriction of right under the law or any contract inuring to you.`,
          cn: `若您已同意让公司收集、使用和披露您的个人信息（不管是个人信息保护法实施之前或之后您给予的同意）；在您的个人信息存放在公司期间，您有权随时撤回您的同意，除了法律对该权利有限制或有对您有利的合同之外。`,
          th: `หากท่านได้ให้ความยินยอมให้บริษัท เก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลท่าน (ไม่ว่าจะเป็นความยินยอมที่ท่านให้ไว้ก่อนวันที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลใช้บังคับหรือหลังจากนั้น) ท่านมีสิทธิที่จะถอนความยินยอมเมื่อใดก็ได้ตลอดระยะเวลาที่ข้อมูลส่วนบุคคลของท่านอยู่กับบริษัท เว้นแต่มีข้อจำกัดสิทธินั้นโดยกฎหมายหรือมีสัญญาที่ให้ประโยชน์แก่ท่านอยู่`,
        },
        sub101: {
          en: `2. Right to Access`,
          cn: `2. 访问信息的权利`,
          th: `2. สิทธิขอเข้าถึงข้อมูล`,
        },
        sub102: {
          en: `You have the right to request access your personal data held by the Company and ask the Company to provide you with a copy of such data and disclose how the Company obtains your personal data without your consent.`,
          cn: `您有权要求访问由公司负责的您的个人信息并要求公司为您复印上述信息，其中包含未经您的同意公司如何披露您的个人信息。`,
          th: `ท่านมีสิทธิขอเข้าถึงข้อมูลส่วนบุคคลของท่านที่อยู่ในความรับผิดชอบของบริษัท และขอให้บริษัท ทำสำเนาข้อมูลดังกล่าวให้แก่ท่าน รวมถึงขอให้บริษัท เปิดเผยว่าข้อมูลส่วนบุคคลของท่านนั้นได้มาอย่างไรโดยปราศจากความยินยอมของท่าน`,
        },
        sub103: {
          en: `3. Right to Data Portability`,
          cn: `3. 信息转移的权利`,
          th: `3. สิทธิขอถ่ายโอนข้อมูล`,
        },
        sub104: {
          en: `You have the right to obtain personal data held by the Company in a structured format that is readable or usable by automated tools or equipment, and usable or disclosable by any automated means. You also have the right to ask the Company to transmit or transfer such format of your personal data to other data controllers when it can be done by any automated means and to obtain personal data in the same format sent by the Company to other data controllers, except where it is not possible to do so for a technical reason.`,
          cn: `若公司将信息制作成公众可以通过自动化工具或设备可轻松读取或使用的格式，并可以通过自动方式使用或披露个人信息，其中包含有权要求公司以上述格式将个人信息向其他个人信息控制者发送或转移。当可以通过自动方式完成时，有权获取公司以上述格式将个人信息向其他个人信息控制者发送或转移；有权要求公司直接向其他个人信息控制者发送或传输个人信息，除非因技术原因无法继续执行。您有权索取您的个人信息。`,
          th: `ท่านมีสิทธิขอรับข้อมูลส่วนบุคคลของท่านในกรณีที่บริษัท ได้ทำให้ข้อมูลนั้นอยู่ในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติและสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ รวมทั้งมีสิทธิขอให้บริษัท ส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นเมื่อสามารถทำได้ด้วยวิธีการอัตโนมัติ และมีสิทธิขอรับข้อมูลส่วนบุคคลที่บริษัท ส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นโดยตรง เว้นแต่ไม่สามารถดำเนินการได้เพราะเหตุทางเทคนิค`,
        },
        sub105: {
          en: `4. Right to Object`,
          cn: `4. 反对的权利`,
          th: `4. สิทธิขอคัดค้าน`,
        },
        sub106: {
          en: `You have the right to object at any time where collection, use and disclosure of personal data is intended for any necessary operation under the legitimate interests of the Company or of other persons or for any operation under the public interest. In case of your objection, the Company will continue collecting, using and disclosing your personal data to the extent that it can be reasonably and legally demonstrated that the grounds for the processing override your fundamental rights or are intended for verification, legal compliance or legal defense, as the case may be.`,
          cn: `若为了公司或其他人的合法权益或为了公共利益，您的个人信息被收集、使用和披露；若您提出反对，公司仍继续收集、使用和披露您的个人信息，可以在法律上证明比您的基本权利更重要或为了确认遵守法律或视情况依法提起诉讼；您有权随时反对。`,
          th: `ท่านมีสิทธิขอคัดค้านในเวลาใดก็ได้ หากการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านที่ทำขึ้นเพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัท หรือของบุคคลอื่น หรือเพื่อดำเนินการตามภารกิจเพื่อสาธารณประโยชน์ หากท่านยื่นคัดค้าน บริษัท จะยังคงดำเนินการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านต่อไปเฉพาะที่บริษัท สามารถแสดงเหตุผลตามกฎหมายได้ว่ามีความสำคัญยิ่งกว่าสิทธิขั้นพื้นฐานของท่าน หรือเป็นไปเพื่อการยืนยันการปฏิบัติตามกฎหมาย หรือการต่อสู้ในการฟ้องร้องตามกฎหมาย ตามแต่ละกรณี`,
        },
        sub107: {
          en: `5. Right to Erasure or Destruction`,
          cn: `5. 删除或销毁信息的权利`,
          th: `5. สิทธิขอให้ลบหรือทำลายข้อมูล`,
        },
        sub108: {
          en: `You have the right to request for deletion or destroy or anonymization of your personal data if you reasonably believe that your personal data has been unlawfully collected, used and disclosed or you determine that the Company no longer has to retain your personal data according to the purposes related to this Policy or when you exercised the right of consent withdrawal or objection specified above.`,
          cn: `若您认为您的个人信息的收集、使用和披露违反了相关法律规定；或认为公司没必要为了该份政策相关的目的而保留；或当您行使上述撤回同意的权利或行使反对的权利时，您有权要求删除或销毁您的个人信息或使其信息成为无法识别您个人身份的信息。`,
          th: `ท่านมีสิทธิขอลบหรือทำลายข้อมูลส่วนบุคคลของท่าน หรือทำให้เป็นข้อมูลที่ไม่สามารถระบุตัวท่านได้ หากท่านเชื่อว่าข้อมูลส่วนบุคคลของท่านถูกเก็บรวบรวม ใช้ และเปิดเผยโดยไม่ชอบด้วยกฎหมายที่เกี่ยวข้อง หรือเห็นว่าบริษัท หมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ที่เกี่ยวข้องในนโยบายฉบับนี้ หรือเมื่อท่านได้ใช้สิทธิขอถอนความยินยอมหรือใช้สิทธิขอคัดค้านตามที่แจ้งไว้ข้างต้นแล้ว`,
        },
        sub109: {
          en: `6. Right to Restriction of Use`,
          cn: `6. 暂停信息使用的权利`,
          th: `6. สิทธิขอให้ระงับการใช้ข้อมูล`,
        },
        sub110: {
          en: `You have the right to temporarily restrict the use of your personal data when the Company is in the process of checking your request for rectification or objection or in any other case that the Company no longer uses and is required to delete or destroy your personal data according to relevant laws, but you ask the Company to restrict the use instead.`,
          cn: `若根据您提出的行使变更个人信息或反对权利的请求公司目前正在处于调查期间或公司没必要并根据相关法律规定必须删除或销毁您的个人信息，但您要求公司停止使用代替；您有权要求暂停停止使用您的个人信息。`,
          th: `ท่านมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคลชั่วคราวในกรณีที่บริษัท อยู่ระหว่างตรวจสอบตามคำร้องขอใช้สิทธิขอแก้ไขข้อมูลส่วนบุคคลหรือขอคัดค้านของท่าน หรือกรณีอื่นใดที่บริษัท หมดความจำเป็นและต้องลบหรือทำลายข้อมูลส่วนบุคคลของท่านตามกฎหมายที่เกี่ยวข้องแต่ท่านขอให้บริษัท ระงับการใช้แทน`,
        },
        sub111: {
          en: `7. Right to Rectification`,
          cn: `7. 更正信息的权利`,
          th: `7. สิทธิขอให้แก้ไขข้อมูล`,
        },
        sub112: {
          en: `You have the right to rectify your personal data to keep it updated, complete and prevent any misleading.`,
          cn: `您有权要求更正您的个人信息，使其准确、最新、完成且不会造成误解。`,
          th: `ท่านมีสิทธิขอแก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด`,
        },
        sub113: {
          en: `8. Right Lodge A Complaint`,
          cn: `8. 投诉的权利`,
          th: `8. สิทธิร้องเรียน`,
        },
        sub114: {
          en: `You have the right to lodge a complaint to relevant authorities if you reasonably believe that collection, use and/or disclosure of your personal data violates or is non-conforming to the applicable laws.`,
          cn: `若您认为收集、使用或披露您的个人信息，其行为违反或不遵守相关法律的规定，您有权向授权部门投诉。`,
          th: `ท่านมีสิทธิร้องเรียนต่อหน่วยงานผู้มีอำนาจ หากท่านเชื่อว่าการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านเป็นการกระทำในลักษณะที่ฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายที่เกี่ยวข้อง`,
        },
        sub115: {
          en: `Name: Permanent Secretary Office of Ministry of Digital Economy and Society acts as the Office of Personal Data Protection Commission.`,
          cn: `名称：数字经济和社会部常务秘书办公室履行个人信息保护委员会办公室的职责`,
          th: `ชื่อ: สำนักงานปลัดกระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม ทำหน้าที่ สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล`,
        },
        sub116: {
          en: `Address: 120, Village No. 3, Government Complex, Ratthaprasasana Phakdi Building (Building B), 7th Floor, Chaeng Watthana Road, Thung Song Hong Sub-district, Lak Si District, Bangkok 10210`,
          cn: `地址:曼谷剌斯区通颂宏街道办桨瓦塔纳路3村120号纪念国王陛下80岁生日市政中心拉塔巴萨纳帕帝（B栋）7楼  邮政编码10210`,
          th: `ที่อยู่: 120 หมู่ 3 ศูนย์ราชการเฉลิมพระเกียรติ 80 พรรษาฯ อาคารรัฐประศาสนภักดี (อาคารบี) ชั้น 7 ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพฯ 10210`,
        },
        sub117: {
          en: `Contact information: E-mail: pdpc@mdes.go.th`,
          cn: `联系方式: e-mail : pdpc@mdes.go.th`,
          th: `ช่องทางการติดต่อ: e-mail : pdpc@mdes.go.th`,
        },
        sub118: {
          en: `Tel. 02 141 6993, 02 142 1033`,
          cn: `电话: 02 141 6993, 02 142 1033`,
          th: `โทร: 02 141 6993, 02 142 1033`,
        },
        sub119: {
          en: `9. Exercise of Rights`,
          cn: `9. 权利行使`,
          th: `9. การใช้สิทธิ`,
        },
        sub120: {
          en: `You may exercise any of the rights mentioned above by filling and submitting the Application Form for Exercise of Rights to the responsible unit or request for exercise of rights via the website. However, your exercise of rights may be limited by relevant laws and in certain circumstances, the Company may reject or be unable to proceed your request due to compliance with the law or court’s order, for public interest or because such exercise of rights may harm the rights or freedoms of other persons. In case of any rejection of such request, the Company will clarify you the reason of such rejection.`,
          cn: `您可以通过填写权利行使申请表并向负责机构提交申请来行使上述权利，其中包含通过网站申请行使权利。您行使权利可能会受到相关法律的限制，在某些情况下公司可能会拒绝或无法按您上述行使权利申请进行处理。例如，为了公共利益必须遵守法律或法院判决。权利行使可能会对他人的权利或自由等受影响或损害。`,
          th: `การใช้สิทธิของท่านดังกล่าวข้างต้นสามารถทำได้โดยกรอกแบบฟอร์มคำร้องขอใช้สิทธิและยื่นคำร้องต่อหน่วยงานที่รับผิดชอบ รวมถึงการขอใช้สิทธิผ่านทาง website อย่างไรก็ตามการใช้สิทธิของท่านอาจถูกจำกัดภายใต้กฎหมายที่เกี่ยวข้อง และมีบางกรณีที่มีเหตุจำเป็นที่บริษัท อาจปฏิเสธหรือไม่สามารถดำเนินการตามคำขอใช้สิทธิข้างต้นของท่านได้ เช่น ต้องปฏิบัติตามกฎหมายหรือคำสั่งศาล เพื่อประโยชน์สาธารณะ การใช้สิทธิอาจจะส่งผลกระทบที่อาจก่อให้เกิดความเสียหายต่อสิทธิหรือเสรีภาพของบุคคลอื่น เป็นต้น โดยหากบริษัท ปฏิเสธคำขอข้างต้น บริษัท จะแจ้งเหตุผลของการปฏิเสธให้ท่านทราบด้วย`,
        },
        sub121: {
          en: `You may request for exercise of rights on the website at https://www.tiffany-show.co.th`,
          cn: `若公司拒绝上述请求，公司将告知您拒绝的原因。您可以通过https://www.tiffany-show.co.th网站申请行使您的权利。`,
          th: `ท่านสามารถขอใช้สิทธิได้ผ่านทาง website ได้ ผ่านทาง https://www.tiffany-show.co.th`,
        },
        sub122: {
          en: `Duration of exercise of rights:`,
          cn: `行使各种权利的处理时间`,
          th: `ระยะเวลาดำเนินการในการใช้สิทธิประเภทต่าง ๆ`,
        },
        sub123: {
          en: `Right`,
          cn: `权利`,
          th: `สิทธิ`,
        },
        sub123_1: {
          en: `Duration`,
          cn: `处理时间`,
          th: `ระยะเวลาดำเนินการ`,
        },
        sub124: {
          en: `Right to Withdraw Consent`,
          cn: `撤回同意权利`,
          th: `สิทธิขอถอนความยินยอม`,
        },
        sub124_1: {
          en: `30 Day`,
          cn: `30 天`,
          th: `30 วัน`,
        },
        sub125: {
          en: `Right to Acces`,
          cn: `访问信息的权利`,
          th: `สิทธิขอเข้าถึงข้อมูล`,
        },
        sub125_1: {
          en: `60 Day`,
          cn: `60 天`,
          th: `60 วัน`,
        },
        sub126: {
          en: `Right to Data Portability`,
          cn: `信息转移的权利`,
          th: `สิทธิขอถ่ายโอนข้อมูล`,
        },
        sub126_1: {
          en: `60 Day`,
          cn: `60 天`,
          th: `60 วัน`,
        },
        sub127: {
          en: `Right to Object`,
          cn: `反对的权利`,
          th: `สิทธิขอคัดค้าน`,
        },
        sub127_1: {
          en: `60 Day`,
          cn: `60 天`,
          th: `60 วัน`,
        },
        sub128: {
          en: `Right to Erasure or Destruction`,
          cn: `删除或销毁信息的权利`,
          th: `สิทธิขอให้ลบหรือทำลายข้อมูล`,
        },
        sub128_1: {
          en: `60 Day`,
          cn: `60 天`,
          th: `60 วัน`,
        },
        sub129: {
          en: `Right to Restriction of Use`,
          cn: `暂停信息使用的权利`,
          th: `สิทธิขอให้ระงับการใช้ข้อมูล`,
        },
        sub129_1: {
          en: `60 Day`,
          cn: `60 天`,
          th: `60 วัน`,
        },
        sub130: {
          en: `Right to Rectification`,
          cn: `更正信息的权利`,
          th: `สิทธิขอให้แก้ไขข้อมูล`,
        },
        sub130_1: {
          en: `30 Day`,
          cn: `30 天`,
          th: `30 วัน`,
        },
        sub131: {
          en: `Erasure or destruction or anonymization of your personal data or withdrawal of your consent may be done subject to the legal requirements and contract made with the Company only. Exercise of such rights may affect the performance of the contract made with the Company or provision of other services because it is unable to identify the data subject and there may be restrictions to provision of certain services requiring personal data. As a result, the data subject may not be provided with benefits, services and news and information from the Company.`,
          cn: `此外，删除或销毁或使得您的个人信息处于无法识别个人信息所有者身份的模式；或撤回个人信息所有者的同意仅限在法律规定以及与公司签订的合同项下进行。因此，上述权利行使因无法识别个人信息所有者的身份可能会对履行公司签订的合同或其他服务案例有影响。因此，对提供某些需要使用个人信息的服务可能会受限制，还可能会导致个人信息所有者无法获得服务权益及继续收到公司的新消息。`,
          th: `อนึ่ง การลบหรือทำลาย หรือทำให้ข้อมูลส่วนบุคคลของท่านอยู่ในรูปแบบที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้ หรือการยกเลิกความยินยอมของเจ้าของข้อมูลส่วนบุคคลสามารถทำได้ภายใต้ข้อกำหนดของกฎหมายและสัญญาที่ทำไว้กับบริษัท เท่านั้น ทั้งนี้ การใช้สิทธิดังกล่าวอาจจะส่งผลต่อกรณีการปฏิบัติตามสัญญาที่ทำไว้กับบริษัท หรือกรณีการให้บริการอื่น ๆ เนื่องจากจะไม่สามารถระบุตัวตนของเจ้าของข้อมูลส่วนบุคคลได้ จึงอาจเกิดข้อจำกัดในการให้บริการในบางส่วนที่จำเป็นต้องใช้ข้อมูลส่วนบุคคล และอาจทำให้เจ้าของข้อมูลส่วนบุคคลนั้นไม่ได้รับสิทธิประโยชน์การบริการ และข่าวสารจากบริษัทต่อไป`,
        },
        sub132: {
          en: `10. Links to Third-Party Websites`,
          cn: `10. 外部网站链接`,
          th: `10. การเชื่อมต่อไปยังเว็บไซต์ภายนอก`,
        },
        sub133: {
          en: `The Company’s websites may be linked to any third-party websites that may have different personal data protection policies. It is recommended that the data subject always familiarizes with those websites’ personal data protection policies to thoroughly understand the details thereof and make decisions on disclosure of personal data. The Company will not be liable for any content, policy, damage or an y act arising from any third-party website.`,
          cn: `公司网站可能包含第三方网站链接，这些网站的个人信息保护政策可能与公司的不同，个人信息所有者应研究该网站的个人信息政策，以便了解个人信息保护详情和决定个人信息的披露。因此，公司将对第三方的网站内容、政策、损害或行为不承担任何责任。`,
          th: `เว็บไซต์ของบริษัทจะมีการเชื่อมต่อไปยังเว็บไซต์ของบุคคลที่สามซึ่งเว็บไซต์เหล่านั้นอาจมีนโยบายคุ้มครองข้อมูลส่วนบุคคลที่แตกต่างจากของบริษัท ขอให้เจ้าของข้อมูลส่วนบุคคลศึกษานโยบายข้อมูลส่วนบุคคลของเว็บไซต์นั้น ๆ เพื่อเข้าใจถึงรายละเอียดการคุ้มครองข้อมูลส่วนบุคคล และเพื่อตัดสินใจในการเปิดเผยข้อมูลส่วนบุคคล ทั้งนี้ บริษัทจะไม่รับผิดชอบต่อเนื้อหา นโยบาย ความเสียหาย หรือการกระทำอันเกิดจากเว็บไซต์ของบุคคลที่สาม`,
        },
        sub134: {
          en: `11. Cookie Policy`,
          cn: `11. Cookie 政策`,
          th: `11. นโยบายคุกกี้`,
        },
        sub135: {
          en: `This Cookie Policy applies to cookies and other similar technologies used on the Company’s websites. This Policy is aimed at notifying you of information on cookies and their functions. This Cookie Policy also describes cookies used by the Company, their functions and how to manage your cookies.`,
          cn: `该Cookie 政策使用的Cookie和其他技术与公司网站使用的类似，该政策目的是告知您有关Cookie的信息和Cookie的工作原理，该Cookie政策还说明了公司使用的Cookie的功能和如何管理您的Cookie。`,
          th: `นโยบายคุกกี้นี้ ใช้กับคุกกี้และเทคโนโลยีอื่นที่ทำหน้าที่คล้ายคลึงกันที่ใช้งานบนเว็บไซต์ของบริษัท วัตถุประสงค์ของนโยบายนี้ เพื่อจะแจ้งให้ท่านทราบข้อมูลเกี่ยวกับคุกกี้ และการทำงานของคุกกี้ นโยบายคุกกี้นี้ยังอธิบายถึงคุกกี้ที่บริษัทใช้ หน้าที่ของคุกกี้ และวิธีการจัดการคุกกี้ของท่าน`,
        },
        sub136: {
          en: `The Company’s websites will use cookies to ensure that you have been provided with desirable experience while using the websites and enable to the Company to enhance the websites’ effectiveness. These cookies will not harm any device of users and their contents will be operated or viewed only on the websites generating such cookies.`,
          cn: `公司网站使用Cookie为您提供良好的网站使用体验和帮助公司进一步优化其网站Cookie。该Cookie不会对用户的设备造成任何损害，该Cookie的内容只限创建上述Cookie网站检索或读取。`,
          th: `เว็บไซต์ของบริษัทจะใช้คุกกี้เพื่อให้ท่านได้รับประสบการณ์ที่ดีจากการใช้งานเว็บไซต์ และช่วยให้บริษัทสามารถเพิ่มประสิทธิภาพของเว็บไซต์ให้ดียิ่งขึ้น ซึ่งคุกกี้จะไม่ก่อให้เกิดอันตรายต่ออุปกรณ์ของผู้ใช้งาน และเนื้อหาในคุกกี้จะถูกเรียกออกมาใช้งานหรืออ่านได้เฉพาะเว็บไซต์ที่สร้างคุกกี้ดังกล่าวเท่านั้น`,
        },
        sub137: {
          en: `1. Types of Cookies Used by the Company and Duration`,
          cn: `1. 公司使用的 cookie 类型及其有效持续时间`,
          th: `1. ประเภทของคุกกี้ที่บริษัทใช้และระยะเวลาการทำงานของคุกกี้`,
        },
        sub138: {
          en: `The Company uses 4 types of cookies including Strictly Necessary Cookies, Analytical / Performance Cookies, Functionality Cookies and Targeting Cookie. These cookies have different functions as detailed below.`,
          cn: `公司使用4种类型的Cookie分别为必要类型Cookie（Strictly Necessary Cookies）、分析、衡量网站性能类型Cookie（Analytical / Performance Cookies）、网站功能类型Cookie（Functionality Cookies）和选择适合目标群体的内容类型 Cookie    （Targeting Cookies）。这些Cookie如下所述执行不同的功能；`,
          th: `บริษัทใช้คุกกี้ทั้งหมด 4 ประเภท ได้แก่ คุกกี้ประเภทที่มีความจำเป็นอย่างยิ่ง (Strictly Necessary Cookies) คุกกี้เพื่อการวิเคราะห์ / วัดผลการทำงานของเว็บไซต์ (Analytical / Performance Cookies) คุกกี้เพื่อการทำงานของเว็บไซต์ (Functionality Cookies) และคุกกี้เพื่อคัดเลือกเนื้อหาให้เข้ากับกลุ่มเป้าหมาย (Targeting Cookies) คุกกี้เหล่านี้ทำหน้าที่แตกต่างกันตามที่ได้อธิบายไว้ในหัวข้อด้านล่าง`,
        },
        sub139: {
          en: `The Company also uses the First-Party Cookies and the Third-Party Cookies. The First-Party Cookies are cookie files generated and stored on the website you are visiting. This type of cookie will be read by the website that generates and records your data only. The Third-Party Cookies are cookie files generated and stored by different domains on the website you are visiting and may independently share cookie files recording your data to any websites.`,
          cn: `公司使用第一方Cookie (First-Party Cookies)和第三方Cookie (Third-Party Cookies)：第一方Cookie是您正在访问的网站创建并记录的Cookie文件，该类型Cookie只限由创建并记录您的信息的网站读取；第三方Cookie是您正在访问的网站不同域名创建并记录的Cookie文件，您可以自由地与任何网站共享记录您信息的Cookie文件。`,
          th: `บริษัทใช้งานคุกกี้ของบุคคลที่หนึ่ง (First-Party Cookies) และคุกกี้ของบุคคลที่สาม (Third-Party Cookies) คุกกี้ของบุคคลที่หนึ่งคือไฟล์คุกกี้ที่ถูกสร้างและบันทึกข้อมูลด้วยเว็บไซต์ที่ท่านกำลังเยี่ยมชม คุกกี้ชนิดนี้จะถูกอ่านโดยเว็บไซต์ที่เป็นผู้สร้างและทำการบันทึกข้อมูลของท่านเท่านั้น คุกกี้ของบุคคลที่สาม คือไฟล์คุกกี้ที่ถูกสร้างและบันทึกโดยโดเมนที่แตกต่างจากเว็บไซต์ที่ท่านกำลังเยี่ยมชม และสามารถแบ่งปันไฟล์คุกกี้ที่บันทึกข้อมูลของท่านให้เว็บไซต์ใด ๆ ได้อย่างอิสระ`,
        },
        sub140: {
          en: `In addition, the cookies used by the Company are Session Cookies and Persistent Cookies. Session Cookies are temporary cookie files stored in your device until you leave the Company’s websites. Persistent Cookies remain in your device even though you have closed the Company’s websites or until you delete them (how long the cookies remain in your device depends on the duration or “age” of such cookies and your browser setting).`,
          cn: `此外，公司使用的Cookie是会话Cookie（Session Cookies）和持久Cookie（Persistent Cookies）。会话Cookie是临时Cookie会保留在您的设备上直至您离开公司网站为止；持久Cookie即使您关闭公司网站仍保留在您的设备上或直至您自己删除掉（Cookie会在您的设备上保留多长时间这取决于Cookie有效持续时间或“寿命”以及您浏览器的设置）`,
          th: `นอกจากนี้ คุกกี้ที่บริษัทใช้จะเป็นคุกกี้แบบช่วงเวลา (Session Cookies) และ คุกกี้ถาวร (Persistent Cookies) สำหรับ คุกกี้แบบช่วงเวลาจะเป็นคุกกี้แบบชั่วคราวที่คงอยู่ในอุปกรณ์ของท่านจนกระทั่งท่านออกจากเว็บไซต์ของบริษัท ส่วนคุกกี้ถาวรจะยังคงอยู่ในอุปกรณ์ของท่านแม้ว่าท่านจะปิดเว็บไซต์ของบริษัทไปแล้ว หรือจนกว่าท่านจะลบทิ้งด้วยตนเอง (คุกกี้จะยังคงอยู่ในอุปกรณ์ของท่านนานเพียงใดนั้น ขึ้นอยู่กับระยะเวลา หรือ "อายุ" ของ คุกกี้นั้น ๆ รวมถึงค่าติดตั้งของบราวเซอร์ของท่านด้วย)`,
        },
        sub141: {
          en: `2. Consent`,
          cn: `2. 同意`,
          th: `2. ความยินยอม`,
        },
        sub142: {
          en: `Strictly Necessary Cookies will be always activated on your device based on the legitimate interest of the Company to ensure security of using the Company’s websites. However, the Company will ask for your consent if other types of cookies are used. If you intend to change your cookie setting or withdraw your consent as to processing of personal data based on cookies, please find more details in the Cookies Setting section.`,
          cn: `为了安全使用公司网站，根据公司合法权益原则，您的设备上始终启用必要类型Cookie，但若使用其他类型Cookie，公司将会征求您的同意；若您有意向变更您的Cookie设置或撤回处理Cookie中的个人信息的同意，您可以在Cookie设置标题上了解更多信息。`,
          th: `คุกกี้ประเภทที่มีความจำเป็นอย่างยิ่งจะเปิดใช้งานเสมอบนอุปกรณ์ของท่านตามหลักผลประโยชน์โดยชอบด้วยกฎหมายของบริษัทเพื่อความปลอดภัยในการใช้งานเว็บไซต์ของบริษัท แต่บริษัทจะขอความยินยอมจากท่านหากมีการใช้คุกกี้ประเภทอื่น หากท่านมีความประสงค์จะเปลี่ยนแปลงการตั้งค่าคุกกี้ของท่านหรือถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลจากคุกกี้ ท่านสามารถศึกษาเพิ่มเติมได้ในหัวข้อการตั้งค่าคุกกี้`,
        },
        sub143: {
          en: `3. Use of Cookies`,
          cn: `3. Cookie的使用`,
          th: `3. การใช้งานคุกกี้`,
        },
        sub144: {
          en: `The Company will use cookies when you visit the Company’s websites according to types of cookies as follows:`,
          cn: `当您访问公司网站时，公司将使用Cookie，根据使用性分类如下：`,
          th: `บริษัท จะใช้คุกกี้เมื่อท่านได้เข้าเยี่ยมชมเว็บไซต์ของบริษัท โดยแบ่งออกตามลักษณะของการใช้งานได้ดังนี้`,
        },
        sub145: {
          en: `Strictly Necessary Cookies: This type of cookie is required for the website’s basic functions and facilitates you to safely access and use the Company’s websites.`,
          cn: `必要类型Cookie（Strictly Necessary Cookies）:该类型Cookie对于网站正常运行至关重要，其中包含允许您安全地访问信息和使用公司网站的Cookie`,
          th: `คุกกี้ประเภทที่มีความจำเป็นอย่างยิ่ง (Strictly Necessary Cookies) : คุกกี้ประเภทนี้มีความสำคัญต่อการทำงานของเว็บไซต์ ซึ่งรวมถึงคุกกี้ที่ทำให้ท่านสามารถเข้าถึงข้อมูลและใช้งานในเว็บไซต์ของบริษัทได้อย่างปลอดภัย`,
        },
        sub146: {
          en: `Analytical / Performance Cookies: This type of cookie tracks your usage information on the websites to enable the Company to measure, evaluate, improve and/or develop contents, products/services and websites of the Company in order to provide you with better website visiting experience and collect statistical data concerning usage method and visiting behaviors to improve the websites’ performance and facilitate data search.`,
          cn: `分析、衡量网站性能类型Cookie（Analytical / Performance Cookies）:该类型Cookie存储有关您使用网站的信息，使得公司能够衡量、评估、改进和/或开发产品/服务和公司网站的内容，增加使用您网站的良好体验。此外，还收集有关如何使用和访问网站的统计信息，有助于改进网站功能，使得用户可以轻松找到他们想要的内容。`,
          th: `คุกกี้เพื่อการวิเคราะห์ / วัดผลการทำงานของเว็บไซต์ (Analytical / Performance Cookies) : คุกกี้ประเภทนี้จะเก็บข้อมูลการใช้งานเว็บไซต์ของท่าน เพื่อให้บริษัทสามารถวัดผล ประเมิน ปรับปรุง และ/หรือ พัฒนาเนื้อหาสินค้า / บริการ และเว็บไซต์ของบริษัท เพื่อเพิ่มประสบการณ์ที่ดีในการใช้เว็บไซต์ของท่าน อีกทั้งเพื่อรวบรวมข้อมูลทางสถิติเกี่ยวกับวิธีการเข้าใช้งาน และพฤติกรรมการเยี่ยมชมเว็บไซต์ ซึ่งจะช่วยปรับปรุงการทำงานของเว็บไซต์โดยให้ผู้ใช้งานสามารถค้นหาสิ่งที่ต้องการได้อย่างง่ายดาย`,
        },
        sub147: {
          en: `Functionality Cookies: This type of cookie is used to remember your preferences and choices while using the websites and enables the Company to provide you with contents that serve your needs upon your revisit such as language, geo-location or font without re-filling or re-setting for each revisit.`,
          cn: `网站功能类型Cookie（Functionality Cookies）：该类型Cookie用于识别您身份；当您再次访问使用公司网站时，有助于公司提供内容和响应需求，其中包含记住您的设置，以便轻松、快速地使用。例如，您选择在网站上使用的语言或区域或字体大小，无需在每次您访问使用网站时提供信息或重置设置。`,
          th: `คุกกี้เพื่อการทำงานของเว็บไซต์ (Functionality Cookies) : คุกกี้ประเภทนี้ใช้ในการจดจำตัวท่าน เมื่อท่านกลับมาใช้งานเว็บไซต์ของบริษัทอีกครั้ง ซึ่งจะช่วยให้บริษัทสามารถนำเสนอเนื้อหาและตอบสนองความต้องการ รวมถึงจดจำการตั้งค่าของท่านให้ใช้งานได้ง่ายและรวดเร็วขึ้น อาทิ ภาษา หรือ ภูมิภาค หรือ ขนาดของตัวอักษรที่ท่านเลือกในการใช้งานบนเว็บไซต์โดยไม่ต้องให้ข้อมูลหรือตั้งค่าใหม่ทุกครั้งที่ท่านเข้าใช้งานเว็บไซต์`,
        },
        sub148: {
          en: `Targeting Cookies: This type of cookie is used to track information on your visit to the websites, web pages and links you have visited. It may include your personal data used to create your profile so that the Company may analyze and provide contents, products and/or services and/or advertisements of your preferences.`,
          cn: `选择适合目标群体的内容类型 Cookie（Targeting Cookies）:该类型Cookie将记录您对网站的访问、您访问过的网站和您访问的链接，可能其中包含用于创建有关您个人资料的个人信息，以便公司能够分析和提议您感兴趣的内容、产品和/或服务和/或广告。`,
          th: `คุกกี้เพื่อคัดเลือกเนื้อหาให้เข้ากับกลุ่มเป้าหมาย (Targeting Cookies) : คุกกี้ประเภทนี้จะบันทึกการเข้าชมเว็บไซต์ของท่าน หน้าเว็บที่ท่านได้เยี่ยมชม และลิงค์ที่ท่านเยี่ยมชม ซึ่งอาจรวมถึงข้อมูลส่วนบุคคลของท่านที่ใช้ในการสร้างโปรไฟล์เกี่ยวกับตัวท่าน เพื่อให้บริษัทสามารถวิเคราะห์และนำเสนอเนื้อหา สินค้า และ/หรือ บริการ และ/หรือ โฆษณา ที่ท่านสนใจ`,
        },
        sub149: {
          en: `Third-Party Cookies`,
          cn: `第三方Cookie使用(Third-Party Cookies)`,
          th: `การใช้คุกกี้โดยบุคคลที่สาม (Third-Party Cookies)`,
        },
        sub150: {
          en: `The Company’s websites or application may provide links to any third-party websites or applications. It is recommended that you always familiarize with those websites’ different cookie and privacy policies to thoroughly understand how the third-party website collects and uses your data. The Company will not be liable for any content, policy, damage or any act arising from any third-party website or application.`,
          cn: `公司的网站或应用程序可能有与第三方万丈或应用程序相链接。您应该研究熟悉第三方网站使用Cookie政策和隐私政策，第三方网站可能与公司网站不同，使得能够访问了解第三方如何收集和使用您的信息。因此，公司不会对第三方网站或应用程序造成的任何内容、政策、损害或行为承担任何责任。`,
          th: `เว็บไซต์หรือแอพพลิเคชั่นของบริษัท อาจมีการเชื่อมต่อไปยังเว็บไซต์หรือแอพพลิเคชั่นของบุคคลที่สาม ท่านควรต้องศึกษานโยบายการใช้คุกกี้และนโยบายส่วนบุคคลในเว็บไซต์ของบุคคลที่สาม ซึ่งอาจแตกต่างจากเว็บไซต์ของบริษัทได้ที่เว็บไซต์ของบุคคลที่สามนั้น ๆ เพื่อให้เข้าใจถึงวิธีการที่บุคคลที่สามอาจเก็บ รวบรวมข้อมูลของท่านไปใช้งาน ทั้งนี้ บริษัทจะไม่รับผิดชอบใด ๆ ต่อเนื้อหา นโยบายต่าง ๆ ความเสียหาย หรือการกระทำอันเกิดจากเว็บไซต์หรือแอพพลิเคชั่นของบุคคลที่สาม`,
        },
        sub151: {
          en: `4. Cookies Setting`,
          cn: `4. Cookie设置`,
          th: `4. การตั้งค่าคุกกี้`,
        },
        sub152: {
          en: `You may disable cookies by using the browser setting on your device as follows:`,
          cn: `您可以在您的设备浏览器上设置禁用Cookie，如下所示`,
          th: `ท่านสามารถปิดการทำงานของคุกกี้ได้ โดยการตั้งค่าบราวเซอร์ที่อุปกรณ์ของท่าน ดังนี้`,
        },
        sub153: {
          en: `Cookies Setting in Chrome`,
          cn: `Cookies Setting in Chrome`,
          th: `Cookies Setting in Chrome`,
        },
        sub154: {
          en: `https://support.google.com/chrome/answer/95647?hl=en&ref_topic=14666`,
          cn: `https://support.google.com/chrome/answer/95647?hl=en&ref_topic=14666`,
          th: `https://support.google.com/chrome/answer/95647?hl=en&ref_topic=14666`,
        },
        sub155: {
          en: `Cookies Setting in Firefox`,
          cn: `Cookies Setting in Firefox`,
          th: `Cookies Setting in Firefox`,
        },
        sub156: {
          en: `https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies`,
          cn: `https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies`,
          th: `https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies`,
        },
        sub157: {
          en: `Cookies Setting in Safari`,
          cn: `Cookies Setting in Safari`,
          th: `Cookies Setting in Safari`,
        },
        sub158: {
          en: `https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac)%20and%20iOS%20(https:/support.apple.com/en-us/HT201265`,
          cn: `https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac)%20and%20iOS%20(https:/support.apple.com/en-us/HT201265`,
          th: `https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac)%20and%20iOS%20(https:/support.apple.com/en-us/HT201265`,
        },
        sub159: {
          en: `Cookies Setting in Internet Explorer`,
          cn: `Cookies Setting in Internet Explorer`,
          th: `Cookies Setting in Internet Explorer`,
        },
        sub160: {
          en: `https://support.microsoft.com/en-us/topic/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-10`,
          cn: `https://support.microsoft.com/en-us/topic/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-10`,
          th: `https://support.microsoft.com/en-us/topic/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-10`,
        },
        sub161: {
          en: `By disabling cookies, you may not be able to effectively visit the Company’s websites. For more information, please visit www.aboutcookies.org`,
          cn: `因此，禁用Cookie可能会导致您无法有效地访问公司网站，想了解更多的信息详情，请登入网站www.aboutcookies.org`,
          th: `ทั้งนี้ การปิดการใช้งานคุกกี้อาจส่งผลให้ท่านไม่สามารถเข้าเยี่ยมชมเว็บไซต์ของบริษัทได้อย่างมีประสิทธิภาพ ข้อมูลเพิ่มเติมกรุณาศึกษารายละเอียดได้ที่ www.aboutcookies.org`,
        },
        sub162: {
          en: `12. Data Protection Officer`,
          cn: `12. 个人信息保护工作人员`,
          th: `12. เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล`,
        },
        sub163: {
          en: `The Company has appointed the Data Protection Officer to inspect any operations concerning collection, use or disclosure of personal data in accordance with the Personal Data Protection Act, B.E. 2562 (2019) and the Company’s policies, rules, announcements and orders; to coordinate and cooperate with the Office of Personal Data Protection Commission and perform any other duties as stipulated by the Personal Data Protection Act, B.E. 2562 (2019).`,
          cn: `公司委任个人信息保护工作人员用于检查与收集、使用或披露个人信息相关的程序，并遵守《2019年个人信息保护法》和公司的政策、法规、公告、指令，其中包含与个人信息保护委员会办公室协调和合作工作，并根据《2019年个人信息保护法》承担其他职责。`,
          th: `บริษัทได้แต่งตั้งเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลเพื่อตรวจสอบการดำเนินการที่เกี่ยวกับการเก็บ รวบรวม ใช้ หรือ เปิดเผยข้อมูลส่วนบุคคล ให้สอดคล้องตามพ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 และ นโยบาย ระเบียบ ประกาศ คำสั่ง ของบริษัท รวมทั้งประสานงานและให้ความร่วมมือกับสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล และมีหน้าที่อื่น ๆ ตามที่พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562`,
        },
        sub164: {
          en: `13. Inquiries about this Privacy Policy`,
          cn: `13. 隐私政策相关问题`,
          th: `13. คำถามที่เกี่ยวกับนโยบายความเป็นส่วนตัว`,
        },
        sub165: {
          en: `For any suggestion or inquiry about collection, use and disclosure of your personal data and request for exercise of rights under this Policy, please contact us via e-mail: res@tiffany-show.co.th.`,
          cn: `若您有任何建议或想询问有关您个人信息收集、使用或披露的详细信息，其中包含根据该份政策申请行使权利，您可以通过e-mail: res@tiffany-show.co.th联系公司`,
          th: `หากท่านมีข้อเสนอแนะ หรือต้องการสอบถามข้อมูลเกี่ยวกับรายละเอียดการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่าน รวมถึงการขอใช้สิทธิตามนโยบายฉบับนี้ ท่านสามารถติดต่อบริษัท ผ่านช่องทาง e-mail: res@tiffany-show.co.th`,
        },
        sub166: {
          en: `14. Contact information`,
          cn: `14. 联系方式`,
          th: `14. ช่องทางการติดต่อ`,
        },
        sub167: {
          en: `For any question concerning the Company’s Privacy Policy or personal data collected by the Company or request for exercise of any right under Clause 9 pursuant to the PDPA, please contact: `,
          cn: `若您对公司的隐私政策、公司收集的信息或根据《个人信息保护法》第9条行使任何权利有任何疑问，您可以通过以下方式联系：`,
          th: `หากท่านมีข้อสงสัยเกี่ยวกับนโยบายความเป็นส่วนตัวของบริษัทข้อมูลที่บริษัทเก็บรวบรวม หรือต้องการใช้สิทธิตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลอย่างใดอย่างหนึ่งตามข้อ 9. ท่านสามารถติดต่อมายัง`,
        },
        sub168: {
          en: `Company`,
          cn: `联系公司`,
          th: `ติดต่อบริษัท`,
        },
        sub169: {
          en: `Name: Tiffany’s Show Pattaya Co., Ltd.`,
          cn: `名称: 蒂芙尼秀芭堤雅有限公司`,
          th: `ชื่อ: บริษัท ทิฟฟานี่โชว์ พัทยา จำกัด`,
        },
        sub170: {
          en: `Tiffany’s Show Pattaya Co., Ltd.`,
          cn: `Tiffany’s Show Pattaya Co., Ltd.`,
          th: `Tiffany’s Show Pattaya Co., Ltd.`,
        },
        sub171: {
          en: `Address: 464, Village No. 9, Pattaya 2 Road, Nong Prue Sub-district, Bang Lamung District, Chonburi Province 20260`,
          cn: `地址:春武里府邦拉蒙县侬勒镇芭提雅2路9村464号  邮政编码20260`,
          th: `ที่อยู่ 464 หมู่ 9 ถ.พัทยาสาย 2 ต.หนองปรือ อ.บางละมุง จ.ชลบุรี 20260`,
        },
        sub172: {
          en: `Contact channel: e-mail: res@tiffany-show.co.th`,
          cn: `联系方式: e-mail : res@tiffany-show.co.th`,
          th: `ช่องทางการติดต่อ: e-mail : res@tiffany-show.co.th`,
        },
        sub173: {
          en: `15. Appropriate Authority Contact`,
          cn: `15. 联系授权机构 (Appropriate Authority)`,
          th: `15. ติดต่อหน่วยงานผู้มีอำนาจ (Appropriate Authority)`,
        },
        sub174: {
          en: `For any complaint or unsatisfactory response of the Company, you may contact and/or lodge a complaint to the Office of Personal Data Protection Commission as detailed below:`,
          cn: `若您想要举报投诉或若您觉得公司作出的回应令您不满意，您可以通过如下联系方式联系个人信息保护委员会办公室和或/投诉：`,
          th: `หากท่านต้องการรายงานเรื่องร้องเรียน หรือหากท่านรู้สึกว่าบริษัท ไม่ตอบข้อกังวลของท่านในลักษณะที่น่าพึงพอใจ ท่านสามารถติดต่อและ/หรือร้องเรียนต่อสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลได้ตามรายละเอียดด้านล่าง`,
        },
        sub175: {
          en: `Name: Permanent Secretary Office of Ministry of Digital Economy and Society acts as the Office of Personal Data Protection Commission.`,
          cn: `名称：数字经济和社会部常务秘书办公室履行个人信息保护委员会办公室的职责`,
          th: `ชื่อ:สำนักงานปลัดกระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม ทำหน้าที่ สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล`,
        },
        sub176: {
          en: `Address: 120, Village No. 3, Government Complex, Ratthaprasasana Phakdi Building (Building B), 7th Floor, Chaeng Watthana Road, Thung Song Hong Sub-district, Lak Si District, Bangkok 10210`,
          cn: `地址:曼谷剌斯区通颂宏街道办桨瓦塔纳路3村120号纪念国王陛下80岁生日市政中心拉塔巴萨纳帕帝（B栋）7楼 邮政编码10210`,
          th: `ที่อยู่:120 หมู่ 3 ศูนย์ราชการเฉลิมพระเกียรติ 80 พรรษาฯ อาคารรัฐประศาสนภักดี (อาคารบี) ชั้น 7 ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพฯ 10210`,
        },
        sub177: {
          en: `Contact information: e-mail: pdpc@mdes.go.th Tel. 02 141 6993, 02 142 1033`,
          cn: `联系方式: e-mail : pdpc@mdes.go.th 电话: 02 141 6993, 02 142 1033`,
          th: `ช่องทางการติดต่อ:e-mail : pdpc@mdes.go.th โทร: 02 141 6993, 02 142 1033`,
        },
        sub178: {
          en: `16. Update of Privacy Policy`,
          cn: `16. 完善个人信息保护政策`,
          th: `16. การปรับปรุงนโยบายคุ้มครองข้อมูลส่วนบุคคล`,
        },
        sub179: {
          en: `The Company reserves the right to update, alter or revise this Privacy Policy at any time subject the legal requirements and will announce any change on the Company’s website at https://www.tiffany-show.co.th.`,
          cn: `公司保留未来根据法律规定更新、变更或修订个人信息保护政策的权利，有任何变更公司将通过公司网站https://www.tiffany-show.co.th公布告知。`,
          th: `บริษัทขอสงวนสิทธิ์ในการปรับปรุง เปลี่ยนแปลง หรือแก้ไขนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ได้ในอนาคต ภายใต้ข้อบังคับของกฎหมาย และการเปลี่ยนแปลงใด ๆ บริษัทจะประกาศให้ทราบผ่านเว็บไซต์ของบริษัทที่ https://www.tiffany-show.co.th`,
        },
        sub180: {
          en: `Effective from 1 August 2023 onwards.`,
          cn: `因此，该规定自2023年8月1日起生效。`,
          th: `ทั้งนี้ให้มีผลตั้งแต่วันที่ 1 สิงหาคม พ.ศ. 2566 เป็นต้นไป`,
        },
        sub181: {
          en: `Managing Director`,
          cn: `常务董事`,
          th: `กรรมการผู้จัดการ`,
        },
        sub182: {
          en: `Tiffany’s Show Pattaya Co., Ltd.`,
          cn: `蒂芙尼秀芭堤雅有限公司`,
          th: `บริษัท ทิฟฟานี่โชว์ พัทยา จำกัด`,
        },
      },
    },
  };

  const handlePressScrollToBottom = () => {
    const element = document.getElementById("end-page-privacy-policy");
    element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="privacy-policy">
      <div className="containter">
        <div className="title">
          <h1>{t(translate.title)}</h1>
        </div>
        <div className="section">
          <h3>{t(translate.sectionHeader.topic1)}</h3>
          <p className="textIndent">{t(translate.sectionHeader.topic2.sub1)}</p>
          <p className="textIndent">{t(translate.sectionHeader.topic2.sub2)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section1.topic1)}</h3>
          <table>
            <tr style={{ width: 250 }}>
              <th style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub1)}
              </th>
              <th style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub2)}
              </th>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub3)}
              </td>
              <td>{t(translate.section1.topic2.sub3_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub4)}
              </td>
              <td>{t(translate.section1.topic2.sub4_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub5)}
              </td>
              <td>{t(translate.section1.topic2.sub5_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub6)}
              </td>
              <td>{t(translate.section1.topic2.sub6_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub7)}
              </td>
              <td>{t(translate.section1.topic2.sub7_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub8)}
              </td>
              <td>{t(translate.section1.topic2.sub8_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub9)}
              </td>
              <td>{t(translate.section1.topic2.sub9_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub10)}
              </td>
              <td>{t(translate.section1.topic2.sub10_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub11)}
              </td>
              <td>{t(translate.section1.topic2.sub11_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub12)}
              </td>
              <td>{t(translate.section1.topic2.sub12_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub13)}
              </td>
              <td>{t(translate.section1.topic2.sub13_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub14)}
              </td>
              <td>{t(translate.section1.topic2.sub14_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub15)}
              </td>
              <td>{t(translate.section1.topic2.sub15_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub16)}
              </td>
              <td>{t(translate.section1.topic2.sub16_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub17)}
              </td>
              <td>{t(translate.section1.topic2.sub17_1)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub18)}
              </td>
              <td>{t(translate.section1.topic2.sub18_1)}</td>
            </tr>
            {currentLanguage !== "th" && (
              <React.Fragment>
                <tr>
                  <td style={{ textAlign: "center" }}>
                    {t(translate.section1.topic2.sub19)}
                  </td>
                  <td>{t(translate.section1.topic2.sub19_1)}</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>
                    {t(translate.section1.topic2.sub20)}
                  </td>
                  <td>{t(translate.section1.topic2.sub20_1)}</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>
                    {t(translate.section1.topic2.sub21)}
                  </td>
                  <td>{t(translate.section1.topic2.sub21_1)}</td>
                </tr>
              </React.Fragment>
            )}
          </table>
          <br />
          <p>{t(translate.section1.topic2.sub22)}</p>
        </div>
        <div className="section">
          <h3>{t(translate.section1.topic2.sub23)}</h3>
          <h4>{t(translate.section1.topic2.sub24)}</h4>
          <p>{t(translate.section1.topic2.sub25)}</p>
          <ol className="lower-latin" type="a">
            <li>{t(translate.section1.topic2.sub26)}</li>
            <li>{t(translate.section1.topic2.sub27)}</li>
            <li>{t(translate.section1.topic2.sub28)}</li>
            <li>{t(translate.section1.topic2.sub29)}</li>
          </ol>
          <h4>{t(translate.section1.topic2.sub30)}</h4>
          <p>{t(translate.section1.topic2.sub31)}</p>
          <h3>{t(translate.section1.topic2.sub32)}</h3>
          <p>{t(translate.section1.topic2.sub33)}</p>
          <h5>{t(translate.section1.topic2.sub34)}</h5>
          <p>{t(translate.section1.topic2.sub35)}</p>
          <ol className="decimal">
            <li>{t(translate.section1.topic2.sub36)}</li>
            <li>{t(translate.section1.topic2.sub37)}</li>
            <li>{t(translate.section1.topic2.sub38)}</li>
            <li>{t(translate.section1.topic2.sub39)}</li>
          </ol>
          <br />
          <h5>{t(translate.section1.topic2.sub40)}</h5>
          <p>{t(translate.section1.topic2.sub41)}</p>
          <ol className="decimal">
            <li>{t(translate.section1.topic2.sub42)}</li>
            <li>{t(translate.section1.topic2.sub43)}</li>
            <li>{t(translate.section1.topic2.sub44)}</li>
            <li>{t(translate.section1.topic2.sub45)}</li>
            <li>{t(translate.section1.topic2.sub46)}</li>
            <li>{t(translate.section1.topic2.sub47)}</li>
          </ol>
          <br />
          <p>{t(translate.section1.topic2.sub48)}</p>
          <p>{t(translate.section1.topic2.sub49)}</p>
          <h3>{t(translate.section1.topic2.sub50)}</h3>
          <p>{t(translate.section1.topic2.sub51)}</p>
          <ol className="decimal">
            <li>{t(translate.section1.topic2.sub52)}</li>
            <li>{t(translate.section1.topic2.sub53)}</li>
            <li>{t(translate.section1.topic2.sub54)}</li>
            <li>{t(translate.section1.topic2.sub55)}</li>
            <li>{t(translate.section1.topic2.sub56)}</li>
            <li>{t(translate.section1.topic2.sub57)}</li>
            <li>{t(translate.section1.topic2.sub58)}</li>
            <li>{t(translate.section1.topic2.sub59)}</li>
            <li>{t(translate.section1.topic2.sub60)}</li>
            <li>{t(translate.section1.topic2.sub61)}</li>
            <li>{t(translate.section1.topic2.sub62)}</li>
            <li>{t(translate.section1.topic2.sub63)}</li>
            <li>{t(translate.section1.topic2.sub64)}</li>
            <li>{t(translate.section1.topic2.sub65)}</li>
            <li>{t(translate.section1.topic2.sub66)}</li>
          </ol>
          {/* <br />
          <p>{t(translate.section1.topic2.sub62)}</p>
          <br /> */}
          {/* <ol>
            <li value="12">{t(translate.section1.topic2.sub63)}</li>
            <li>{t(translate.section1.topic2.sub64)}</li>
            <li>{t(translate.section1.topic2.sub65)}</li>
            <li>{t(translate.section1.topic2.sub66)}</li>
          </ol> */}
          {/* <br /> */}
          <br />
          <p>{t(translate.section1.topic2.sub67)}</p>
          {/* <br /> */}
          <p>{t(translate.section1.topic2.sub68)}</p>
          <ol className="decimal">
            <li>{t(translate.section1.topic2.sub69)}</li>
            <li>{t(translate.section1.topic2.sub70)}</li>
            <li>{t(translate.section1.topic2.sub71)}</li>
            <li>{t(translate.section1.topic2.sub72)}</li>
            <li>{t(translate.section1.topic2.sub73)}</li>
            <li>{t(translate.section1.topic2.sub74)}</li>
            <li>{t(translate.section1.topic2.sub75)}</li>
          </ol>
          <h3>{t(translate.section1.topic2.sub76)}</h3>
          <h5>{t(translate.section1.topic2.sub77)}</h5>
          <p>{t(translate.section1.topic2.sub78)}</p>
          <ol className="decimal">
            <li>{t(translate.section1.topic2.sub79)}</li>
            <li>{t(translate.section1.topic2.sub80)}</li>
            <li>{t(translate.section1.topic2.sub81)}</li>
            <li>{t(translate.section1.topic2.sub82)}</li>
            <li>{t(translate.section1.topic2.sub83)}</li>
            <li>{t(translate.section1.topic2.sub84)}</li>
          </ol>
          <br />
          <h5>{t(translate.section1.topic2.sub85)}</h5>
          <p>{t(translate.section1.topic2.sub86)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub87)}</p>
          <h3>{t(translate.section1.topic2.sub88)}</h3>
          <p>{t(translate.section1.topic2.sub89)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub90)}</p>
          <h3>{t(translate.section1.topic2.sub91)}</h3>
          <p>{t(translate.section1.topic2.sub92)}</p>
          <h3>{t(translate.section1.topic2.sub93)}</h3>
          <p>{t(translate.section1.topic2.sub94)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub95)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub96)}</p>
          <h3>{t(translate.section1.topic2.sub97)}</h3>
          <p>{t(translate.section1.topic2.sub98)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub99)}</h5>
          <p>{t(translate.section1.topic2.sub100)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub101)}</h5>
          <p>{t(translate.section1.topic2.sub102)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub103)}</h5>
          <p>{t(translate.section1.topic2.sub104)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub105)}</h5>
          <p>{t(translate.section1.topic2.sub106)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub107)}</h5>
          <p>{t(translate.section1.topic2.sub108)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub109)}</h5>
          <p>{t(translate.section1.topic2.sub110)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub111)}</h5>
          <p>{t(translate.section1.topic2.sub112)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub113)}</h5>
          <p>{t(translate.section1.topic2.sub114)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub115)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub116)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub117)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub118)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub119)}</h5>
          <p>{t(translate.section1.topic2.sub120)}</p>
          <p>{t(translate.section1.topic2.sub121)}</p>
          <p>{t(translate.section1.topic2.sub122)}</p>
          <table>
            <tr style={{ width: "100%" }}>
              <th style={{ textAlign: "center", width: "50%" }}>
                {t(translate.section1.topic2.sub123)}
              </th>
              <th style={{ textAlign: "center", width: "50%" }}>
                {t(translate.section1.topic2.sub123_1)}
              </th>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub124)}
              </td>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub124_1)}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub125)}
              </td>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub125_1)}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub126)}
              </td>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub126_1)}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub127)}
              </td>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub127_1)}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub128)}
              </td>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub128_1)}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub129)}
              </td>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub129_1)}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub130)}
              </td>
              <td style={{ textAlign: "center" }}>
                {t(translate.section1.topic2.sub130_1)}
              </td>
            </tr>
          </table>
          <br />
          <p>{t(translate.section1.topic2.sub131)}</p>
          <h3>{t(translate.section1.topic2.sub132)}</h3>
          <p>{t(translate.section1.topic2.sub133)}</p>
          <h3>{t(translate.section1.topic2.sub134)}</h3>
          <p>{t(translate.section1.topic2.sub135)}</p>
          <p>{t(translate.section1.topic2.sub136)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub137)}</h5>
          <p>{t(translate.section1.topic2.sub138)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub139)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub140)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub141)}</h5>
          <p>{t(translate.section1.topic2.sub142)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub143)}</h5>
          <p>{t(translate.section1.topic2.sub144)}</p>
          <ul className="disc">
            <li>{t(translate.section1.topic2.sub145)}</li>
            <li>{t(translate.section1.topic2.sub146)}</li>
            <li>{t(translate.section1.topic2.sub147)}</li>
            <li>{t(translate.section1.topic2.sub148)}</li>
            <li>{t(translate.section1.topic2.sub149)}</li>
          </ul>
          <p>{t(translate.section1.topic2.sub150)}</p>
          <br />
          <h5>{t(translate.section1.topic2.sub151)}</h5>
          <p>{t(translate.section1.topic2.sub152)}</p>
          <p>{t(translate.section1.topic2.sub153)}</p>
          <p>{t(translate.section1.topic2.sub154)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub155)}</p>
          <p>{t(translate.section1.topic2.sub156)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub157)}</p>
          <p>{t(translate.section1.topic2.sub158)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub159)}</p>
          <p>{t(translate.section1.topic2.sub160)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub161)}</p>
          <h3>{t(translate.section1.topic2.sub162)}</h3>
          <p>{t(translate.section1.topic2.sub163)}</p>
          <h3>{t(translate.section1.topic2.sub164)}</h3>
          <p>{t(translate.section1.topic2.sub165)}</p>
          <h3>{t(translate.section1.topic2.sub166)}</h3>
          <p>{t(translate.section1.topic2.sub167)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub168)}</p>
          <p>{t(translate.section1.topic2.sub169)}</p>
          <p>{t(translate.section1.topic2.sub170)}</p>
          <p>{t(translate.section1.topic2.sub171)}</p>
          <p>{t(translate.section1.topic2.sub172)}</p>
          <h3>{t(translate.section1.topic2.sub173)}</h3>
          <p>{t(translate.section1.topic2.sub174)}</p>
          <br />
          <p id="end-page-privacy-policy">
            {t(translate.section1.topic2.sub175)}
          </p>
          <br />
          <p>{t(translate.section1.topic2.sub176)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub177)}</p>
          <h3>{t(translate.section1.topic2.sub178)}</h3>
          <p>{t(translate.section1.topic2.sub179)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub180)}</p>
          <br />
          <p>{t(translate.section1.topic2.sub181)}</p>
          <p>{t(translate.section1.topic2.sub182)}</p>
        </div>
      </div>
      <ScrollToBottom onClick={handlePressScrollToBottom} />
    </div>
  );
};

export { TermsOfUse, PrivacyPolicy };



// WEBPACK FOOTER //
// ./src/components/PDPA.js